import * as React from 'react'

function SvgSv(props) {
	return (
		<svg data-name="Layer 1" viewBox="0 0 1005 567" width="1em" height="1em" {...props}>
			<path d="M0 0h1005v567H0z" fill="#fff" fillRule="evenodd" />
			<path d="M0 378h1005v189H0zM0 0h1005v189H0z" fill="#0047ab" fillRule="evenodd" />
			<path
				d="M463.041 354.917l-.035.035.8 5.406a2.833 2.833 0 00-3.418 1.5c-1 2.032-.148 3.565 1.813 4.57l2.617 1.29 4.812-9.417-1.917-1.012-1.884 3.837h-.069l-.419-5.058-2.3-1.15zm.453 7.22a2.492 2.492 0 011.29.28l.28.139-1.36 2.581-.279-.14c-.873-.5-1.444-1.027-.942-2.092a1.356 1.356 0 011.011-.768zm-8.872-2.3l1.286-1.875-2.9-1.943 1-1.434 2.811 1.875 1.592-2.376-2.965-1.943 1-1.5 4.773 3.18-5.928 8.852-4.71-3.18 1-1.44 2.964 1.874m-1.91-12.444v.035l-2.617 2.965-.766-.628c-1.723-1.524-3.41-1.449-4.849.21-1.592 1.874-1.007 3.48.8 4.987l2.163 1.883 6.871-8.056zM447 350.974a1.782 1.782 0 011.464.594l.314.279-1.883 2.163-.35-.176c-.763-.652-1.168-1.328-.383-2.266a1.6 1.6 0 01.838-.594zm-7.4-.921l-1.438-1.59 4.425-3.99c.937-.871 2.245-2.244 1-3.556-1.222-1.373-2.682-.195-3.684.637l-4.34 3.99-1.438-1.6 4.71-4.27c1.874-1.724 4.12-2.159 6.082 0 2.026 2.16 1.286 4.336-.633 6.083l-4.622 4.27m-4.146-20.019a2.467 2.467 0 00-.454.035 3.267 3.267 0 00-1.29.523 2.437 2.437 0 00-1.047 3.035 2.36 2.36 0 00-2.267.454c-1.722 1.155-1.643 2.606-.488 4.325l1.5 2.163 8.685-6-1.884-2.72a3.585 3.585 0 00-2.755-1.815zm.14 2.268c.642-.053 1.109.445 1.534 1.081l.28.35v.068l-2.269 1.5-.174-.28c-.48-.808-1.071-1.76-.069-2.475a1.468 1.468 0 01.7-.244zm-3.105 3.069a1.389 1.389 0 011.046.732l.105.21-2.023 1.43-.174-.175c-.436-.652-.571-1.314.28-1.883a1.282 1.282 0 01.766-.313zm-.148-9.818l-1.438-2.684 1.5-.848 2.535 4.558-9.352 5.056-1.068-1.87 7.826-4.208m-1.591-7.545l.785 2.026-9.7 4.275-.85-2.026 9.79-4.275m-10.988-7.322a3.4 3.4 0 00-.349 2.68 3.512 3.512 0 004.556 1.874 3.264 3.264 0 00.5-6.15l2.31-.714a5.348 5.348 0 011.438 2.154 5.6 5.6 0 01-10.659 3.427 5.814 5.814 0 01-.2-2.534l2.377-.721m5.087-14.222l-9.94 6 .314 1.674 11.44 2.3-.419-2.232-2.3-.523h-.07l-.7-3.767 2.093-1.221zm-3.14 4.395l.42 2.511-3.977-.487zm-2.964-24.206a5.038 5.038 0 00-4.639 4.848L414 284.53l10.463.871.28-3.034a5.124 5.124 0 00-4.813-5.72 6.129 6.129 0 00-1.117 0zm.176 2.372a4.816 4.816 0 01.731 0c1.9.152 3.091 1.18 2.895 3.557v.35l-6.348-.524.07-.349c.133-1.907 1.026-2.9 2.65-3.034zm-1.513-8.272l2.245.414.72-3.335 1.721.348-.633 3.336 2.814.632.719-3.466 1.743.283-1.155 5.647-10.345-2.159 1.068-5.58 1.81.348-.72 3.467m4.077-13.933l2.18.854 1.221-3.188 1.656.638-1.22 3.18 2.681 1 1.286-3.247 1.656.63-2.091 5.274-9.941-3.834 2.18-5.273 1.657.563-1.286 3.337m10.115-5.385l1.371-2.681 1.656.787-2.376 4.62-9.482-4.837 1-1.875 7.827 3.99m2.964-16.614a1.854 1.854 0 00-1.656.787 1.38 1.38 0 00.065 1.808c1.439 1 3.466-2.964 6.365-.781a3.455 3.455 0 01.72 5.055 4.022 4.022 0 01-3.685 1.5l-.195-1.936a2.144 2.144 0 002.376-.637 1.388 1.388 0 00-.349-2.026c-.85-.63-1.722 0-2.53.5-1.22.787-2.462 1.223-3.77.2a3.074 3.074 0 01-.633-4.425 4.542 4.542 0 012.747-1.719l.566 1.651m4.713-9.361l-1.15 1.22 4.847 10.676 1.57-1.64-1.012-2.162.035-.07 2.685-2.721 2.163.907 1.57-1.64zm1.64 3.068h.07v.036l3.313 1.5-1.64 1.744zm11.262-2.468l2.377-1.876 1.068 1.352-4.056 3.27-6.67-8.26 1.723-1.374 5.494 6.888m6.735-6.825l.065-.062-1.809-7.327 2.027-1.217L461.336 222l-1.067.63-9.418-6.953 1.962-1.223 6.082 4.622m7.773-12.54l-1.5.732.559 11.65 2.022-.942-.069-2.372h.035L471.2 214l1.64 1.64 2.162-.838zm.419 3.487l2.581 2.652-2.162.94zm10.882-7.115a6.53 6.53 0 00-1.15.243l-2.9.769 2.964 10.219 2.93-.837a5.193 5.193 0 003.663-6.592 5.053 5.053 0 00-5.512-3.8zm.523 2.162a2.708 2.708 0 012.582 2.338c.588 1.83.01 3.38-2.3 4.01l-.28.105-1.814-6.14.35-.138a4.763 4.763 0 011.464-.175zm12.767-5.3c-.2 0-.39.01-.594.035A5.6 5.6 0 00492.2 210.9a5.6 5.6 0 00-.942-11.127zm-.244 2.372a3.164 3.164 0 013.348 2.755c.13 1.434-.886 3.378-2.477 3.663-1.666.215-3.169-1.428-3.383-2.86a3.13 3.13 0 012.511-3.558zm9.138-2.86l-.14 10.673h2.163v-4.291h.07l2.616 4.29 2.581.069v-.034l-3.035-4.569a2.771 2.771 0 002.268-2.9c.065-2.249-1.448-3.182-3.628-3.244zm2.092 1.883h.28c1.025 0 1.814.243 1.814 1.465 0 1.155-.78 1.43-1.85 1.43h-.209l-.035.035zm20.415 2.391l-.567 2.25 3.333.781-.413 1.808-3.334-.847-.633 2.745 3.4.937-.419 1.724-5.49-1.44 2.528-10.29 5.58 1.373-.435 1.814-3.466-.855m7.98 0l1.435.57 2.617 9.069h.068l2.678-6.586 1.964.787L535.5 217.4l-1.44-.569-2.679-9.07-2.661 6.737-2.026-.781 4.058-10.14m14.186 16.893l2.533 1.595-.937 1.5-4.426-2.68 5.642-9.068 1.814 1.156-4.627 7.456m12.873-2l-10.22 5.825 1.71 1.36 2.093-1.15.034.034 2.965 2.442-.732 2.232 1.813 1.43 3.627-11.092zm-1.64 3.14l-1.22 3.453-1.779-1.43zm17.616 13.5l-11.372 2.965 1.291 1.814 2.372-.593h.035l2.232 3.138-1.29 2.024 1.29 1.813 6.384-9.8zm-2.372 2.616l-2.093 3.035-1.36-1.884zm7.555 14.642l-7.172.715-.284-.63 4.839-5.146v-.061l-6.3 2.092-1-1.941 10.57-3.25.72 1.374-4.99 5.58 7.39-.786.72 1.373-9.07 6.368-.937-1.943 5.492-3.683m5.19 6.976l-2.183.787 1.072 3.18-1.725.569-1.065-3.186-2.684.855 1.133 3.4-1.72.565-1.808-5.428 10.007-3.4 1.87 5.424-1.72.57-1.155-3.4m4 6.844l-10.36 2.163.42 2.162 4.115-.942h.07l-3.628 3.558.488 2.511.07.035 3.768-3.907a2.759 2.759 0 003.313 1.5c2.243-.435 2.84-2.1 2.337-4.255zm-1.36 2.582v.173c.224 1.025.21 1.9-1.012 2.093-1.178.218-1.619-.432-1.813-1.5v-.21zm-7.084 11.15l-.194-2.092 10.507-1.221.28 2.092-10.57 1.222m8.236 10.311a3.1 3.1 0 001.072-2.464 3.626 3.626 0 10-6.083 2.53l-2.461.065a6.616 6.616 0 01-.637-2.529 5.436 5.436 0 015.43-5.494 5.5 5.5 0 015.71 5.363 4.828 4.828 0 01-.564 2.463l-2.467.066m-7.838 1.976l-.208 2.233 2.057 1.15-.487 3.837-2.3.489-.278 2.337 11.3-2.826.21-1.639zm3.559 4.36l3.348 1.5v.1l-3.628.766zm-3.193 26.1a3.129 3.129 0 001.936-1.808 3.443 3.443 0 00-2.16-4.426 3.527 3.527 0 00-4.553 1.658 3.828 3.828 0 00.195 2.746l-2.31-.848a6.433 6.433 0 01.285-2.6 5.371 5.371 0 017.1-2.963 5.485 5.485 0 013.338 7.1 6.1 6.1 0 01-1.5 2.094l-2.317-.939m-1.764 5.71l-2.026-1.067-1.656 2.964-1.507-.782 1.573-3.03-2.528-1.373-1.724 3.182-1.507-.849 2.684-5.061 9.353 5.061-2.684 4.99-1.59-.849 1.657-3.12m-2.07 7.763l-.855 1.223-9.414.278-.067.068 5.8 4.208-1.283 1.724-8.7-6.368.854-1.222 9.414-.346h.069l-5.867-4.275 1.284-1.724 8.768 6.457m-18.947 6.016l1.506-1.59 6.363 6.143 1.507-1.657 1.283 1.223-4.554 4.776-1.288-1.212 1.5-1.591-6.368-6.083m-3.1 3.131l-1.675 1.29 2.76 3.353v.07l-4.85-1.605-1.953 1.64.035.07 5.2 1.43a2.762 2.762 0 00.209 3.7c1.373 1.719 3.19 1.408 4.847.035l2.163-1.848-6.731-8.128zm2.058 5.929l1.883 2.268-.21.1c-.808.7-1.52 1.007-2.3.07-.72-.87-.36-1.582.488-2.3zm-8.615-.42l-1.954 1.187.42 2.372h-.036l-3.244 2.023-1.884-1.43-1.953 1.22 9.383 7.011 1.36-.837-2.092-11.544zm-1.257 5.582l.943 3.487h-.07l-2.895-2.267zm-10.45 3.173l-2.813 1.222-.721-1.59 4.71-2.249 4.56 9.637-1.964.848-3.773-7.89m50.076-101.154l2.125 2.785h1.687l-1.466-2.785zm-154.113 88.7l3.477-.429 1.18 1.2-3.016.9z"
				fill="#fc0"
			/>
			<path
				d="M484.357 359.842s3.772-.285 4.425-.285c.567 0 1.876-2.6 2.443-3.03.566-.413 10.572-5.274 17.047-6.3 6.366-1 16.4-4.839 18.488-5.86 10.726-5.145 22.691-14.716 25.376-18.64 2.745-4.118 5.708-13.628 7.014-18.79.57-2.378 3.84-12.035 3.84-18.64a83.241 83.241 0 00-2.093-18.922c-1.155-4.993-9.7-19.64-14.933-26.12 0 0 11.752 18.205 13.778 25.247a77.632 77.632 0 012.46 20.884c-.128 4.12-3.487 19.142-8.476 30.17-3.968 8.85-7.456 9.855-13.629 14.782a90.148 90.148 0 01-13.187 8.417 91.74 91.74 0 01-17.33 5.642c-2.681.5-16.023 4.425-17.767 5.28a44.751 44.751 0 00-7.456 6.144"
				fill="#090"
			/>
			<path
				d="M484.357 359.842s3.772-.285 4.425-.285c.567 0 1.876-2.6 2.443-3.03.566-.413 10.572-5.274 17.047-6.3 6.366-1 16.4-4.839 18.488-5.86 10.726-5.145 22.691-14.716 25.376-18.64 2.745-4.118 5.708-13.628 7.014-18.79.57-2.378 3.84-12.035 3.84-18.64a83.241 83.241 0 00-2.093-18.922c-1.155-4.993-9.7-19.64-14.933-26.12 0 0 11.752 18.205 13.778 25.247a77.632 77.632 0 012.46 20.884c-.128 4.12-3.487 19.142-8.476 30.17-3.968 8.85-7.456 9.855-13.629 14.782a90.148 90.148 0 01-13.187 8.417 91.74 91.74 0 01-17.33 5.642c-2.681.5-16.023 4.425-17.767 5.28a44.751 44.751 0 00-7.456 6.144z"
				fill="none"
				stroke="#000"
				strokeWidth={0.347}
			/>
			<path
				d="M551.326 325.81c-.284-1.373-.413-2.371-.937-2.746-.347-.5-1.875-2.243-2.16-3.4a8.417 8.417 0 010-2.684 25.18 25.18 0 00-.413-2.59 10.612 10.612 0 011.29-2.969 11.891 11.891 0 002.31-3.03 3.831 3.831 0 00.279 1.725 5.6 5.6 0 01.636 2.962 17.848 17.848 0 000 3.9 6.871 6.871 0 01.435 3.4c-.195 1.065-1.44 5.425-1.44 5.425"
				fill="#090"
			/>
			<path
				d="M551.326 325.81c-.284-1.373-.413-2.371-.937-2.746-.347-.5-1.875-2.243-2.16-3.4a8.417 8.417 0 010-2.684 25.18 25.18 0 00-.413-2.59 10.612 10.612 0 011.29-2.969 11.891 11.891 0 002.31-3.03 3.831 3.831 0 00.279 1.725 5.6 5.6 0 01.636 2.962 17.848 17.848 0 000 3.9 6.871 6.871 0 01.435 3.4c-.195 1.065-1.44 5.425-1.44 5.425"
				fill="none"
				stroke="#000"
				strokeWidth={0.347}
			/>
			<path
				d="M551.7 324.377s3.4-4.276 3.4-6.084a6.569 6.569 0 01.563-3.186 4.529 4.529 0 00.5-5.426 7.141 7.141 0 01-1.374-2.31c-.563-1.59-1.718-1.59-1.874-3.184a34.009 34.009 0 00-.564 3.468 8.627 8.627 0 00.28 3.026c.133.937-.413 1.941-.413 3.254 0 1.283.133 1.808.133 2.589 0 .419.564 6.016-.636 7.83"
				fill="#090"
			/>
			<path
				d="M551.7 324.377s3.4-4.276 3.4-6.084a6.569 6.569 0 01.563-3.186 4.529 4.529 0 00.5-5.426 7.141 7.141 0 01-1.374-2.31c-.563-1.59-1.718-1.59-1.874-3.184a34.009 34.009 0 00-.564 3.468 8.627 8.627 0 00.28 3.026c.133.937-.413 1.941-.413 3.254 0 1.283.133 1.808.133 2.589 0 .419.564 6.016-.636 7.83z"
				fill="none"
				stroke="#000"
				strokeWidth={0.347}
			/>
			<path
				d="M514.092 347.285s2.812-.284 3.9-.5a20.218 20.218 0 003.466-.847 11.148 11.148 0 003.9-2.685c2.679-2.9 2.371-4.426 2.9-4.554 1-.128-1.5-.413-2.679-.2a7.48 7.48 0 00-3.838 1.942 39.092 39.092 0 01-3.335 2.59 6.824 6.824 0 00-1.657 1.44 7.667 7.667 0 01-2.681 2.812"
				fill="#090"
			/>
			<path
				d="M514.092 347.285s2.812-.284 3.9-.5a20.218 20.218 0 003.466-.847 11.148 11.148 0 003.9-2.685c2.679-2.9 2.371-4.426 2.9-4.554 1-.128-1.5-.413-2.679-.2a7.48 7.48 0 00-3.838 1.942 39.092 39.092 0 01-3.335 2.59 6.824 6.824 0 00-1.657 1.44 7.667 7.667 0 01-2.681 2.812z"
				fill="none"
				stroke="#000"
				strokeWidth={0.347}
			/>
			<path
				d="M510.255 349.333s7.107-3.18 7.76-3.772a17 17 0 002.685-2.461c.784-.786 3.768-2.31 4.27-3.336.351-.632 2.16-3.182 3.248-5.207.57-1.072-4.705.284-4.705.284-4.34 1.719-2.312.5-4.71 2.31a8.641 8.641 0 00-2.747 2.813c-.567 1.217-1.22 3.465-1.874 4.553a18.542 18.542 0 01-3.9 4.773"
				fill="#090"
			/>
			<path
				d="M510.255 349.333s7.107-3.18 7.76-3.772a17 17 0 002.685-2.461c.784-.786 3.768-2.31 4.27-3.336.351-.632 2.16-3.182 3.248-5.207.57-1.072-4.705.284-4.705.284-4.34 1.719-2.312.5-4.71 2.31a8.641 8.641 0 00-2.747 2.813c-.567 1.217-1.22 3.465-1.874 4.553a18.542 18.542 0 01-3.9 4.773z"
				fill="none"
				stroke="#000"
				strokeWidth={0.347}
			/>
			<path
				d="M506.419 350.21s5.776-1.508 8.48-5.146c1.875-2.467 1.94-1.724 2.747-2.528a27.944 27.944 0 003.77-4.342c-.13.195 1.593-5.8 1.593-6.452-.067-.413-2.246.285-4.056 1-1.5.652-2.376 1.875-3.683 2.679-1.592 1-1.723 3.555-2.464 4.71a6.307 6.307 0 00-1.155 3.466c0 1.284-.72 1.724-1.156 2.812-.5 1.284-2.028 1.066-4.055 3.773"
				fill="#090"
			/>
			<path
				d="M506.419 350.21s5.776-1.508 8.48-5.146c1.875-2.467 1.94-1.724 2.747-2.528a27.944 27.944 0 003.77-4.342c-.13.195 1.593-5.8 1.593-6.452-.067-.413-2.246.285-4.056 1-1.5.652-2.376 1.875-3.683 2.679-1.592 1-1.723 3.555-2.464 4.71a6.307 6.307 0 00-1.155 3.466c0 1.284-.72 1.724-1.156 2.812-.5 1.284-2.028 1.066-4.055 3.773z"
				fill="none"
				stroke="#000"
				strokeWidth={0.347}
			/>
			<path
				d="M515.77 348.312s4.993-2.25 5.712-2.4c.719-.128 1-.57 2.03-.848a5.765 5.765 0 013.682-.419c.849.2 4.488 1 5.426.57.853-.413-1.306 2.46-2.395 3.12a8.063 8.063 0 01-4.208.713c-1.506-.127-3.554 0-4.273 0a6.866 6.866 0 01-2.245-.127 6.392 6.392 0 00-3.772-.57"
				fill="#090"
			/>
			<path
				d="M515.77 348.312s4.993-2.25 5.712-2.4c.719-.128 1-.57 2.03-.848a5.765 5.765 0 013.682-.419c.849.2 4.488 1 5.426.57.853-.413-1.306 2.46-2.395 3.12a8.063 8.063 0 01-4.208.713c-1.506-.127-3.554 0-4.273 0a6.866 6.866 0 01-2.245-.127 6.392 6.392 0 00-3.772-.57z"
				fill="none"
				stroke="#000"
				strokeWidth={0.347}
			/>
			<path
				d="M512.37 348.312s5.58-1.44 6.518-1.44a34.052 34.052 0 014.624.413c1.066.133 4.4-.2 5.424.284a18.493 18.493 0 006.586.782c1.155-.195-2.311 3.186-3.773 3.555-4.492 1.29-3.114 1.072-6.016.351-1.808-.419-4.338-.569-5.21-.72-.872-.133-.72-.63-1.875-1.155a17.727 17.727 0 00-6.3-2.093"
				fill="#090"
			/>
			<path
				d="M512.37 348.312s5.58-1.44 6.518-1.44a34.052 34.052 0 014.624.413c1.066.133 4.4-.2 5.424.284a18.493 18.493 0 006.586.782c1.155-.195-2.311 3.186-3.773 3.555-4.492 1.29-3.114 1.072-6.016.351-1.808-.419-4.338-.569-5.21-.72-.872-.133-.72-.63-1.875-1.155a17.727 17.727 0 00-6.3-2.093z"
				fill="none"
				stroke="#000"
				strokeWidth={0.347}
			/>
			<path
				d="M507.792 350.645s5.581-2.31 9.919-1.155a26.341 26.341 0 004.12.937c1.352.194 2.529-.5 4.84.435 1.155.413 6.016 2.372 7.327 2.31 1.217-.066-3.84 3.249-5.212 3.03-4.493-.636-8.764.849-10.791.063-1.876-.715-2.966-1.218-3.9-1.5-.937-.352-1.439-1.223-2-1.591-.567-.5-.938-1.591-4.273-2.528"
				fill="#090"
			/>
			<path
				d="M507.792 350.645s5.581-2.31 9.919-1.155a26.341 26.341 0 004.12.937c1.352.194 2.529-.5 4.84.435 1.155.413 6.016 2.372 7.327 2.31 1.217-.066-3.84 3.249-5.212 3.03-4.493-.636-8.764.849-10.791.063-1.876-.715-2.966-1.218-3.9-1.5-.937-.352-1.439-1.223-2-1.591-.567-.5-.938-1.591-4.273-2.528z"
				fill="none"
				stroke="#000"
				strokeWidth={0.347}
			/>
			<path
				d="M537.614 337.781s3.249-3.556 3.834-3.99c.637-.5 2.16-1.59 2.97-2.31a5.99 5.99 0 013.331-2.378c.937-.195 3.12-.631 3.69-1.373.63-.782-.069 2.813-.788 3.773a7.52 7.52 0 01-3.466 2.528c-1.372.5-3.185 1.507-3.839 1.808a5.4 5.4 0 01-2.026.787 7.268 7.268 0 00-3.683 1.155"
				fill="#090"
			/>
			<path
				d="M537.614 337.781s3.249-3.556 3.834-3.99c.637-.5 2.16-1.59 2.97-2.31a5.99 5.99 0 013.331-2.378c.937-.195 3.12-.631 3.69-1.373.63-.782-.069 2.813-.788 3.773a7.52 7.52 0 01-3.466 2.528c-1.372.5-3.185 1.507-3.839 1.808a5.4 5.4 0 01-2.026.787 7.268 7.268 0 00-3.683 1.155z"
				fill="none"
				stroke="#000"
				strokeWidth={0.347}
			/>
			<path
				d="M534.584 339.242s5.492-3.838 6.3-4.207c.848-.413 2.4-.937 3.4-1.289 1.072-.28 3.84-2.243 4.928-2.243 1.072 0 3.181-.129 4.12-.787.853-.782.065 2.595-.939 3.621-3.549 3.115-1.066 2.154-4.051 2.747-1.725.345-4.12 1.372-4.928 1.59-.938.285-1-.285-2.243-.195a19.973 19.973 0 00-6.586.787"
				fill="#090"
			/>
			<path
				d="M534.584 339.242s5.492-3.838 6.3-4.207c.848-.413 2.4-.937 3.4-1.289 1.072-.28 3.84-2.243 4.928-2.243 1.072 0 3.181-.129 4.12-.787.853-.782.065 2.595-.939 3.621-3.549 3.115-1.066 2.154-4.051 2.747-1.725.345-4.12 1.372-4.928 1.59-.938.285-1-.285-2.243-.195a19.973 19.973 0 00-6.586.787z"
				fill="none"
				stroke="#000"
				strokeWidth={0.347}
			/>
			<path
				d="M533.256 340.265a18.849 18.849 0 016.669-2.155 27.17 27.17 0 004.057-1 12.306 12.306 0 014.119-.5c1.222-.128 6.083 1.44 7.238.787 1-.57-1.223 1.434-2.528 1.937-1.942.72-1.724 1.942-3.84 2.684-2.22.72-4.553 1.59-5.926 1.284-.938-.129-1.814-.63-3.187-.781-1.373-.135-3.834-2.16-6.58-2.25"
				fill="#090"
			/>
			<path
				d="M533.256 340.265a18.849 18.849 0 016.669-2.155 27.17 27.17 0 004.057-1 12.306 12.306 0 014.119-.5c1.222-.128 6.083 1.44 7.238.787 1-.57-1.223 1.434-2.528 1.937-1.942.72-1.724 1.942-3.84 2.684-2.22.72-4.553 1.59-5.926 1.284-.938-.129-1.814-.63-3.187-.781-1.373-.135-3.834-2.16-6.58-2.25z"
				fill="none"
				stroke="#000"
				strokeWidth={0.347}
			/>
			<path
				d="M532.82 339.176s-1.071-5.363-.133-6.585a6.2 6.2 0 001.155-2.813 11.074 11.074 0 011.59-4.208c.57-.714 1.814-4.119 1.44-4.989 0 0 3.12 3.03 2.964 4.989a6.32 6.32 0 000 2.317 11.919 11.919 0 01-1.284 4.7c-.63.853-.284 3.553-.938 4.056-.569.63-4.056 2.964-4.776 2.528"
				fill="#090"
			/>
			<path
				d="M532.82 339.176s-1.071-5.363-.133-6.585a6.2 6.2 0 001.155-2.813 11.074 11.074 0 011.59-4.208c.57-.714 1.814-4.119 1.44-4.989 0 0 3.12 3.03 2.964 4.989a6.32 6.32 0 000 2.317 11.919 11.919 0 01-1.284 4.7c-.63.853-.284 3.553-.938 4.056-.569.63-4.056 2.964-4.776 2.528z"
				fill="none"
				stroke="#000"
				strokeWidth={0.347}
			/>
			<path
				d="M533.256 340.265a15.3 15.3 0 012.9-2.094c1.071-.412 5.144-1.59 5.43-2.594.284-1.066 3.682-4.555 3.833-5.492a15.376 15.376 0 00.57-2.746 18.318 18.318 0 00-.848-3.465c-.42-1.072-1.507-3.556-2.534-3.99 0 0-.848 2.745-1.156 3.772a9.421 9.421 0 01-1 2.813 19.859 19.859 0 00-2.094 4.426 41.535 41.535 0 01-1 5.078c-.068.72-2.813 3.772-4.052 4.336"
				fill="#090"
			/>
			<path
				d="M533.256 340.265a15.3 15.3 0 012.9-2.094c1.071-.412 5.144-1.59 5.43-2.594.284-1.066 3.682-4.555 3.833-5.492a15.376 15.376 0 00.57-2.746 18.318 18.318 0 00-.848-3.465c-.42-1.072-1.507-3.556-2.534-3.99 0 0-.848 2.745-1.156 3.772a9.421 9.421 0 01-1 2.813 19.859 19.859 0 00-2.094 4.426 41.535 41.535 0 01-1 5.078c-.068.72-2.813 3.772-4.052 4.336z"
				fill="none"
				stroke="#000"
				strokeWidth={0.347}
			/>
			<path
				d="M551.326 325.81c-.194.787 2.16-.714 3.338-.714 1.217 0 4.705.413 5.58-.42.848-.847 2.155-2.526 2.6-2.812a13.1 13.1 0 002.528-4.335c.435-1.5 3.549-4.12 3.9-4.426 0 0-4.208-.848-6.892.847a8.529 8.529 0 01-3.331 1.6c-.57.278-5.146 4.118-5.43 5.58-.285 1.434-2.244 3.984-2.311 4.705"
				fill="#090"
			/>
			<path
				d="M551.326 325.81c-.194.787 2.16-.714 3.338-.714 1.217 0 4.705.413 5.58-.42.848-.847 2.155-2.526 2.6-2.812a13.1 13.1 0 002.528-4.335c.435-1.5 3.549-4.12 3.9-4.426 0 0-4.208-.848-6.892.847a8.529 8.529 0 01-3.331 1.6c-.57.278-5.146 4.118-5.43 5.58-.285 1.434-2.244 3.984-2.311 4.705z"
				fill="none"
				stroke="#000"
				strokeWidth={0.347}
			/>
			<path
				d="M551.326 325.81s3.773-2.678 4.622-2.528c.937.134 5.056-2.9 5.273-4.772.134-1 2.093-2.466 2.534-3.119 1-1.74 1.59-5.709 3.03-6.736 0 0-3.99 1-4.994 1.155-1.875.284-3.466.57-4.276 2.25-.63 1.59-1.283 2.9-1.875 3.029-.563.129-1.434 2.155-1.718 4.27-.285 2.026-2.6 6.452-2.6 6.452"
				fill="#090"
			/>
			<path
				d="M551.326 325.81s3.773-2.678 4.622-2.528c.937.134 5.056-2.9 5.273-4.772.134-1 2.093-2.466 2.534-3.119 1-1.72 1.59-5.709 3.03-6.736 0 0-3.99 1-4.994 1.155-1.875.284-3.466.57-4.276 2.25-.63 1.59-1.283 2.9-1.875 3.029-.563.129-1.434 2.155-1.74 4.27-.285 2.026-2.6 6.452-2.6 6.452z"
				fill="none"
				stroke="#000"
				strokeWidth={0.347}
			/>
			<path
				d="M558.52 305.8c-.63 1.006-.57-5.86-.938-6.514a10.334 10.334 0 00-1.59-2.812c-.57-.567-.57-2.594-.848-3.184a15.492 15.492 0 01.279-5.58 14.381 14.381 0 011.814 1.591c.563.72 1.59 1 1.875 1.875.278.85.87.85 1.283 1.81a5.593 5.593 0 01.57 3.466 8.585 8.585 0 00-.135 2.681 22.989 22.989 0 01-2.31 6.667"
				fill="#090"
			/>
			<path
				d="M558.52 305.8c-.63 1.006-.57-5.86-.938-6.514a10.334 10.334 0 00-1.59-2.812c-.57-.567-.57-2.594-.848-3.184a15.492 15.492 0 01.279-5.58 14.381 14.381 0 011.814 1.591c.563.72 1.59 1 1.875 1.875.278.85.87.85 1.283 1.81a5.593 5.593 0 01.57 3.466 8.585 8.585 0 00-.135 2.681 22.989 22.989 0 01-2.31 6.667"
				fill="none"
				stroke="#000"
				strokeWidth={0.347}
			/>
			<path
				d="M558.369 306.456s.285-1.941-.418-2.683c-.714-.719-1.434-.719-1.719-1.155-.284-.414-.195-1-.5-1.591a10.725 10.725 0 01-1-2.092c-.28-1.592-1.155-3.337-.413-5.058a8.785 8.785 0 012.026.85 4.711 4.711 0 011.942 2.593 4.1 4.1 0 00.72 2.246c.413.72 1 2.9.284 4.207a8.235 8.235 0 00-.853 2.683"
				fill="#090"
			/>
			<path
				d="M558.369 306.456s.285-1.941-.418-2.683c-.714-.719-1.434-.719-1.719-1.155-.284-.414-.195-1-.5-1.591a10.725 10.725 0 01-1-2.092c-.28-1.592-1.155-3.337-.413-5.058a8.785 8.785 0 012.026.85 4.711 4.711 0 011.942 2.593 4.1 4.1 0 00.72 2.246c.413.72 1 2.9.284 4.207a8.235 8.235 0 00-.853 2.683z"
				fill="none"
				stroke="#000"
				strokeWidth={0.347}
			/>
			<path
				d="M562.577 283.958s.28-4.274-.786-5.581c-1.223-1.286-1.507-3.771-4.209-5.145a5.115 5.115 0 010 1.81c-.067.632-.345 2.746 0 3.465.5.72 1.943 2.028 1.943 2.682a3.83 3.83 0 001.718 2.31 10.3 10.3 0 001.29.415"
				fill="#090"
			/>
			<path
				d="M562.577 283.958s.28-4.274-.786-5.581c-1.223-1.286-1.507-3.771-4.209-5.145a5.115 5.115 0 010 1.81c-.067.632-.345 2.746 0 3.465.5.72 1.943 2.028 1.943 2.682a3.83 3.83 0 001.718 2.31 10.3 10.3 0 001.29.415z"
				fill="none"
				stroke="#000"
				strokeWidth={0.347}
			/>
			<path
				d="M562.577 286.268s0-3.03-.786-3.9a17.826 17.826 0 01-1.791-1.876c-.435-.567-.877-2.094-1.875-2.682a9.29 9.29 0 01-2.968-2.594s-.413 3.619.569 5.58c1 1.875 1 2.9 2.243 3.336a5.484 5.484 0 011.747 1 3.121 3.121 0 001.724.718 2.4 2.4 0 011.155.415"
				fill="#090"
			/>
			<path
				d="M562.577 286.268s0-3.03-.786-3.9a17.826 17.826 0 01-1.791-1.876c-.435-.567-.877-2.094-1.875-2.682a9.29 9.29 0 01-2.968-2.594s-.413 3.619.569 5.58c1 1.875 1 2.9 2.243 3.336a5.484 5.484 0 011.747 1 3.121 3.121 0 001.724.718 2.4 2.4 0 011.155.415z"
				fill="none"
				stroke="#000"
				strokeWidth={0.347}
			/>
			<path
				d="M559.24 306.3c-.128.854-.72-1.875 2.31-1.875a9.774 9.774 0 006.585-2.243 22.447 22.447 0 002.093-2.245 8.408 8.408 0 001.72-3.03c.133-.851 1-4.12.853-4.71a6.7 6.7 0 00-2.31.85c-.72.634-2.093.634-2.813 1.07-.72.413-1.312 1.59-1.725 2.027-.413.414-1.718.414-2.31 1.285a15 15 0 00-1.808 3.685c-.067.85-1.155 1.722-1.875 2.158-.72.414-.57 2.157-.72 2.967"
				fill="#090"
			/>
			<path
				d="M559.24 306.3c-.128.854-.72-1.875 2.31-1.875a9.774 9.774 0 006.585-2.243 22.447 22.447 0 002.093-2.245 8.408 8.408 0 001.72-3.03c.133-.851 1-4.12.853-4.71a6.7 6.7 0 00-2.31.85c-.72.634-2.093.634-2.813 1.07-.72.413-1.312 1.59-1.747 2.027-.413.414-1.718.414-2.31 1.285a15.222 15.222 0 00-1.809 3.685c-.066.85-1.154 1.722-1.874 2.158-.72.414-.57 2.157-.72 2.967z"
				fill="none"
				stroke="#000"
				strokeWidth={0.347}
			/>
			<path
				d="M559.525 305.145s2.026-2.527 3.03-2.527c1.066 0 3.683-2.681 3.834-3.771a8.074 8.074 0 011.59-3.837 3.422 3.422 0 001.508-3.248c-.2-1.723-.2-4.622-.2-4.622s-.57 1.723-1.44 2.158c-.847.414-2.46 1-2.746 1.592-.285.567-1.44.567-1.964 2.376-.346 1.722-.346 1.592-.72 2.159a8.972 8.972 0 00-1.284 2.462c-.284 1.22-1.875 4.273-1.59 7.235"
				fill="#090"
			/>
			<path
				d="M559.525 305.145s2.026-2.527 3.03-2.527c1.066 0 3.683-2.681 3.834-3.771a8.074 8.074 0 011.59-3.837 3.422 3.422 0 001.508-3.248c-.2-1.723-.2-4.622-.2-4.622s-.57 1.723-1.44 2.158c-.847.414-2.46 1-2.746 1.592-.285.567-1.44.567-1.964 2.376-.346 1.722-.346 1.592-.72 2.159a8.972 8.972 0 00-1.284 2.462c-.284 1.22-1.875 4.273-1.59 7.235z"
				fill="none"
				stroke="#000"
				strokeWidth={0.347}
			/>
			<path
				d="M562.577 288.884c.061.785-1.155-1.5 1.59-2.377a9.414 9.414 0 005.425-3.836c.636-1.155.938-2.026 1.222-2.528a7.928 7.928 0 00.72-3.249c-.067-.85-.194-4.054-.5-4.556a6.576 6.576 0 00-1.875 1.439c-.5.785-1.658 1.155-2.243 1.722a11.051 11.051 0 00-1 2.376c-.279.5-1.44.85-1.719 1.81a11.986 11.986 0 00-.569 3.836 4.068 4.068 0 01-1.155 2.53c-.5.566.133 2.092.133 2.812"
				fill="#090"
			/>
			<path
				d="M562.577 288.884c.061.785-1.155-1.5 1.59-2.377a9.414 9.414 0 005.425-3.836c.636-1.155.938-2.026 1.222-2.528a7.928 7.928 0 00.72-3.249c-.067-.85-.194-4.054-.5-4.556a6.576 6.576 0 00-1.875 1.439c-.5.785-1.658 1.155-2.243 1.722a11.051 11.051 0 00-1 2.376c-.279.5-1.44.85-1.719 1.81a11.986 11.986 0 00-.569 3.836 4.068 4.068 0 01-1.155 2.53c-.5.566.133 2.092.133 2.812z"
				fill="none"
				stroke="#000"
				strokeWidth={0.347}
			/>
			<path
				d="M562.577 287.729s1.155-2.813 2.093-3.118c.938-.282 2.461-2.68 2.528-3.77.062-1.222.285-3.4.72-3.9a4.952 4.952 0 00.563-3.9c-.63-1.591-1.59-3.685-1.59-3.685a18.852 18.852 0 00-1.283 2.159c-.788 1.5-1.507 1.592-1.657 2.158-.069.633-1.072 1-1.374 2.224-.419 1.656.061 1.59-.066 2.245a9.334 9.334 0 00-.5 2.593c.067 1.157-.564 4.34.569 6.956"
				fill="#090"
			/>
			<path
				d="M562.577 287.729s1.155-2.813 2.093-3.118c.938-.282 2.461-2.68 2.528-3.77.062-1.222.285-3.4.72-3.9a4.952 4.952 0 00.563-3.9c-.63-1.591-1.59-3.685-1.59-3.685a18.852 18.852 0 00-1.283 2.159c-.788 1.5-1.507 1.592-1.657 2.158-.069.633-1.072 1-1.374 2.224-.419 1.656.061 1.59-.066 2.245a9.334 9.334 0 00-.5 2.593c.067 1.157-.564 4.34.569 6.956z"
				fill="none"
				stroke="#000"
				strokeWidth={0.347}
			/>
			<path
				d="M560.267 270.028c-.134-.415-1.005-.851-2.032-1.221-1-.284-2.656-2.6-3.332-3.183-.72-.633-1.071-1.5-1.941-2.028-.849-.5-1.507-2.31-1.724-4.119 0 0 2.466.565 3.185.721a7.627 7.627 0 012.814 1.718c.563.72 1.155 1.942 1.718 2.225s1.29 2.028 1.29 3.248v2.595"
				fill="#090"
			/>
			<path
				d="M560.267 270.028c-.134-.415-1.005-.851-2.032-1.221-1-.284-2.656-2.6-3.332-3.183-.72-.633-1.071-1.5-1.941-2.028-.849-.5-1.507-2.31-1.748-4.119 0 0 2.468.565 3.188.721a7.628 7.628 0 012.812 1.718c.564.72 1.156 1.942 1.719 2.225s1.29 2.028 1.29 3.248v2.595z"
				fill="none"
				stroke="#000"
				strokeWidth={0.347}
			/>
			<path
				d="M560.4 268.719s.128-1.722.128-2.528c0-.85.57-3.248-.714-5.145-.854-1.283-4.124-3.772-4.994-3.9a12.025 12.025 0 00-.413 3.03c.127.72.937 3.683 1.59 3.988.72.283 2.377 3.772 4.425 4.556"
				fill="#090"
			/>
			<path
				d="M560.4 268.719s.128-1.722.128-2.528c0-.85.57-3.248-.714-5.145-.854-1.283-4.124-3.772-4.994-3.9a12.025 12.025 0 00-.413 3.03c.127.72.937 3.683 1.59 3.988.72.283 2.377 3.772 4.425 4.556z"
				fill="none"
				stroke="#000"
				strokeWidth={0.347}
			/>
			<path
				d="M561.137 270.028c.346.632.129-2.225 1-2.9a3.434 3.434 0 001-2.965 22.923 22.923 0 00-.345-2.81c-.195-.72-2.377-3.773-2.25-4.621 0 0-1.216 2.807-1.59 3.616-.413 1 .284 2.093.134 2.963-.134.852-.854 2.465-.284 3.337.434.785 1.718 2.377 2.31 3.4"
				fill="#090"
			/>
			<path
				d="M561.137 270.028c.346.632.129-2.225 1-2.9a3.434 3.434 0 001-2.965 22.923 22.923 0 00-.345-2.81c-.195-.72-2.377-3.773-2.25-4.621 0 0-1.216 2.807-1.59 3.616-.413 1 .284 2.093.134 2.963-.134.852-.854 2.465-.284 3.337.434.785 1.718 2.377 2.31 3.4z"
				fill="none"
				stroke="#000"
				strokeWidth={0.347}
			/>
			<path
				d="M553.352 254.857s-.128-.442-1.44-.442c-1.283 0-3.248-.061-3.833-.714a11.452 11.452 0 00-2.16-1.595 4.378 4.378 0 01-1.72-2.244c-.2-.564-1.221-1.72-1.657-1.72a11.032 11.032 0 013.4.348c1.723.345 4.208 1.283 4.776 2.46.63 1.156 2.68 3.907 2.68 3.907"
				fill="#090"
			/>
			<path
				d="M553.352 254.857s-.128-.442-1.44-.442c-1.283 0-3.248-.061-3.833-.714a11.452 11.452 0 00-2.16-1.595 4.532 4.532 0 01-1.741-2.244c-.2-.564-1.223-1.72-1.658-1.72a11.023 11.023 0 013.4.348c1.724.345 4.208 1.283 4.777 2.46.63 1.156 2.679 3.907 2.679 3.907z"
				fill="none"
				stroke="#000"
				strokeWidth={0.347}
			/>
			<path
				d="M552.917 254.572c-.346 1-2.813-1-3.4-1.724-.568-.72-1.438-1.875-1.438-1.875a14.624 14.624 0 01-1.725-2.372c-.848-1.6-.631-4.493-.28-4.275a21.134 21.134 0 002.462 1.374 2.41 2.41 0 011.59 1.132 7.364 7.364 0 001.072 2.243 4.418 4.418 0 011.742 5.5"
				fill="#090"
			/>
			<path
				d="M552.917 254.572c-.346 1-2.813-1-3.4-1.724-.568-.72-1.438-1.875-1.438-1.875a14.624 14.624 0 01-1.725-2.372c-.848-1.6-.631-4.493-.28-4.275a21.134 21.134 0 002.462 1.374 2.41 2.41 0 011.59 1.132 7.364 7.364 0 001.072 2.243 4.418 4.418 0 011.742 5.5z"
				fill="none"
				stroke="#000"
				strokeWidth={0.347}
			/>
			<path
				d="M553.787 254.572a24.071 24.071 0 01-2.745-2.16c-.938-.847-.413-2.026-.938-2.595-.346-.564-1.44-1.936-1.155-2.812.285-.849.854-3.332.854-3.332s1.066.937 1.808 1.719a4.639 4.639 0 011.155 2.182 19.31 19.31 0 001.156 2.243 7.509 7.509 0 01-.135 3.03 6.7 6.7 0 000 1.724"
				fill="#090"
			/>
			<path
				d="M553.787 254.572a24.071 24.071 0 01-2.745-2.16c-.938-.847-.413-2.026-.938-2.595-.346-.564-1.44-1.936-1.155-2.812.285-.849.854-3.332.854-3.332s1.066.937 1.808 1.719a4.639 4.639 0 011.155 2.182 19.31 19.31 0 001.156 2.243 7.509 7.509 0 01-.135 3.03 6.7 6.7 0 000 1.724"
				fill="none"
				stroke="#000"
				strokeWidth={0.347}
			/>
			<path
				d="M530.878 337.278a.851.851 0 11.85-.848.808.808 0 01-.85.848"
				fill="#e60000"
			/>
			<path
				d="M530.878 337.278a.851.851 0 11.85-.848.808.808 0 01-.85.848"
				fill="none"
				stroke="#000"
				strokeWidth={0.173}
			/>
			<path
				d="M535.867 343.45a.814.814 0 01-.847-.853.864.864 0 01.847-.848.916.916 0 01.877.847.859.859 0 01-.877.855"
				fill="#e60000"
			/>
			<path
				d="M535.867 343.45a.814.814 0 01-.847-.853.864.864 0 01.847-.848.916.916 0 01.877.847.859.859 0 01-.877.855"
				fill="none"
				stroke="#000"
				strokeWidth={0.173}
			/>
			<path
				d="M547.492 324.091a.93.93 0 01-.937-.853.875.875 0 01.937-.849.866.866 0 01.849.848.913.913 0 01-.848.854"
				fill="#e60000"
			/>
			<path
				d="M547.492 324.091a.93.93 0 01-.937-.853.875.875 0 01.937-.849.866.866 0 01.849.848.913.913 0 01-.848.854"
				fill="none"
				stroke="#000"
				strokeWidth={0.173}
			/>
			<path
				d="M554.664 327.708a.973.973 0 01-1-1 .959.959 0 011-.936.946.946 0 01.938.937.961.961 0 01-.937 1"
				fill="#e60000"
			/>
			<path
				d="M554.664 327.708a.973.973 0 01-1-1 .959.959 0 011-.936.946.946 0 01.938.937.961.961 0 01-.937 1"
				fill="none"
				stroke="#000"
				strokeWidth={0.173}
			/>
			<path
				d="M555.97 305.932a1 1 0 01-1-.938 1.079 1.079 0 011-1 1.018 1.018 0 01.938 1 .943.943 0 01-.938.937"
				fill="#e60000"
			/>
			<path
				d="M555.97 305.932a1 1 0 01-1-.938 1.079 1.079 0 011-1 1.018 1.018 0 01.938 1 .943.943 0 01-.938.937"
				fill="none"
				stroke="#000"
				strokeWidth={0.173}
			/>
			<path
				d="M561.986 307.762a.924.924 0 01-.938-1 .908.908 0 01.938-.938.947.947 0 01.937.938.958.958 0 01-.937 1"
				fill="#e60000"
			/>
			<path
				d="M561.986 307.762a.924.924 0 01-.938-1 .908.908 0 01.938-.938.947.947 0 01.937.938.958.958 0 01-.937 1"
				fill="none"
				stroke="#000"
				strokeWidth={0.173}
			/>
			<path
				d="M558.934 288.382a1.026 1.026 0 01-1-1 .958.958 0 011-.937.944.944 0 01.938.937 1 1 0 01-.938 1"
				fill="#e60000"
			/>
			<path
				d="M558.934 288.382a1.026 1.026 0 01-1-1 .958.958 0 011-.937.944.944 0 01.938.937 1 1 0 01-.938 1"
				fill="none"
				stroke="#000"
				strokeWidth={0.173}
			/>
			<path
				d="M564.319 270.529a.886.886 0 01-.938-.85.96.96 0 01.938-1 .973.973 0 011 1 .907.907 0 01-1 .85"
				fill="#e60000"
			/>
			<path
				d="M564.319 270.529a.886.886 0 01-.938-.85.96.96 0 01.938-1 .973.973 0 011 1 .907.907 0 01-1 .85"
				fill="none"
				stroke="#000"
				strokeWidth={0.173}
			/>
			<path
				d="M557.431 272.337a.959.959 0 01-.937-1 .944.944 0 01.937-.938.959.959 0 011 .938.972.972 0 01-1 1"
				fill="#e60000"
			/>
			<path
				d="M557.431 272.337a.959.959 0 01-.937-1 .944.944 0 01.937-.938.959.959 0 011 .938.972.972 0 01-1 1"
				fill="none"
				stroke="#000"
				strokeWidth={0.173}
			/>
			<path d="M550.673 257.468a.94.94 0 110-1.875.938.938 0 010 1.875" fill="#e60000" />
			<path
				d="M550.673 257.468a.94.94 0 110-1.875.938.938 0 010 1.875"
				fill="none"
				stroke="#000"
				strokeWidth={0.173}
			/>
			<path
				d="M555.82 253.417a.922.922 0 01-.939-1 .9.9 0 01.938-.939.972.972 0 010 1.943"
				fill="#e60000"
			/>
			<path
				d="M555.82 253.417a.922.922 0 01-.939-1 .9.9 0 01.938-.939.972.972 0 010 1.943"
				fill="none"
				stroke="#000"
				strokeWidth={0.173}
			/>
			<path d="M545.528 243.41a.971.971 0 010-1.941.971.971 0 110 1.941" fill="#e60000" />
			<path
				d="M545.528 243.41a.971.971 0 010-1.941.971.971 0 110 1.941"
				fill="none"
				stroke="#000"
				strokeWidth={0.173}
			/>
			<path
				d="M566.5 288.449a.886.886 0 01-.937-.85.938.938 0 111.875 0 .872.872 0 01-.937.85"
				fill="#e60000"
			/>
			<path
				d="M566.5 288.449a.886.886 0 01-.937-.85.938.938 0 111.875 0 .872.872 0 01-.937.85"
				fill="none"
				stroke="#000"
				strokeWidth={0.173}
			/>
			<path
				d="M530.008 340.918a18.057 18.057 0 00.564-3.768s-.285 0-.721-.57m1.312 5.56a22.186 22.186 0 013.684.35 2.3 2.3 0 00.284.782m13.076-15.128s.134-3.685-.564-3.986a2.96 2.96 0 01-1.155-.876m4.554 3.705a7.915 7.915 0 012.595 0 1.06 1.06 0 00.569.721m.736-22.279l.721.352c.786.346 2.249 3.834 2.249 3.834a12.793 12.793 0 013.331-1.875h1M567 288.1a1.116 1.116 0 01-1.156.282s-2.968 1.877-3.03 2.6c0 0-3.12-3.03-3.689-2.748 0 0-.28.415-.847-.13m5.514-18.072a2.925 2.925 0 01-.938.72 7.561 7.561 0 00-1.284 3.335s-2.461-2.158-3.181-2.027a2.279 2.279 0 01-1.44 0m-.4-18.945s-.564.72-1 .133c0 0-1.746 2.155-.72 3.835 0 0-2.466-.564-3.18-.129a.749.749 0 01-1.223.413m-4.111-14.767s.435 1-1.29.636"
				fill="none"
				stroke="#000"
				strokeWidth={0.347}
			/>
			<path
				d="M521.373 347.068s9.634-.068 10.571-1.284m-16.173 2.528s6.3 1.72 9.633 1.284a17.691 17.691 0 015.714.284 28.328 28.328 0 004.426-1.507m-26.225 2.272s4.838.847 5.863 1.155c1 .279 6.017 2.153 7.455 2.153 1.154 0 4.056-.06 4.842 0a17.292 17.292 0 006.145-.412m-5.95-14.515a30.9 30.9 0 00-4.274 2.9c-.564.786-3.836 3.4-4.425 3.4m8.7-10.882s-6.3 5.43-7.392 6.15c-1 .78-7.172 6.736-7.89 7.695m10.135-16.156s-4.991 3.99-5.58 5.582a15.563 15.563 0 01-2.027 3.465s-2.093 4.124-2.812 4.71a30.77 30.77 0 01-3.9 3.248m42.836-20.71s-5.3 4.425-6.736 5.273m8.918-2.438a63.615 63.615 0 01-7.607 4.553 41.549 41.549 0 01-9.42 2.31m-2.07 2.054s5.864-.284 6.887 0c1 .28 5.58-.72 6.735-1s5.865-1.155 6.457-1.289m-11.078-17.5a15.718 15.718 0 01-.2 4.554c-.413 1.289-2.462 5.056-2.31 6.016.128.853-1.156 4.838-2.311 5.58m-1.29-15.586s1.072 3.186.57 4.274a15.629 15.629 0 00-1.156 4.119 12.126 12.126 0 01-1 3.622c-.28.72.133 3.248-.565 3.9a21.8 21.8 0 00-1.59 2.094m35.18-25.465s-4.62 1.725-5.272 2.9c-.57 1.156-1.374 1.5-1.875 2.093m-10.136-9.42s-1.155 4.71-.853 5.865a24.717 24.717 0 01.284 4.426c0 .854 1.29 4.425 1.072 4.994m1.395-19.208s.413 2.745.564 3.906a25.931 25.931 0 00.285 3.834c.284.72.72 4.62 0 6.451M566 309.069s-3.84 3.247-4.71 4.123c-.848.848-4.771 5.056-4.99 6.144-.067 1-2.9 4.209-3.771 5m19.922-31.676s-3.772 3.771-4.119 4.621a8.029 8.029 0 01-2.594 2.813m-11.207-5.82s1.44 2.157 1.44 2.9a7.191 7.191 0 001.223 3.4c.346.5 1.59 2.594 1.44 3.9m-2.947-16.37s.569 2.027.854 3.467a25.253 25.253 0 001.373 3.836c.278.85 1.434 5.145 1 7.761m10.119-15.216a6.283 6.283 0 01-1.44 3.03c-1.005 1-2.6 2.529-2.746 3.335-.135.937-1.44 5.275-2.964 6.8a5.387 5.387 0 00-1.6 2.964m10.267-31.085s-.5 2.462-.72 3.181c-.278.72-1.522 3.99-2.678 4.993m-9.219-7.52a22.285 22.285 0 01.848 2.964 10.751 10.751 0 001.155 2.31c.129.414.72 1.94.72 1.94m-5.408-5.187a22.3 22.3 0 001.943 3.989 6.847 6.847 0 001.875 3.117c.87.567 3.465 2.463 3.332 3.249m4.32-16s.128 3.183-.414 4.338c-.569 1.22-1.289 2.966-1.6 3.836a22.966 22.966 0 00-.412 3.337 9.2 9.2 0 01-1.155 3.683m-11.53-25.2s2.092 2.377 3.03 3.4c1 .936 4.705 4.991 4.84 5.71m-4.382-11.29s2.093 4.486 2.528 5.206c.413.787.848 1.942.848 1.942m1.92-7.305s-.129 3.555 0 4.425a9.806 9.806 0 010 2.75 31.383 31.383 0 00.569 4.425m-17.552-20.73s4.622 2.812 5.364 3.55m-2.662-7.194l3.247 4.627.721 1.372m-.28-6.435a22.9 22.9 0 011.218 3.466 30.368 30.368 0 002.16 5.43"
				fill="none"
				stroke="#000"
				strokeWidth={0.173}
			/>
			<path
				d="M472.454 337.278a.851.851 0 000-1.7.866.866 0 00-.85.853.85.85 0 00.85.848"
				fill="#e60000"
			/>
			<path
				d="M472.454 337.278a.851.851 0 000-1.7.866.866 0 00-.85.853.85.85 0 00.85.848"
				fill="none"
				stroke="#000"
				strokeWidth={0.173}
			/>
			<path
				d="M467.463 343.45a.888.888 0 00.937-.853.931.931 0 00-.937-.848.912.912 0 00-.85.847.853.853 0 00.85.855"
				fill="#e60000"
			/>
			<path
				d="M467.463 343.45a.888.888 0 00.937-.853.931.931 0 00-.937-.848.912.912 0 00-.85.847.853.853 0 00.85.855"
				fill="none"
				stroke="#000"
				strokeWidth={0.173}
			/>
			<path
				d="M455.908 324.091a.9.9 0 00.85-.853.852.852 0 00-.85-.849.887.887 0 00-.937.848.931.931 0 00.937.854"
				fill="#e60000"
			/>
			<path
				d="M455.908 324.091a.9.9 0 00.85-.853.852.852 0 00-.85-.849.887.887 0 00-.937.848.931.931 0 00.937.854"
				fill="none"
				stroke="#000"
				strokeWidth={0.173}
			/>
			<path d="M448.737 327.708a.969.969 0 10-1-1 .985.985 0 001 1" fill="#e60000" />
			<path
				d="M448.737 327.708a.969.969 0 10-1-1 .985.985 0 001 1"
				fill="none"
				stroke="#000"
				strokeWidth={0.173}
			/>
			<path
				d="M447.428 305.932a.944.944 0 00.937-.938 1 1 0 00-.937-1 1.029 1.029 0 00-1 1 .961.961 0 001 .937"
				fill="#e60000"
			/>
			<path
				d="M447.428 305.932a.944.944 0 00.937-.938 1 1 0 00-.937-1 1.029 1.029 0 00-1 1 .961.961 0 001 .937"
				fill="none"
				stroke="#000"
				strokeWidth={0.173}
			/>
			<path
				d="M441.347 307.762a.972.972 0 100-1.942.947.947 0 00-.938.938.959.959 0 00.938 1"
				fill="#e60000"
			/>
			<path
				d="M441.347 307.762a.972.972 0 100-1.942.947.947 0 00-.938.938.959.959 0 00.938 1"
				fill="none"
				stroke="#000"
				strokeWidth={0.173}
			/>
			<path
				d="M444.464 288.382a1.019 1.019 0 00.937-1 .944.944 0 00-.937-.937.96.96 0 00-1 .937 1.013 1.013 0 001 1"
				fill="#e60000"
			/>
			<path
				d="M444.464 288.382a1.019 1.019 0 00.937-1 .944.944 0 00-.937-.937.96.96 0 00-1 .937 1.013 1.013 0 001 1"
				fill="none"
				stroke="#000"
				strokeWidth={0.173}
			/>
			<path
				d="M439.014 270.529a.948.948 0 001-.85 1.031 1.031 0 00-1-1 .962.962 0 00-.938 1 .874.874 0 00.938.85"
				fill="#e60000"
			/>
			<path
				d="M439.014 270.529a.948.948 0 001-.85 1.031 1.031 0 00-1-1 .962.962 0 00-.938 1 .874.874 0 00.938.85"
				fill="none"
				stroke="#000"
				strokeWidth={0.173}
			/>
			<path
				d="M445.9 272.337a.973.973 0 001-1 .961.961 0 00-1-.938.945.945 0 00-.937.938.96.96 0 00.938 1"
				fill="#e60000"
			/>
			<path
				d="M445.9 272.337a.973.973 0 001-1 .961.961 0 00-1-.938.945.945 0 00-.937.938.96.96 0 00.938 1"
				fill="none"
				stroke="#000"
				strokeWidth={0.173}
			/>
			<path
				d="M452.66 257.468a.94.94 0 100-1.875.948.948 0 00-.939.938.96.96 0 00.939.937"
				fill="#e60000"
			/>
			<path
				d="M452.66 257.468a.94.94 0 100-1.875.948.948 0 00-.939.938.96.96 0 00.939.937"
				fill="none"
				stroke="#000"
				strokeWidth={0.173}
			/>
			<path d="M447.494 253.417a.973.973 0 001-1 .971.971 0 10-1 1" fill="#e60000" />
			<path
				d="M447.494 253.417a.973.973 0 001-1 .971.971 0 10-1 1"
				fill="none"
				stroke="#000"
				strokeWidth={0.173}
			/>
			<path d="M457.805 243.41a.971.971 0 10-.937-.938.9.9 0 00.937.938" fill="#e60000" />
			<path
				d="M457.805 243.41a.971.971 0 10-.937-.938.9.9 0 00.937.938"
				fill="none"
				stroke="#000"
				strokeWidth={0.173}
			/>
			<path
				d="M436.833 288.449a.886.886 0 00.937-.85.937.937 0 10-1.874 0 .873.873 0 00.937.85"
				fill="#e60000"
			/>
			<path
				d="M436.833 288.449a.886.886 0 00.937-.85.937.937 0 10-1.874 0 .873.873 0 00.937.85"
				fill="none"
				stroke="#000"
				strokeWidth={0.173}
			/>
			<path
				d="M473.326 340.918a18.227 18.227 0 01-.567-3.768s.284 0 .72-.57m-1.308 5.56a22.783 22.783 0 00-3.684.35 2.3 2.3 0 01-.283.782m-13.08-15.128s-.131-3.685.566-3.986a2.967 2.967 0 001.156-.876m-4.469 3.705a8.435 8.435 0 00-2.68 0 1.07 1.07 0 01-.569.721m-.763-22.279l-.718.352c-.72.346-2.18 3.834-2.18 3.834a13.5 13.5 0 00-3.4-1.875h-1m-4.735-19.64a1.113 1.113 0 001.156.282s2.9 1.877 3.117 2.6c0 0 3.03-3.03 3.618-2.748 0 0 .35.415.938-.13m-5.56-18.072a2.484 2.484 0 00.786.72 7.3 7.3 0 011.374 3.335s2.44-2.158 3.182-2.027a2.513 2.513 0 001.5 0m.327-18.945s.568.72 1 .133c0 0 1.744 2.155.719 3.835 0 0 2.465-.564 3.27-.129a.706.706 0 001.156.413M457 242.6s-.414 1 1.374.636"
				fill="none"
				stroke="#000"
				strokeWidth={0.347}
			/>
			<path
				d="M518.975 359.842s-3.771-.285-4.337-.285-1.963-2.6-2.53-3.03c-.566-.413-10.508-5.274-17.047-6.3-6.453-1-16.393-4.839-18.422-5.86-10.725-5.145-22.758-14.716-25.461-18.64-2.747-4.118-5.712-13.628-7.02-18.79-.567-2.378-3.77-12.035-3.77-18.64a82.491 82.491 0 012.026-18.922c1.156-4.993 9.7-19.64 15-26.12 0 0-11.815 18.205-13.842 25.247a77.734 77.734 0 00-2.464 20.884c.065 4.12 3.554 19.142 8.48 30.17 3.99 8.85 7.456 9.855 13.69 14.782a93.228 93.228 0 0013.124 8.417 91.7 91.7 0 0017.331 5.642c2.594.5 16.023 4.425 17.767 5.28 1.809.87 6.3 4.837 7.455 6.144"
				fill="#090"
			/>
			<path
				d="M518.975 359.842s-3.771-.285-4.337-.285-1.963-2.6-2.53-3.03c-.566-.413-10.508-5.274-17.047-6.3-6.453-1-16.393-4.839-18.422-5.86-10.725-5.145-22.758-14.716-25.461-18.64-2.747-4.118-5.712-13.628-7.02-18.79-.567-2.378-3.77-12.035-3.77-18.64a82.491 82.491 0 012.026-18.922c1.156-4.993 9.7-19.64 15-26.12 0 0-11.815 18.205-13.842 25.247a77.734 77.734 0 00-2.464 20.884c.065 4.12 3.554 19.142 8.48 30.17 3.99 8.85 7.456 9.855 13.69 14.782a93.228 93.228 0 0013.124 8.417 91.7 91.7 0 0017.331 5.642c2.594.5 16.023 4.425 17.767 5.28 1.809.87 6.3 4.837 7.455 6.144z"
				fill="none"
				stroke="#000"
				strokeWidth={0.347}
			/>
			<path
				d="M452.071 325.81c.284-1.373.349-2.371.85-2.746a11.72 11.72 0 002.16-3.4 8.359 8.359 0 000-2.684 25.18 25.18 0 01.413-2.59 10.7 10.7 0 00-1.286-2.969 13.814 13.814 0 01-2.376-3.03 2.558 2.558 0 01-.283 1.725 6.312 6.312 0 00-.568 2.962 17.91 17.91 0 010 3.9 6.625 6.625 0 00-.414 3.4q.744 2.715 1.5 5.425"
				fill="#090"
			/>
			<path
				d="M452.071 325.81c.284-1.373.349-2.371.85-2.746a11.72 11.72 0 002.16-3.4 8.359 8.359 0 000-2.684 25.18 25.18 0 01.413-2.59 10.7 10.7 0 00-1.286-2.969 13.814 13.814 0 01-2.376-3.03 2.558 2.558 0 01-.283 1.725 6.312 6.312 0 00-.568 2.962 17.91 17.91 0 010 3.9 6.625 6.625 0 00-.414 3.4q.744 2.715 1.5 5.425"
				fill="none"
				stroke="#000"
				strokeWidth={0.347}
			/>
			<path
				d="M451.57 324.377s-3.335-4.276-3.335-6.084a6.481 6.481 0 00-.567-3.186 4.563 4.563 0 01-.435-5.426 8.145 8.145 0 001.285-2.31c.567-1.59 1.744-1.59 1.962-3.184 0 0 .35 1.873.5 3.468a12.278 12.278 0 01-.195 3.026c-.2.937.348 1.941.348 3.254 0 1.283-.13 1.808-.13 2.589 0 .419-.5 6.016.566 7.83"
				fill="#090"
			/>
			<path
				d="M451.57 324.377s-3.335-4.276-3.335-6.084a6.481 6.481 0 00-.567-3.186 4.563 4.563 0 01-.435-5.426 8.145 8.145 0 001.285-2.31c.567-1.59 1.744-1.59 1.962-3.184 0 0 .35 1.873.5 3.468a12.278 12.278 0 01-.195 3.026c-.2.937.348 1.941.348 3.254 0 1.283-.13 1.808-.13 2.589 0 .419-.5 6.016.566 7.83z"
				fill="none"
				stroke="#000"
				strokeWidth={0.347}
			/>
			<path
				d="M489.219 347.285s-2.813-.284-3.9-.5a18.278 18.278 0 01-3.4-.847 10.91 10.91 0 01-3.99-2.685c-2.66-2.9-2.377-4.426-2.9-4.554-.936-.128 1.5-.413 2.66-.2a7.731 7.731 0 013.838 1.942 30.616 30.616 0 003.4 2.59 5.672 5.672 0 011.592 1.44 7.09 7.09 0 002.68 2.812"
				fill="#090"
			/>
			<path
				d="M489.219 347.285s-2.813-.284-3.9-.5a18.278 18.278 0 01-3.4-.847 10.91 10.91 0 01-3.99-2.685c-2.66-2.9-2.377-4.426-2.9-4.554-.936-.128 1.5-.413 2.66-.2a7.731 7.731 0 013.838 1.942 30.616 30.616 0 003.4 2.59 5.672 5.672 0 011.592 1.44 7.09 7.09 0 002.68 2.812z"
				fill="none"
				stroke="#000"
				strokeWidth={0.347}
			/>
			<path
				d="M493.143 349.333s-7.107-3.18-7.827-3.772a20.766 20.766 0 01-2.747-2.462c-.632-.786-3.684-2.31-4.206-3.336-.284-.632-2.159-3.182-3.271-5.207-.566-1.072 4.709.284 4.709.284 4.272 1.719 2.4.5 4.709 2.31a9 9 0 012.812 2.813 42.184 42.184 0 001.81 4.553 19.454 19.454 0 003.988 4.773"
				fill="#090"
			/>
			<path
				d="M493.143 349.333s-7.107-3.18-7.827-3.772a20.766 20.766 0 01-2.747-2.462c-.632-.786-3.684-2.31-4.206-3.336-.284-.632-2.159-3.182-3.271-5.207-.566-1.072 4.709.284 4.709.284 4.272 1.719 2.4.5 4.709 2.31a9 9 0 012.812 2.813 42.184 42.184 0 001.81 4.553 19.454 19.454 0 003.988 4.773z"
				fill="none"
				stroke="#000"
				strokeWidth={0.347}
			/>
			<path
				d="M496.979 350.21s-5.864-1.508-8.545-5.146c-1.876-2.467-1.876-1.724-2.681-2.528a22.3 22.3 0 01-3.772-4.342c.065.195-1.723-5.8-1.591-6.452 0-.413 2.158.285 3.99 1 1.5.652 2.376 1.875 3.683 2.679 1.569 1 1.788 3.555 2.53 4.71a6.006 6.006 0 011.067 3.466c0 1.284.72 1.724 1.155 2.812.5 1.284 2.093 1.066 4.121 3.773"
				fill="#090"
			/>
			<path
				d="M496.979 350.21s-5.864-1.508-8.545-5.146c-1.876-2.467-1.876-1.724-2.681-2.528a22.3 22.3 0 01-3.772-4.342c.065.195-1.744-5.8-1.591-6.452 0-.413 2.158.285 3.99 1 1.5.652 2.376 1.875 3.683 2.679 1.569 1 1.788 3.555 2.53 4.71a6.006 6.006 0 011.067 3.466c0 1.284.72 1.724 1.155 2.812.5 1.284 2.093 1.066 4.121 3.773z"
				fill="none"
				stroke="#000"
				strokeWidth={0.347}
			/>
			<path
				d="M487.562 348.312s-4.993-2.25-5.646-2.4c-.785-.128-1.068-.57-2.093-.848a5.745 5.745 0 00-3.684-.419c-.85.2-4.491 1-5.363.57-.938-.413 1.286 2.46 2.31 3.12a8.2 8.2 0 004.273.713c1.44-.127 3.466 0 4.208 0a6.783 6.783 0 002.223-.127 6.433 6.433 0 013.772-.57"
				fill="#090"
			/>
			<path
				d="M487.562 348.312s-4.993-2.25-5.646-2.4c-.785-.128-1.068-.57-2.093-.848a5.745 5.745 0 00-3.684-.419c-.85.2-4.491 1-5.363.57-.938-.413 1.286 2.46 2.31 3.12a8.2 8.2 0 004.273.713c1.44-.127 3.466 0 4.208 0a6.783 6.783 0 002.223-.127 6.433 6.433 0 013.772-.57z"
				fill="none"
				stroke="#000"
				strokeWidth={0.347}
			/>
			<path
				d="M490.963 348.312s-5.581-1.44-6.519-1.44a37.6 37.6 0 00-4.709.413c-1 .133-4.338-.2-5.362.284a18.479 18.479 0 01-6.584.782c-1.155-.195 2.377 3.186 3.771 3.555 4.491 1.29 3.118 1.072 6.083.351 1.744-.419 4.273-.569 5.144-.72.938-.133.72-.63 1.94-1.155a16.821 16.821 0 016.236-2.093"
				fill="#090"
			/>
			<path
				d="M490.963 348.312s-5.581-1.44-6.519-1.44a37.6 37.6 0 00-4.709.413c-1 .133-4.338-.2-5.362.284a18.479 18.479 0 01-6.584.782c-1.155-.195 2.377 3.186 3.771 3.555 4.491 1.29 3.118 1.072 6.083.351 1.744-.419 4.273-.569 5.144-.72.938-.133.72-.63 1.94-1.155a16.821 16.821 0 016.236-2.093z"
				fill="none"
				stroke="#000"
				strokeWidth={0.347}
			/>
			<path
				d="M495.54 350.645s-5.58-2.31-9.918-1.155a24.8 24.8 0 01-4.12.937c-1.374.194-2.53-.5-4.84.435-1.068.413-5.952 2.372-7.325 2.31-1.22-.066 3.9 3.249 5.275 3.03 4.491-.636 8.7.849 10.726.063 1.875-.715 2.965-1.218 3.9-1.5.938-.352 1.44-1.223 2.027-1.591.567-.5.938-1.591 4.273-2.528"
				fill="#090"
			/>
			<path
				d="M495.54 350.645s-5.58-2.31-9.918-1.155a24.8 24.8 0 01-4.12.937c-1.374.194-2.53-.5-4.84.435-1.068.413-5.952 2.372-7.325 2.31-1.22-.066 3.9 3.249 5.275 3.03 4.491-.636 8.7.849 10.726.063 1.875-.715 2.965-1.218 3.9-1.5.938-.352 1.44-1.223 2.027-1.591.567-.5.938-1.591 4.273-2.528"
				fill="none"
				stroke="#000"
				strokeWidth={0.347}
			/>
			<path
				d="M465.718 337.781s-3.182-3.556-3.836-3.99c-.567-.5-2.093-1.59-2.9-2.31-.72-.57-1.374-1.876-3.466-2.378-.872-.195-3.03-.631-3.618-1.373-.568-.782.13 2.813.784 3.773a7.422 7.422 0 003.466 2.528c1.374.5 3.183 1.507 3.837 1.808a5.919 5.919 0 002.026.787 7.273 7.273 0 013.686 1.155"
				fill="#090"
			/>
			<path
				d="M465.718 337.781s-3.182-3.556-3.836-3.99c-.567-.5-2.093-1.59-2.9-2.31-.72-.57-1.374-1.876-3.466-2.378-.872-.195-3.03-.631-3.618-1.373-.568-.782.13 2.813.784 3.773a7.422 7.422 0 003.466 2.528c1.374.5 3.183 1.507 3.837 1.808a5.919 5.919 0 002.026.787 7.273 7.273 0 013.686 1.155z"
				fill="none"
				stroke="#000"
				strokeWidth={0.347}
			/>
			<path
				d="M468.749 339.242s-5.428-3.838-6.3-4.207c-.85-.413-2.376-.937-3.4-1.289-1.069-.28-3.838-2.243-4.927-2.243-1.069 0-3.118-.129-4.055-.787-1-.782-.131 2.595.937 3.621 3.467 3.115 1.068 2.154 3.99 2.747 1.722.345 4.12 1.372 4.992 1.59.85.285.937-.285 2.246-.195a19.62 19.62 0 016.517.787"
				fill="#090"
			/>
			<path
				d="M468.749 339.242s-5.428-3.838-6.3-4.207c-.85-.413-2.376-.937-3.4-1.289-1.069-.28-3.838-2.243-4.927-2.243-1.069 0-3.118-.129-4.055-.787-1-.782-.131 2.595.937 3.621 3.467 3.115 1.068 2.154 3.99 2.747 1.722.345 4.12 1.372 4.992 1.59.85.285.937-.285 2.246-.195a19.62 19.62 0 016.517.787z"
				fill="none"
				stroke="#000"
				strokeWidth={0.347}
			/>
			<path
				d="M470.056 340.265a18.861 18.861 0 00-6.67-2.155 29.631 29.631 0 01-4.055-1 12.328 12.328 0 00-4.121-.5c-1.22-.128-6.082 1.44-7.17.787-1.07-.57 1.153 1.434 2.527 1.937 1.875.72 1.657 1.942 3.772 2.684 2.245.72 4.621 1.59 5.93 1.284 1-.129 1.743-.63 3.182-.781 1.374-.135 3.837-2.16 6.584-2.25"
				fill="#090"
			/>
			<path
				d="M470.056 340.265a18.861 18.861 0 00-6.67-2.155 29.631 29.631 0 01-4.055-1 12.328 12.328 0 00-4.121-.5c-1.22-.128-6.082 1.44-7.17.787-1.07-.57 1.153 1.434 2.527 1.937 1.875.72 1.657 1.942 3.772 2.684 2.245.72 4.621 1.59 5.93 1.284 1-.129 1.743-.63 3.182-.781 1.374-.135 3.837-2.16 6.584-2.25z"
				fill="none"
				stroke="#000"
				strokeWidth={0.347}
			/>
			<path
				d="M470.514 339.176s1.156-5.363.2-6.585a4.9 4.9 0 01-1.222-2.813 10.021 10.021 0 00-1.59-4.208c-.568-.714-1.723-4.119-1.44-4.989 0 0-3.117 3.03-2.9 4.989a12.173 12.173 0 010 2.317c-.2.847.72 3.833 1.286 4.7.567.853.284 3.553.872 4.056.567.63 4.055 2.964 4.774 2.528"
				fill="#090"
			/>
			<path
				d="M470.514 339.176s1.156-5.363.2-6.585a4.9 4.9 0 01-1.222-2.813 10.021 10.021 0 00-1.59-4.208c-.568-.714-1.744-4.119-1.44-4.989 0 0-3.117 3.03-2.9 4.989a12.173 12.173 0 010 2.317c-.2.847.72 3.833 1.286 4.7.567.853.284 3.553.872 4.056.567.63 4.055 2.964 4.774 2.528z"
				fill="none"
				stroke="#000"
				strokeWidth={0.347}
			/>
			<path
				d="M470.056 340.265a13.207 13.207 0 00-2.9-2.094c-1-.412-5.145-1.59-5.428-2.594-.284-1.066-3.684-4.555-3.772-5.492-.13-.631-.784-2.026-.566-2.746a11.88 11.88 0 01.85-3.465c.415-1.072 1.438-3.556 2.442-3.99 0 0 .85 2.745 1.155 3.772a9.524 9.524 0 001 2.813c.414.563 1.961 3.332 2.027 4.426.2 1 .938 4.424 1.068 5.078.13.72 2.9 3.772 4.055 4.336"
				fill="#090"
			/>
			<path
				d="M470.056 340.265a13.207 13.207 0 00-2.9-2.094c-1-.412-5.145-1.59-5.428-2.594-.284-1.066-3.684-4.555-3.772-5.492-.13-.631-.784-2.026-.566-2.746a11.88 11.88 0 01.85-3.465c.415-1.072 1.438-3.556 2.442-3.99 0 0 .85 2.745 1.155 3.772a9.524 9.524 0 001 2.813c.414.563 1.961 3.332 2.027 4.426.2 1 .938 4.424 1.068 5.078.13.72 2.9 3.772 4.055 4.336z"
				fill="none"
				stroke="#000"
				strokeWidth={0.347}
			/>
			<path
				d="M452.071 325.81c.066.787-2.244-.714-3.4-.714s-4.709.413-5.582-.42a32.834 32.834 0 00-2.68-2.812 16.268 16.268 0 01-2.463-4.335c-.415-1.5-3.467-4.12-3.9-4.426 0 0 4.186-.848 6.89.847a8.535 8.535 0 003.334 1.6c.633.278 5.145 4.118 5.43 5.58.282 1.434 2.157 3.984 2.374 4.705"
				fill="#090"
			/>
			<path
				d="M452.071 325.81c.066.787-2.244-.714-3.4-.714s-4.709.413-5.582-.42a32.834 32.834 0 00-2.68-2.812 16.268 16.268 0 01-2.463-4.335c-.415-1.5-3.467-4.12-3.9-4.426 0 0 4.186-.848 6.89.847a8.535 8.535 0 003.334 1.6c.633.278 5.145 4.118 5.43 5.58.282 1.434 2.157 3.984 2.374 4.705z"
				fill="none"
				stroke="#000"
				strokeWidth={0.347}
			/>
			<path
				d="M452.071 325.81s-3.836-2.678-4.708-2.528c-.85.134-4.993-2.9-5.276-4.772-.13-1-2.158-2.466-2.463-3.119-1.068-1.74-1.657-5.709-3.117-6.736 0 0 3.99 1 4.992 1.155 1.874.284 3.466.57 4.207 2.25.784 1.59 1.374 2.9 1.962 3.029.567.129 1.439 2.155 1.722 4.27.284 2.026 2.66 6.452 2.66 6.452"
				fill="#090"
			/>
			<path
				d="M452.071 325.81s-3.836-2.678-4.708-2.528c-.85.134-4.993-2.9-5.276-4.772-.13-1-2.158-2.466-2.463-3.119-1.068-1.72-1.657-5.709-3.117-6.736 0 0 3.99 1 4.992 1.155 1.874.284 3.466.57 4.207 2.25.784 1.59 1.374 2.9 1.962 3.029.567.129 1.439 2.155 1.722 4.27.284 2.026 2.66 6.452 2.66 6.452z"
				fill="none"
				stroke="#000"
				strokeWidth={0.347}
			/>
			<path
				d="M444.9 305.8c.566 1.006.566-5.86.785-6.514a10.423 10.423 0 011.656-2.812c.568-.567.568-2.594.85-3.184a15.5 15.5 0 00-.282-5.58 10.477 10.477 0 00-1.723 1.591c-.633.72-1.592 1-1.94 1.875-.284.85-.85.85-1.286 1.81a5.7 5.7 0 00-.567 3.466 8.671 8.671 0 01.13 2.681 21.431 21.431 0 002.377 6.667"
				fill="#090"
			/>
			<path
				d="M444.9 305.8c.566 1.006.566-5.86.785-6.514a10.423 10.423 0 011.656-2.812c.568-.567.568-2.594.85-3.184a15.5 15.5 0 00-.282-5.58 10.477 10.477 0 00-1.723 1.591c-.633.72-1.592 1-1.94 1.875-.284.85-.85.85-1.286 1.81a5.7 5.7 0 00-.567 3.466 8.671 8.671 0 01.13 2.681 21.431 21.431 0 002.377 6.667"
				fill="none"
				stroke="#000"
				strokeWidth={0.347}
			/>
			<path
				d="M444.965 306.456s-.283-1.941.5-2.683c.72-.719 1.44-.719 1.723-1.155.282-.414.13-1 .436-1.591a10.759 10.759 0 001-2.092c.283-1.592 1.156-3.337.415-5.058a10.189 10.189 0 00-2.028.85 4.072 4.072 0 00-1.874 2.593 4.051 4.051 0 01-.786 2.246c-.414.72-1 2.9-.283 4.207a6.635 6.635 0 01.85 2.683"
				fill="#090"
			/>
			<path
				d="M444.965 306.456s-.283-1.941.5-2.683c.72-.719 1.44-.719 1.723-1.155.282-.414.13-1 .436-1.591a10.759 10.759 0 001-2.092c.283-1.592 1.156-3.337.415-5.058a10.189 10.189 0 00-2.028.85 4.072 4.072 0 00-1.874 2.593 4.051 4.051 0 01-.786 2.246c-.414.72-1 2.9-.283 4.207a6.635 6.635 0 01.85 2.683z"
				fill="none"
				stroke="#000"
				strokeWidth={0.347}
			/>
			<path
				d="M440.692 283.958s-.283-4.274.938-5.581c1.155-1.286 1.439-3.771 4.055-5.145a7.578 7.578 0 000 1.81c.195.632.5 2.746 0 3.465-.414.72-1.876 2.028-1.876 2.682a3.842 3.842 0 01-1.722 2.31 9.135 9.135 0 01-1.374.415"
				fill="#090"
			/>
			<path
				d="M440.692 283.958s-.283-4.274.938-5.581c1.155-1.286 1.439-3.771 4.055-5.145a7.578 7.578 0 000 1.81c.195.632.5 2.746 0 3.465-.414.72-1.876 2.028-1.876 2.682a3.842 3.842 0 01-1.722 2.31 9.135 9.135 0 01-1.374.415z"
				fill="none"
				stroke="#000"
				strokeWidth={0.347}
			/>
			<path
				d="M440.692 286.268s0-3.03.938-3.9c.85-.85 1.286-1.374 1.721-1.874.415-.567.85-2.094 1.876-2.682a10.052 10.052 0 002.964-2.594s.415 3.619-.566 5.58c-1.069 1.875-1.069 2.9-2.181 3.336a5.039 5.039 0 00-1.81 1 3.118 3.118 0 01-1.721.718 2.789 2.789 0 00-1.221.415"
				fill="#090"
			/>
			<path
				d="M440.692 286.268s0-3.03.938-3.9c.85-.85 1.286-1.374 1.721-1.874.415-.567.85-2.094 1.876-2.682a10.052 10.052 0 002.964-2.594s.415 3.619-.566 5.58c-1.069 1.875-1.069 2.9-2.181 3.336a5.039 5.039 0 00-1.81 1 3.119 3.119 0 01-1.743.718 2.777 2.777 0 00-1.22.415z"
				fill="none"
				stroke="#000"
				strokeWidth={0.347}
			/>
			<path
				d="M444.093 306.3c.13.854.785-1.875-2.31-1.875a9.885 9.885 0 01-6.606-2.243 17.33 17.33 0 01-2.006-2.245 7.42 7.42 0 01-1.81-3.03c-.13-.851-1-4.12-.849-4.71a6.277 6.277 0 012.31.85c.72.634 2.093.634 2.812 1.07.72.413 1.286 1.59 1.744 2.027.415.414 1.722.414 2.312 1.285a13.138 13.138 0 011.809 3.685 3.859 3.859 0 001.874 2.158c.72.414.567 2.157.72 2.967"
				fill="#090"
			/>
			<path
				d="M444.093 306.3c.13.854.785-1.875-2.31-1.875a9.885 9.885 0 01-6.606-2.243 17.33 17.33 0 01-2.006-2.245 7.42 7.42 0 01-1.81-3.03c-.13-.851-1-4.12-.849-4.71a6.277 6.277 0 012.31.85c.72.634 2.093.634 2.812 1.07.72.413 1.286 1.59 1.744 2.027.415.414 1.722.414 2.312 1.285a13.138 13.138 0 011.809 3.685 3.859 3.859 0 001.874 2.158c.72.414.567 2.157.72 2.967z"
				fill="none"
				stroke="#000"
				strokeWidth={0.347}
			/>
			<path
				d="M443.81 305.145s-2.027-2.527-3.118-2.527c-1 0-3.619-2.681-3.771-3.771a8.006 8.006 0 00-1.592-3.837 3.708 3.708 0 01-1.5-3.248c.218-1.723.218-4.622.218-4.622s.566 1.723 1.44 2.158c.849.414 2.463 1 2.746 1.592.283.567 1.438.567 1.961 2.376a5.761 5.761 0 00.72 2.159 8.94 8.94 0 011.286 2.462c.284 1.22 1.874 4.273 1.592 7.235"
				fill="#090"
			/>
			<path
				d="M443.81 305.145s-2.027-2.527-3.118-2.527c-1 0-3.619-2.681-3.771-3.771a8.006 8.006 0 00-1.592-3.837 3.708 3.708 0 01-1.5-3.248c.218-1.723.218-4.622.218-4.622s.566 1.723 1.44 2.158c.849.414 2.463 1 2.746 1.592.283.567 1.438.567 1.961 2.376a5.761 5.761 0 00.72 2.159 8.94 8.94 0 011.286 2.462c.284 1.22 1.874 4.273 1.592 7.235z"
				fill="none"
				stroke="#000"
				strokeWidth={0.347}
			/>
			<path
				d="M440.758 288.884c-.066.785 1.155-1.5-1.593-2.377a9.434 9.434 0 01-5.427-3.836c-.567-1.155-.938-2.026-1.221-2.528a8.025 8.025 0 01-.72-3.249c.066-.85.2-4.054.5-4.556a6.562 6.562 0 011.874 1.439c.5.785 1.656 1.155 2.245 1.722a11.1 11.1 0 011 2.376c.282.5 1.439.85 1.721 1.81a10.374 10.374 0 01.567 3.836 4.089 4.089 0 001.155 2.53c.5.566-.065 2.092-.13 2.812"
				fill="#090"
			/>
			<path
				d="M440.758 288.884c-.066.785 1.155-1.5-1.593-2.377a9.434 9.434 0 01-5.427-3.836c-.567-1.155-.938-2.026-1.221-2.528a8.025 8.025 0 01-.72-3.249c.066-.85.2-4.054.5-4.556a6.562 6.562 0 011.874 1.439c.5.785 1.656 1.155 2.245 1.722a11.1 11.1 0 011 2.376c.282.5 1.439.85 1.721 1.81a10.374 10.374 0 01.567 3.836 4.089 4.089 0 001.155 2.53c.5.566-.065 2.092-.13 2.812z"
				fill="none"
				stroke="#000"
				strokeWidth={0.347}
			/>
			<path
				d="M440.823 287.729s-1.221-2.813-2.18-3.118c-.85-.282-2.377-2.68-2.442-3.77-.13-1.222-.349-3.4-.719-3.9a4.681 4.681 0 01-.633-3.9c.633-1.591 1.658-3.685 1.658-3.685s.784 1.374 1.286 2.159c.72 1.5 1.5 1.592 1.59 2.158.131.633 1 1 1.374 2.224.437 1.656-.065 1.59.066 2.245a9.536 9.536 0 01.5 2.593c-.065 1.157.567 4.34-.5 6.956"
				fill="#090"
			/>
			<path
				d="M440.823 287.729s-1.221-2.813-2.18-3.118c-.85-.282-2.377-2.68-2.442-3.77-.13-1.222-.349-3.4-.719-3.9a4.681 4.681 0 01-.633-3.9c.633-1.591 1.658-3.685 1.658-3.685s.784 1.374 1.286 2.159c.72 1.5 1.5 1.592 1.59 2.158.131.633 1 1 1.374 2.224.437 1.656-.065 1.59.066 2.245a9.536 9.536 0 01.5 2.593c-.065 1.157.567 4.34-.5 6.956z"
				fill="none"
				stroke="#000"
				strokeWidth={0.347}
			/>
			<path
				d="M443.069 270.028c.13-.415 1-.851 2.092-1.221 1-.284 2.595-2.6 3.335-3.183.655-.633 1-1.5 1.963-2.028.85-.5 1.373-2.31 1.656-4.119 0 0-2.464.565-3.183.721a6.9 6.9 0 00-2.747 1.718c-.631.72-1.22 1.942-1.809 2.225-.567.284-1.286 2.028-1.286 3.248v2.595"
				fill="#090"
			/>
			<path
				d="M443.069 270.028c.13-.415 1-.851 2.092-1.221 1-.284 2.595-2.6 3.335-3.183.655-.633 1-1.5 1.963-2.028.85-.5 1.373-2.31 1.656-4.119 0 0-2.464.565-3.183.721a6.9 6.9 0 00-2.747 1.718c-.631.72-1.22 1.942-1.809 2.225-.567.284-1.286 2.028-1.286 3.248v2.595z"
				fill="none"
				stroke="#000"
				strokeWidth={0.347}
			/>
			<path
				d="M442.937 268.719s-.13-1.722-.13-2.528c0-.85-.567-3.248.719-5.145.85-1.283 4.12-3.772 4.992-3.9a13.109 13.109 0 01.436 3.03c-.13.72-.937 3.683-1.591 3.988-.633.283-2.377 3.772-4.426 4.556"
				fill="#090"
			/>
			<path
				d="M442.937 268.719s-.13-1.722-.13-2.528c0-.85-.567-3.248.719-5.145.85-1.283 4.12-3.772 4.992-3.9a13.109 13.109 0 01.436 3.03c-.13.72-.937 3.683-1.591 3.988-.633.283-2.377 3.772-4.426 4.556"
				fill="none"
				stroke="#000"
				strokeWidth={0.347}
			/>
			<path
				d="M442.2 270.028c-.349.632-.13-2.225-1-2.9a3.707 3.707 0 01-1-2.965 9.552 9.552 0 01.415-2.81c.066-.72 2.311-3.773 2.158-4.621 0 0 1.286 2.807 1.59 3.616.5 1-.282 2.093-.13 2.963.13.852.85 2.465.35 3.337-.5.785-1.81 2.377-2.4 3.4"
				fill="#090"
			/>
			<path
				d="M442.2 270.028c-.349.632-.13-2.225-1-2.9a3.707 3.707 0 01-1-2.965 9.552 9.552 0 01.415-2.81c.066-.72 2.311-3.773 2.158-4.621 0 0 1.286 2.807 1.59 3.616.5 1-.282 2.093-.13 2.963.13.852.85 2.465.35 3.337-.5.785-1.81 2.377-2.4 3.4z"
				fill="none"
				stroke="#000"
				strokeWidth={0.347}
			/>
			<path
				d="M449.979 254.857s.131-.442 1.5-.442c1.286 0 3.183-.061 3.772-.714a11.374 11.374 0 012.157-1.595 5.57 5.57 0 001.81-2.244c.131-.564 1.155-1.72 1.591-1.72a11.131 11.131 0 00-3.4.348c-1.723.345-4.208 1.283-4.775 2.46a38.561 38.561 0 01-2.68 3.907"
				fill="#090"
			/>
			<path
				d="M449.979 254.857s.131-.442 1.5-.442c1.286 0 3.183-.061 3.772-.714a11.374 11.374 0 012.157-1.595 5.57 5.57 0 001.81-2.244c.131-.564 1.155-1.72 1.591-1.72a11.131 11.131 0 00-3.4.348c-1.723.345-4.208 1.283-4.775 2.46a38.561 38.561 0 01-2.68 3.907z"
				fill="none"
				stroke="#000"
				strokeWidth={0.347}
			/>
			<path
				d="M450.48 254.572c.284 1 2.747-1 3.336-1.724.567-.72 1.439-1.875 1.439-1.875a20.088 20.088 0 001.722-2.372c.937-1.6.719-4.493.348-4.275-.5.284-2.093 1.222-2.528 1.374a2.409 2.409 0 00-1.592 1.132 7.288 7.288 0 01-1.068 2.243c-.348.441-3.03 1.875-1.657 5.5"
				fill="#090"
			/>
			<path
				d="M450.48 254.572c.284 1 2.747-1 3.336-1.724.567-.72 1.439-1.875 1.439-1.875a20.088 20.088 0 001.722-2.372c.937-1.6.719-4.493.348-4.275-.5.284-2.093 1.222-2.528 1.374a2.409 2.409 0 00-1.592 1.132 7.288 7.288 0 01-1.068 2.243c-.348.441-3.03 1.875-1.657 5.5"
				fill="none"
				stroke="#000"
				strokeWidth={0.347}
			/>
			<path
				d="M449.543 254.572s2.026-1.44 2.812-2.16c.85-.847.414-2.026.85-2.595.349-.564 1.439-1.936 1.155-2.812-.282-.849-.849-3.332-.849-3.332a19.352 19.352 0 00-1.722 1.719 4.085 4.085 0 00-1.222 2.182 19.313 19.313 0 01-1.155 2.243 7.594 7.594 0 00.131 3.03 6.6 6.6 0 010 1.724"
				fill="#090"
			/>
			<path
				d="M449.543 254.572s2.026-1.44 2.812-2.16c.85-.847.414-2.026.85-2.595.349-.564 1.439-1.936 1.155-2.812-.282-.849-.849-3.332-.849-3.332a21.681 21.681 0 00-1.744 1.719 4.077 4.077 0 00-1.221 2.182 19.467 19.467 0 01-1.156 2.243 7.63 7.63 0 00.13 3.03 6.551 6.551 0 010 1.724z"
				fill="none"
				stroke="#000"
				strokeWidth={0.347}
			/>
			<path
				d="M481.96 347.068s-9.636-.068-10.508-1.284m16.11 2.528s-6.3 1.72-9.635 1.284a17.682 17.682 0 00-5.712.284 31.069 31.069 0 01-4.426-1.507m26.226 2.272s-4.84.847-5.865 1.155c-1 .279-5.93 2.153-7.455 2.153-1.155 0-4.055-.06-4.84 0a17.3 17.3 0 01-6.147-.412m5.951-14.515a30.606 30.606 0 014.272 2.9c.568.786 3.837 3.4 4.426 3.4m-8.7-10.882s6.3 5.43 7.325 6.15c1.068.78 7.238 6.736 7.979 7.695M480.8 332.133s4.992 3.99 5.581 5.582a15.8 15.8 0 002.006 3.465s2.092 4.124 2.811 4.71a28.377 28.377 0 003.99 3.248m-42.815-20.71s5.21 4.425 6.67 5.273m-8.937-2.438a65.571 65.571 0 007.608 4.553 41.48 41.48 0 009.418 2.31m2.048 2.054s-5.864-.284-6.888 0c-1 .28-5.581-.72-6.736-1s-5.865-1.155-6.453-1.289m11.162-17.5a17.586 17.586 0 00.13 4.554c.414 1.289 2.441 5.056 2.311 6.016-.13.853 1.155 4.838 2.377 5.58m1.2-15.586s-1 3.186-.567 4.274a13.366 13.366 0 011.134 4.119 12.1 12.1 0 001 3.622c.283.72-.131 3.248.565 3.9.721.788 1.659 2.094 1.659 2.094m-35.207-25.465s4.708 1.725 5.3 2.9c.5 1.156 1.439 1.5 1.875 2.093m10.092-9.42s1.222 4.71.939 5.865a24.8 24.8 0 00-.283 4.426c0 .854-1.287 4.425-1.222 4.994m-1.308-19.208s-.435 2.745-.566 3.906a26.5 26.5 0 01-.284 3.834c-.283.72-.72 4.62 0 6.451m-12.077-10.267s3.836 3.247 4.71 4.123c.849.848 4.839 5.056 4.99 6.144.131 1 2.9 4.209 3.773 5m-19.926-31.676s3.837 3.771 4.12 4.621a7.523 7.523 0 002.682 2.813m11.118-5.82s-1.439 2.157-1.439 2.9a7.821 7.821 0 01-1.155 3.4 7.541 7.541 0 00-1.5 3.9m2.942-16.37s-.566 2.027-.85 3.467-1.069 2.964-1.286 3.836c-.283.85-1.5 5.145-1.068 7.761M434.3 287.947a7.005 7.005 0 001.44 3.03c1 1 2.593 2.529 2.746 3.335.13.937 1.5 5.275 2.965 6.8a5.377 5.377 0 011.592 2.964m-10.268-31.085a29.019 29.019 0 00.719 3.181c.283.72 1.5 3.99 2.682 4.993m9.286-7.52a15.394 15.394 0 00-.85 2.964 14.452 14.452 0 01-1.22 2.31c-.131.414-.72 1.94-.72 1.94m5.406-5.187c-.13.937-1.809 3.552-1.874 3.989-.2.5-1 2.529-1.94 3.117-.85.567-3.467 2.463-3.335 3.249m-4.318-16s-.13 3.183.414 4.338a27.422 27.422 0 011.592 3.836 12.479 12.479 0 01.414 3.337c.2 1.068.567 2.964 1.222 3.683m11.532-25.2s-2.16 2.377-3.118 3.4c-.938.936-4.709 4.991-4.84 5.71m4.4-11.29s-2.027 4.486-2.529 5.206a14.752 14.752 0 00-.784 1.942m-1.985-7.305s.132 3.555 0 4.425a9.656 9.656 0 000 2.75 28.417 28.417 0 01-.567 4.425m17.615-20.73a61.769 61.769 0 00-5.428 3.55m2.594-7.194l-3.183 4.627-.72 1.372m.284-6.435a18.428 18.428 0 00-1.155 3.466 29.505 29.505 0 01-2.245 5.43"
				fill="none"
				stroke="#000"
				strokeWidth={0.173}
			/>
			<path
				d="M501.273 348.027s.633-1.808 2.159-.195c0 0 1.744 4.118.414 4.27-1.286.133-2.594.418-2.747-.28a21.206 21.206 0 01.131-3.772"
				fill="#004bb3"
			/>
			<path
				d="M503.148 347.375s.414-6.235 1.286-6.586c.85-.285 3.554-1.724 5.146-.413 1.591 1.35.13 7.824-.414 8.477-.567.57-1.44 2.377-4.84 1.942l-.414-1.59a8.439 8.439 0 002.9-.787c1.22-.564 1.59-1.066 1.5-1.72-.131-.853-.065-4.123-1-4.424-.85-.286-2.246-.721-2.246-.721s-1.285 4.928-1.59 6.3l-.283-.418m-2.072 4.364s-6.082 3.466-2.964 8.763a2.649 2.649 0 01-2.093-1.284S495 361.37 496 362.526c0 0-4.12-3.688-.937-8.047 3.248-4.426 5.864-4.119 5.864-4.119l.2 1.44"
				fill="#004bb3"
			/>
			<path
				d="M501.121 351.8s-6.082 3.465-2.964 8.762a2.649 2.649 0 01-2.093-1.284S495 361.37 496 362.526c0 0-4.12-3.688-.937-8.047 3.248-4.426 5.864-4.119 5.864-4.119l.2 1.44"
				fill="none"
				stroke="#000"
				strokeWidth={0.232}
			/>
			<path
				d="M501.121 348.9a8.206 8.206 0 00-6.43-.781s-1.744-5.431-1.069-7.178a1.159 1.159 0 01.85-.847s-1.874-1.156-1.285 3.99c.566 5.145 1.59 6.585 1.59 6.585s4.993.279 6.148-.285l.2-1.44"
				fill="#004bb3"
			/>
			<path
				d="M501.121 348.9a8.206 8.206 0 00-6.43-.781s-1.744-5.431-1.069-7.178a1.159 1.159 0 01.85-.847s-1.874-1.156-1.285 3.99c.566 5.145 1.59 6.585 1.59 6.585s4.993.279 6.148-.285l.2-1.44z"
				fill="none"
				stroke="#000"
				strokeWidth={0.232}
			/>
			<path
				d="M501.121 348.9s-5.275-8.851-6.67-8.851c0 0-1.5-.2 1.874-.564 1.22-.134 3.118 0 3.99 1.658.937 1.59 1.591 5.358 1.94 5.927a1.91 1.91 0 00-1.155 1.808"
				fill="#004bb3"
			/>
			<path
				d="M501.121 348.9s-5.275-8.851-6.67-8.851c0 0-1.5-.2 1.874-.564 1.22-.134 3.118 0 3.99 1.658.937 1.59 1.591 5.358 1.94 5.927a1.91 1.91 0 00-1.155 1.808z"
				fill="none"
				stroke="#000"
				strokeWidth={0.232}
			/>
			<path
				d="M501.121 348.9a36.814 36.814 0 01-3.99-2.093c-.413-.413-1.154-5.363-.784-5.056 0 0-1.374-1.657-1.875-1.657-.283 0-1.285.72-1 2.46a29.393 29.393 0 001.222 5.581 8.412 8.412 0 016.43.788"
				fill="#003"
			/>
			<path
				d="M501.121 348.9a36.814 36.814 0 01-3.99-2.093c-.413-.413-1.154-5.363-.784-5.056 0 0-1.374-1.657-1.875-1.657-.283 0-1.285.72-1 2.46a29.393 29.393 0 001.222 5.581 8.412 8.412 0 016.43.788z"
				fill="none"
				stroke="#000"
				strokeWidth={0.232}
			/>
			<path
				d="M504.3 351.8a4.235 4.235 0 011.875 3.4c0 2.158.937 6.149 2.68 7.019 0 0 .415-1.657 1-1.942 0 0 1.723 2.093 2.31 2.093a9.738 9.738 0 01-1-2.813c0-.848-.85-4.27-1.722-5.055a11.931 11.931 0 00-5.145-3.685v1"
				fill="#004bb3"
			/>
			<path
				d="M504.3 351.8a4.235 4.235 0 011.875 3.4c0 2.158.937 6.149 2.68 7.019 0 0 .415-1.657 1-1.942 0 0 1.723 2.093 2.31 2.093a9.738 9.738 0 01-1-2.813c0-.848-.85-4.27-1.722-5.055a11.931 11.931 0 00-5.145-3.685v.983z"
				fill="none"
				stroke="#000"
				strokeWidth={0.232}
			/>
			<path
				d="M505.045 341.487l-1.59 6.3.413 1.373a1.332 1.332 0 00.85-.847c.283-.788 1.156-6.151 1.657-6.39l-1.375-.414"
				fill="#003"
			/>
			<path
				d="M505.045 341.487l-1.59 6.3.413 1.373a1.332 1.332 0 00.85-.847c.283-.788 1.156-6.151 1.657-6.39l-1.375-.414z"
				fill="none"
				stroke="#000"
				strokeWidth={0.232}
			/>
			<path
				d="M501.056 351.08s-2.9.848-3.99 3.114c0 0-.348-1.434 3.837-3.465l.131.35m3.356 0s2.029.782 2.53 1.936a27.232 27.232 0 00-2.529-1.434v-.5m-3.335-1.68s-4.491.72-5.516.5a23.591 23.591 0 005.582-.068l-.066-.413m7.26-2.767s.5 2.243.85 2.16c.348-.2 1.067-3.773 1.154-5.5.066-1.59-.719-2.026-1.35-1.875-.633 0-1 1.507-.938 2.16a27.323 27.323 0 00.283 3.03"
				fill="#00004b"
			/>
			<path
				d="M503.454 347.81s1.81 4.052.414 4.269c-1.373.2.567.133-.349-2.59-.348-1.071-.938-2.376-1.221-2.376 0 0 1 .412 1.156.719"
				fill="#00004b"
			/>
			<path
				d="M501.273 348.027s.633-1.808 2.159-.195c0 0 1.744 4.118.414 4.27-1.286.133-2.594.418-2.747-.28a21.206 21.206 0 01.131-3.772zm1.875-.652s.414-6.235 1.286-6.586c.85-.285 3.554-1.724 5.146-.413 1.591 1.35.13 7.824-.414 8.477-.567.57-1.44 2.377-4.84 1.942l-.414-1.59a8.439 8.439 0 002.9-.787c1.22-.564 1.59-1.066 1.5-1.72-.131-.853-.065-4.123-1-4.424-.85-.286-2.246-.721-2.246-.721s-1.285 4.928-1.59 6.3l-.283-.418z"
				fill="none"
				stroke="#000"
				strokeWidth={0.232}
			/>
			<path
				d="M496.63 240.576c-.349-.938-.414-7.238-.349-8.2.066-1.658 3.03-10.007 3.62-10.945.632-.937.413-1.154.72-1.718l.784-1.156a9.574 9.574 0 011.22 3.99 58.628 58.628 0 01-1 5.8 27.2 27.2 0 01-1.723 4.7c-.566 1.222-.5 2.31-.13 2.444l-3.117 5.056"
				fill="#004bb3"
			/>
			<path
				d="M501.624 232.227l.5.5c1.286-1.44 1.374-4.342 1.374-4.342l-.851-5.86a58.677 58.677 0 01-1 5.8 27.424 27.424 0 01-1.721 4.706c-.85 2.092-.2 2.315-.132 2.444l1.876-3.248"
				fill="#fff"
			/>
			<path
				d="M502.146 232.729c1.286-1.44 1.373-4.342 1.373-4.342s.938 4.777.414 5.8c-.5 1-.5.715-.414 1.218l-1.373-2.68"
				fill="#004bb3"
			/>
			<path
				d="M503.52 235.408c-.066-.5-.066-.195.413-1.217.5-1-.414-5.8-.414-5.8l-.85-5.86a9.176 9.176 0 00-1.22-3.99l-.786 1.155c-.282.564-.065.782-.719 1.719-.567.938-3.553 9.27-3.619 10.945-.065.937 0 7.238.349 8.2"
				fill="none"
				stroke="#000"
				strokeWidth={0.347}
			/>
			<path
				d="M501.624 219.3s-.066-.937-.132-1.289c-.066-.129.5.848.937.72a5.743 5.743 0 012.028 1.724c-.35.5-1.221 1.591-1.876 1.374-.5-.135-.414-.938-.566-1.441a3.8 3.8 0 01-.348-1.072"
				fill="#fc0"
			/>
			<path
				d="M501.624 219.3s-.066-.937-.132-1.289c-.066-.129.5.848.937.72a5.743 5.743 0 012.028 1.724c-.35.5-1.221 1.591-1.876 1.374-.5-.135-.414-.938-.566-1.441a3.8 3.8 0 01-.348-1.072z"
				fill="none"
				stroke="#000"
				strokeWidth={0.173}
			/>
			<path
				d="M501.71 218.515c.066.067.283.346.35.435.194.067.348 0 .631.129a9.432 9.432 0 011.505 1.44m-1.92-1.352a5.259 5.259 0 011.81 1.725v-.134"
				fill="none"
				stroke="#000"
				strokeWidth={0.173}
			/>
			<path
				d="M500.75 218.643a10.393 10.393 0 001.134-.63c.131-.068-.632.786-.349 1.133a4.688 4.688 0 01-.937 2.528c-.567-.195-1.22-.195-1.722-1.155-.2-.346.348-.721.72-1.066.195-.135.718-.721 1.155-.787"
				fill="#fc0"
			/>
			<path
				d="M500.75 218.643a10.393 10.393 0 001.134-.63c.131-.068-.632.786-.349 1.133a4.688 4.688 0 01-.937 2.528c-.567-.195-1.22-.195-1.722-1.155-.2-.346.348-.721.72-1.066.195-.135.718-.721 1.155-.787z"
				fill="none"
				stroke="#000"
				strokeWidth={0.173}
			/>
			<path
				d="M501.558 218.365a1.083 1.083 0 00-.284.5c0 .2.13.351.065.636a8.733 8.733 0 01-.785 1.936m.567-2.266a4.6 4.6 0 01-1 2.244h.131"
				fill="none"
				stroke="#000"
				strokeWidth={0.173}
			/>
			<path
				d="M502.06 218.013c.565-.631 1.655-1.284 2.157-.848a2.922 2.922 0 01.567.5c.282.28.2.413.065.781-.349.721-1.352.352-2.027 0-.13-.066-.5-.412-.72-.284-.282.067-.2.067-.282.067.064.135.194.067.282.135a14.754 14.754 0 011.722.78c.5.2 1.44-.412 1.374-.937 0-.5-.85-1.5-1.286-1.5a3.472 3.472 0 00-2.377 1.371c.2-.133.349.129.5-.066"
				fill="#fc0"
			/>
			<path
				d="M502.06 218.013c.565-.631 1.655-1.284 2.157-.848a2.922 2.922 0 01.567.5c.282.28.2.413.065.781-.349.721-1.352.352-2.027 0-.13-.066-.5-.412-.72-.284-.282.067-.2.067-.282.067.064.135.194.067.282.135a14.754 14.754 0 011.722.78c.5.2 1.44-.412 1.374-.937 0-.5-.85-1.5-1.286-1.5a3.472 3.472 0 00-2.377 1.371c.2-.133.349.129.5-.066z"
				fill="none"
				stroke="#000"
				strokeWidth={0.173}
			/>
			<path
				d="M501.558 218.013c-.567-.631-1.657-1.284-2.16-.848a2.37 2.37 0 00-.565.5.674.674 0 00-.066.781c.348.721 1.373.352 2.027 0 .131-.066.5-.412.72-.284.348.067.2.067.348.067-.13.135-.283.067-.414.135-.5.127-.938.5-1.657.78a1.284 1.284 0 01-1.438-.937c.065-.563.938-1.5 1.373-1.5a3.305 3.305 0 012.377 1.371c-.131-.133-.35.129-.5-.066"
				fill="#fc0"
			/>
			<path
				d="M501.558 218.013c-.567-.631-1.657-1.284-2.16-.848a2.37 2.37 0 00-.565.5.674.674 0 00-.066.781c.348.721 1.373.352 2.027 0 .131-.066.5-.412.72-.284.348.067.2.067.348.067-.13.135-.283.067-.414.135-.5.127-.938.5-1.657.78a1.284 1.284 0 01-1.438-.937c.065-.563.938-1.5 1.373-1.5a3.305 3.305 0 012.377 1.371c-.131-.133-.35.129-.5-.066z"
				fill="none"
				stroke="#000"
				strokeWidth={0.173}
			/>
			<path
				d="M501.776 217.645c-.284-.135-.568.127-.655.278-.065.2.065.57.284.57.348.128.85.066.938-.285.065-.346-.284-.413-.567-.563"
				fill="#fc0"
			/>
			<path
				d="M501.776 217.645c-.284-.135-.568.127-.655.278-.065.2.065.57.284.57.348.128.85.066.938-.285.065-.346-.284-.413-.567-.563"
				fill="none"
				stroke="#000"
				strokeWidth={0.173}
			/>
			<path
				d="M501.71 211.757a10.735 10.735 0 001.5 3.9 11.235 11.235 0 00-1.591 2.027 5.6 5.6 0 00-1.5-2.094 13.269 13.269 0 001.591-3.833"
				fill="#fc0"
			/>
			<path
				d="M501.71 211.757a10.735 10.735 0 001.5 3.9 11.235 11.235 0 00-1.591 2.027 5.6 5.6 0 00-1.5-2.094 13.269 13.269 0 001.591-3.833m-.087 2.4a10.247 10.247 0 00.632 1.656 4.063 4.063 0 00-.632.632 2.167 2.167 0 00-.567-.788 3.46 3.46 0 00.567-1.5"
				fill="none"
				stroke="#000"
				strokeWidth={0.173}
			/>
			<path
				d="M528.613 277.2c1.434-3.554 2.963-10.944 2.9-12.623-.284-6.89-.2-8.984-.847-16.087l-7.112 8.2a26.264 26.264 0 01-1 10.267l6.085 10.224"
				fill="#fff"
			/>
			<path
				d="M522.53 266.975a27.289 27.289 0 001-4.991 28.241 28.241 0 000-5.274l-4.428 4.838 3.4 5.427m18.228 6.671c.129-1.591.195-3.335.195-4.12 0-4.992.564-7.76 0-13.056-.35-4.125-1.44-9.638-1.221-14.064.066-1.283-.129-2.528-.129-3.773l-8.918 9.857c.63 7.1.564 9.2.848 16.087.067 1.657-1.44 9.07-2.9 12.622l1.875 3.183 10.224-6.736"
				fill="#004bb3"
			/>
			<path d="M518.452 260.9l20.82-23.066.346.5-20.512 23.194-.632-.63" fill="#fc0" />
			<path
				d="M518.452 260.9l20.82-23.066.346.5-20.512 23.194-.632-.63z"
				fill="none"
				stroke="#000"
				strokeWidth={0.173}
			/>
			<path
				d="M539.076 244.259s-1.657 14.565-7.327 14"
				fill="none"
				stroke="#006"
				strokeWidth={0.232}
			/>
			<path
				d="M531.749 258.188c2.813.135 4.621-3.465 5.715-6.8a41.3 41.3 0 001.59-7.177"
				fill="none"
				stroke="#00056b"
				strokeWidth={0.232}
			/>
			<path
				d="M531.749 258.188c2.813-.128 4.621-3.773 5.648-6.887a42.121 42.121 0 001.657-7.11"
				fill="none"
				stroke="#000b73"
				strokeWidth={0.232}
			/>
			<path
				d="M531.749 258.127c2.813-.2 4.621-3.99 5.648-6.96a47.856 47.856 0 001.657-7.013"
				fill="none"
				stroke="#001178"
				strokeWidth={0.232}
			/>
			<path
				d="M531.749 258.06c2.813-.413 4.621-4.209 5.582-6.954a49.089 49.089 0 001.745-7.02"
				fill="none"
				stroke="#00167c"
				strokeWidth={0.232}
			/>
			<path
				d="M531.666 257.971c2.806-.564 4.7-4.487 5.58-6.953a50.784 50.784 0 001.808-7.018"
				fill="none"
				stroke="#001e85"
				strokeWidth={0.232}
			/>
			<path
				d="M531.666 257.971c2.806-.781 4.7-4.771 5.58-7.02a47.72 47.72 0 001.808-6.951"
				fill="none"
				stroke="#002289"
				strokeWidth={0.232}
			/>
			<path
				d="M531.666 257.91c2.806-.938 4.7-5 5.424-7.11a52.781 52.781 0 001.964-6.888"
				fill="none"
				stroke="#00288f"
				strokeWidth={0.232}
			/>
			<path
				d="M531.666 257.91c2.806-1.223 4.7-5.28 5.424-7.178a62.406 62.406 0 001.964-6.886"
				fill="none"
				stroke="#002d93"
				strokeWidth={0.232}
			/>
			<path
				d="M531.6 257.754c2.9-1.284 4.771-5.426 5.424-7.105a58.951 58.951 0 002.03-6.892"
				fill="none"
				stroke="#00359c"
				strokeWidth={0.232}
			/>
			<path
				d="M531.6 257.754c2.9-1.5 4.771-5.8 5.424-7.172 1-2.595 1.942-6.518 2.03-6.8"
				fill="none"
				stroke="#0039a0"
				strokeWidth={0.232}
			/>
			<path
				d="M531.6 257.686c2.812-1.652 4.771-6.016 5.274-7.17a47.658 47.658 0 002.16-6.8"
				fill="none"
				stroke="#003ea6"
				strokeWidth={0.232}
			/>
			<path
				d="M531.531 257.686c2.9-1.875 4.84-6.295 5.363-7.322a66.792 66.792 0 002.16-6.735"
				fill="none"
				stroke="#0046ad"
				strokeWidth={0.232}
			/>
			<path
				d="M538.988 243.606a39.676 39.676 0 01-2.16 6.67c-.436.785-2.372 5.211-5.274 7.237"
				fill="none"
				stroke="#004bb3"
				strokeWidth={0.232}
			/>
			<path
				d="M538.86 240.927s-4.711 11.6-7.7 10.285"
				fill="none"
				stroke="#006"
				strokeWidth={0.232}
			/>
			<path
				d="M531.163 251.235c1.217.569 3.18-1.719 4.772-4.487q1.574-2.839 2.9-5.8"
				fill="none"
				stroke="#00066d"
				strokeWidth={0.232}
			/>
			<path
				d="M531.163 251.169c1.066.5 3.115-1.653 4.705-4.488q1.621-2.828 2.969-5.8"
				fill="none"
				stroke="#001178"
				strokeWidth={0.232}
			/>
			<path
				d="M531.163 251.169c.848.44 3.03-1.653 4.62-4.555 1.81-3.248 3.031-5.708 3.031-5.708"
				fill="none"
				stroke="#00187e"
				strokeWidth={0.232}
			/>
			<path
				d="M531.1 251.169c.787.283 3.03-1.653 4.71-4.622q1.567-2.826 3.03-5.708"
				fill="none"
				stroke="#002086"
				strokeWidth={0.232}
			/>
			<path
				d="M531.1 251.084c.631.285 2.963-1.59 4.621-4.62 1.942-3.556 3.03-5.715 3.03-5.715"
				fill="none"
				stroke="#002b91"
				strokeWidth={0.232}
			/>
			<path
				d="M531.1 251.084c.413.195 2.9-1.59 4.621-4.777l3.03-5.642"
				fill="none"
				stroke="#039"
				strokeWidth={0.232}
			/>
			<path
				d="M531.1 251.084c.284.128 2.813-1.59 4.554-4.838 2.093-3.84 3.03-5.582 3.03-5.582"
				fill="none"
				stroke="#0039a0"
				strokeWidth={0.232}
			/>
			<path
				d="M531.1 251.084a12.226 12.226 0 004.493-4.838c2.154-4.057 3.114-5.648 3.114-5.648"
				fill="none"
				stroke="#0045ab"
				strokeWidth={0.232}
			/>
			<path
				d="M538.7 240.576s-.938 1.373-3.181 5.49a12.5 12.5 0 01-4.493 4.93m-7.494 8l-3.993 2.16m3.708 1.612l-3.686-.636"
				fill="none"
				stroke="#004bb3"
				strokeWidth={0.232}
			/>
			<path
				d="M523.617 259.215l-4.053 1.943"
				fill="none"
				stroke="#0045ab"
				strokeWidth={0.232}
			/>
			<path
				d="M523.534 259.366l-4.057 1.875"
				fill="none"
				stroke="#003ca2"
				strokeWidth={0.232}
			/>
			<path
				d="M523.534 259.583l-4.057 1.658"
				fill="none"
				stroke="#00359c"
				strokeWidth={0.232}
			/>
			<path
				d="M523.534 259.718l-4.123 1.59"
				fill="none"
				stroke="#002d93"
				strokeWidth={0.232}
			/>
			<path
				d="M523.534 259.868l-4.123 1.44"
				fill="none"
				stroke="#00258b"
				strokeWidth={0.232}
			/>
			<path
				d="M523.534 260.086l-4.123 1.223"
				fill="none"
				stroke="#001e85"
				strokeWidth={0.232}
			/>
			<path
				d="M523.534 260.237l-4.21 1.154"
				fill="none"
				stroke="#00167c"
				strokeWidth={0.232}
			/>
			<path
				d="M523.534 260.46l-4.275.931"
				fill="none"
				stroke="#000f75"
				strokeWidth={0.232}
			/>
			<path
				d="M523.534 260.589l-4.275.847"
				fill="none"
				stroke="#00066d"
				strokeWidth={0.232}
			/>
			<path
				d="M523.31 262.615l-3.833-.565"
				fill="none"
				stroke="#0045ab"
				strokeWidth={0.232}
			/>
			<path
				d="M523.31 262.4l-3.833-.413"
				fill="none"
				stroke="#003ca2"
				strokeWidth={0.232}
			/>
			<path
				d="M523.31 262.178l-3.9-.284"
				fill="none"
				stroke="#00359c"
				strokeWidth={0.232}
			/>
			<path
				d="M523.31 262.05l-3.9-.134"
				fill="none"
				stroke="#002d93"
				strokeWidth={0.232}
			/>
			<path d="M523.31 261.833h-3.986" fill="none" stroke="#00258b" strokeWidth={0.232} />
			<path
				d="M523.4 261.615l-4.12.128"
				fill="none"
				stroke="#001e85"
				strokeWidth={0.232}
			/>
			<path
				d="M523.4 261.391l-4.12.286"
				fill="none"
				stroke="#00167c"
				strokeWidth={0.232}
			/>
			<path
				d="M523.467 261.241l-4.273.351"
				fill="none"
				stroke="#000f75"
				strokeWidth={0.232}
			/>
			<path
				d="M523.467 261.023l-4.273.57"
				fill="none"
				stroke="#00066d"
				strokeWidth={0.232}
			/>
			<path
				d="M523.467 260.806l-4.339.72"
				fill="none"
				stroke="#006"
				strokeWidth={0.232}
			/>
			<path
				d="M540.734 273.646a28.761 28.761 0 00.129-3.117c0-4.993.63-8.764.066-14.06-.35-4.124-1.44-9.637-1.221-14.063.066-1.283-.129-2.528-.129-3.773l-20.45 22.915"
				fill="none"
				stroke="#000"
				strokeWidth={0.232}
			/>
			<path
				d="M540.734 261.894a17.139 17.139 0 01-.938 4.34c-.937 1.875-3.772 4.621-7.02 6.671"
				fill="none"
				stroke="#006"
				strokeWidth={0.232}
			/>
			<path
				d="M532.687 272.926a28.555 28.555 0 005.363-4.49 12.982 12.982 0 001.59-2.245 15.238 15.238 0 001-4.336"
				fill="none"
				stroke="#00056b"
				strokeWidth={0.232}
			/>
			<path
				d="M532.6 272.926a28.323 28.323 0 005.274-4.621 13.218 13.218 0 001.657-2.158 16.79 16.79 0 001.066-4.337"
				fill="none"
				stroke="#000b73"
				strokeWidth={0.232}
			/>
			<path
				d="M532.536 272.926a30.018 30.018 0 005.207-4.621A15.024 15.024 0 00539.4 266a16.553 16.553 0 001.221-4.34"
				fill="none"
				stroke="#001178"
				strokeWidth={0.232}
			/>
			<path
				d="M532.47 272.861a34.728 34.728 0 005.144-4.621 9.572 9.572 0 001.658-2.311 17.2 17.2 0 001.374-4.336"
				fill="none"
				stroke="#00167c"
				strokeWidth={0.232}
			/>
			<path
				d="M532.38 272.861a33.2 33.2 0 005.145-4.709 16.83 16.83 0 001.6-2.31 17.134 17.134 0 001.524-4.339"
				fill="none"
				stroke="#001e85"
				strokeWidth={0.232}
			/>
			<path
				d="M532.319 272.861a31.313 31.313 0 005.078-4.84 12.606 12.606 0 001.657-2.244 26.293 26.293 0 001.59-4.34"
				fill="none"
				stroke="#002289"
				strokeWidth={0.232}
			/>
			<path
				d="M532.251 272.861a31.683 31.683 0 005-4.926 16.491 16.491 0 001.652-2.246 26.4 26.4 0 001.747-4.337"
				fill="none"
				stroke="#00288f"
				strokeWidth={0.232}
			/>
			<path
				d="M532.162 272.861a32.291 32.291 0 005-4.991 14.374 14.374 0 001.59-2.246 28.094 28.094 0 001.875-4.338"
				fill="none"
				stroke="#002d93"
				strokeWidth={0.232}
			/>
			<path
				d="M532.1 272.861a45.035 45.035 0 004.923-5.058 13.626 13.626 0 001.6-2.31 32.516 32.516 0 001.937-4.335"
				fill="none"
				stroke="#00359c"
				strokeWidth={0.232}
			/>
			<path
				d="M532.034 272.861a41.421 41.421 0 004.839-5.144 16.6 16.6 0 001.59-2.311 38.844 38.844 0 002.093-4.338"
				fill="none"
				stroke="#0039a0"
				strokeWidth={0.232}
			/>
			<path
				d="M531.944 272.861c1.943-1.5 3.84-4.12 4.845-5.21a15.366 15.366 0 001.5-2.31 42.487 42.487 0 002.245-4.34"
				fill="none"
				stroke="#003ea6"
				strokeWidth={0.232}
			/>
			<path
				d="M531.883 272.774a34.958 34.958 0 004.772-5.21 21.406 21.406 0 001.568-2.311c1.155-1.942 2.31-4.335 2.31-4.335"
				fill="none"
				stroke="#0046ad"
				strokeWidth={0.232}
			/>
			<path
				d="M540.577 260.806a60.427 60.427 0 01-4.051 6.67c-.937 1-2.751 3.772-4.71 5.277"
				fill="none"
				stroke="#004bb3"
				strokeWidth={0.232}
			/>
			<path
				d="M540.516 273.646c-2.968 2.028-3.772 2.528-10 6.518l-1.876-2.965s.72-1.656 1-2.528"
				fill="none"
				stroke="#00004b"
				strokeWidth={0.232}
			/>
			<path
				d="M540.45 273.646c-2.814 1.94-3.84 2.528-9.923 6.365l-.061-.065-1.725-2.812s.134-.349.285-.784a7.225 7.225 0 00.63-1.657"
				fill="none"
				stroke="#00004f"
				strokeWidth={0.232}
			/>
			<path
				d="M540.45 273.646c-2.746 1.876-4.058 2.681-9.923 6.3l-.061-.13c0-.066-1.591-2.813-1.591-2.813a3.4 3.4 0 01.28-.719c.2-.5.35-1.156.5-1.591"
				fill="none"
				stroke="#000053"
				strokeWidth={0.232}
			/>
			<path
				d="M540.45 273.646c-2.685 1.723-4.119 2.681-9.923 6.147l-.061-.13c0-.066-1.507-2.747-1.507-2.747s.067-.283.2-.72c.2-.5.418-1.068.57-1.5"
				fill="none"
				stroke="#000056"
				strokeWidth={0.232}
			/>
			<path
				d="M540.45 273.581c-2.6 1.722-4.342 2.811-9.923 6.082l-.061-.066c0-.13-1.374-2.812-1.374-2.812a2.578 2.578 0 01.129-.632 9.834 9.834 0 00.5-1.439"
				fill="none"
				stroke="#000058"
				strokeWidth={0.232}
			/>
			<path
				d="M540.45 273.581c-2.528 1.656-4.493 2.9-9.923 6.016l-.061-.13c0-.2-1.29-2.812-1.29-2.812a1.879 1.879 0 01.134-.567 5.585 5.585 0 00.413-1.374"
				fill="none"
				stroke="#00005c"
				strokeWidth={0.232}
			/>
			<path
				d="M540.45 273.581c-2.377 1.59-4.622 2.964-9.923 5.864l-.061-.131c0-.2-1.156-2.747-1.156-2.747a.945.945 0 01.062-.566 9.072 9.072 0 00.35-1.286"
				fill="none"
				stroke="#000060"
				strokeWidth={0.232}
			/>
			<path
				d="M540.45 273.581c-2.31 1.5-4.839 2.964-9.923 5.712l-.061-.132c0-.2-1.072-2.747-1.072-2.747s-.061-.13.067-.5a4.927 4.927 0 00.285-1.221"
				fill="none"
				stroke="#000062"
				strokeWidth={0.232}
			/>
			<path
				d="M540.36 273.581c-2.16 1.439-4.928 3.03-9.85 5.646l-.067-.131c0-.283-1-2.747-.937-2.747 0 0-.134-.13 0-.5a3.55 3.55 0 00.2-1.155"
				fill="none"
				stroke="#006"
				strokeWidth={0.232}
			/>
			<path
				d="M540.36 273.516a82.979 82.979 0 01-9.85 5.58c-.067 0-.067-.13-.067-.13 0-.283-.854-2.748-.854-2.748s-.128-.065 0-.414a2.761 2.761 0 00.134-1.068"
				fill="none"
				stroke="#00056b"
				strokeWidth={0.232}
			/>
			<path
				d="M540.36 273.516a78.009 78.009 0 01-9.85 5.427c-.067 0-.067-.065-.134-.13a16.441 16.441 0 00-.72-2.682h.067a.317.317 0 01-.067-.414 2.415 2.415 0 00.067-1"
				fill="none"
				stroke="#00066d"
				strokeWidth={0.232}
			/>
			<path
				d="M540.36 273.516a76.082 76.082 0 01-9.85 5.362c-.067-.066-.067-.131-.134-.195 0-.285-.563-2.595-.563-2.595s-.2-.131-.068-.436a1.512 1.512 0 000-.938"
				fill="none"
				stroke="#00096f"
				strokeWidth={0.232}
			/>
			<path
				d="M540.36 273.516a78.353 78.353 0 01-9.85 5.21l-.134-.132c0-.414-.5-2.68-.5-2.68s-.194-.066-.128-.35a1.286 1.286 0 00.067-.85"
				fill="none"
				stroke="#000b73"
				strokeWidth={0.232}
			/>
			<path
				d="M540.36 273.516a68.1 68.1 0 01-9.917 5.078l-.067-.13c0-.436-.413-2.595-.346-2.681 0 0-.284-.066-.133-.284.066-.349 0-.349-.068-.785"
				fill="none"
				stroke="#001178"
				strokeWidth={0.232}
			/>
			<path
				d="M540.36 273.516a65.649 65.649 0 01-9.917 4.991.644.644 0 00-.067-.195c0-.415-.346-2.6-.284-2.6 0 0-.279-.065-.195-.283.133-.284 0-.284-.068-.72"
				fill="none"
				stroke="#001379"
				strokeWidth={0.232}
			/>
			<path
				d="M540.293 273.428a47.69 47.69 0 01-9.85 4.927l-.067-.2c0-.414-.195-2.53-.129-2.595 0 0-.35 0-.284-.195.067-.284-.066-.284-.133-.634"
				fill="none"
				stroke="#00167c"
				strokeWidth={0.232}
			/>
			<path
				d="M540.293 273.428a45.953 45.953 0 01-9.85 4.773l-.067-.13c0-.5-.129-2.594-.067-2.681 0 0-.346.065-.279-.13.129-.284-.067-.2-.2-.567"
				fill="none"
				stroke="#001c82"
				strokeWidth={0.232}
			/>
			<path
				d="M540.293 273.363a44.1 44.1 0 01-9.85 4.773.662.662 0 00-.067-.2c0-.566 0-2.529.067-2.594 0 0-.413.065-.351-.13.067-.283-.129-.13-.195-.5"
				fill="none"
				stroke="#001e85"
				strokeWidth={0.232}
			/>
			<path
				d="M540.293 273.363c-1.217.85-6.518 3.836-9.85 4.621a.641.641 0 00-.067-.2 23.465 23.465 0 01.135-2.594s-.5.13-.352-.066c.067-.195-.195-.065-.285-.414"
				fill="none"
				stroke="#002086"
				strokeWidth={0.232}
			/>
			<path
				d="M540.232 273.363c-1.094.785-6.586 3.9-9.789 4.49a.642.642 0 01-.067-.195 21.363 21.363 0 01.2-2.53h.068s-.5.066-.413-.065c.061-.195-.2 0-.352-.349"
				fill="none"
				stroke="#00258b"
				strokeWidth={0.232}
			/>
			<path
				d="M540.232 273.363c-1 .719-6.736 3.989-9.789 4.425a.235.235 0 01-.067-.2 13.726 13.726 0 01.352-2.53s-.5.066-.5-.065c.128-.195-.2.066-.352-.282"
				fill="none"
				stroke="#00288f"
				strokeWidth={0.232}
			/>
			<path
				d="M540.232 273.363c-.937.632-6.893 4.054-9.789 4.272-.067-.065-.067-.13-.134-.195a20.572 20.572 0 01.5-2.53s-.565.131-.436 0c.067-.2-.346.131-.5-.2"
				fill="none"
				stroke="#002b91"
				strokeWidth={0.232}
			/>
			<path
				d="M540.232 273.363c-.877.5-7.021 4.054-9.789 4.207a1.709 1.709 0 00-.134-.282 9.8 9.8 0 01.658-2.53s-.569.131-.569.066c.068-.2-.284.195-.5-.131"
				fill="none"
				stroke="#002d93"
				strokeWidth={0.232}
			/>
			<path
				d="M540.232 273.3c-.787.5-7.238 4.207-9.789 4.12a.484.484 0 01-.134-.284 8.12 8.12 0 01.72-2.463s-.564.13-.564 0c.062-.065-.351.349-.568 0"
				fill="none"
				stroke="#039"
				strokeWidth={0.232}
			/>
			<path
				d="M540.232 273.3c-.636.5-7.394 4.272-9.789 3.989-.067-.066-.134-.13-.134-.2a6.5 6.5 0 01.854-2.529s-.72.195-.636.13c.067-.13-.346.35-.63 0"
				fill="none"
				stroke="#00359c"
				strokeWidth={0.232}
			/>
			<path
				d="M540.232 273.3c-.57.348-7.545 4.337-9.789 3.836-.067 0-.134-.13-.134-.195a6.939 6.939 0 01.938-2.465v-.065s-.72.283-.63.2c.066-.132-.413.414-.721.065"
				fill="none"
				stroke="#00389e"
				strokeWidth={0.232}
			/>
			<path
				d="M540.165 273.3c-.413.282-7.674 4.337-9.7 3.77a2.143 2.143 0 01-.194-.282 6.361 6.361 0 011.154-2.465s-.72.285-.72.2c0-.13-.5.5-.72.13"
				fill="none"
				stroke="#003ca2"
				strokeWidth={0.232}
			/>
			<path
				d="M540.165 273.3c-.351.195-7.824 4.425-9.7 3.619a2.313 2.313 0 01-.194-.284c0-.785 1.154-2.312 1.216-2.464 0 0-.782.35-.72.2 0 0-.5.633-.782.284"
				fill="none"
				stroke="#003ea6"
				strokeWidth={0.232}
			/>
			<path
				d="M540.165 273.3c-.285.13-7.98 4.49-9.789 3.552a.445.445 0 00-.129-.282 6.163 6.163 0 011.284-2.465s-.78.285-.72.285c0-.067-.564.567-.847.282"
				fill="none"
				stroke="#0042a8"
				strokeWidth={0.232}
			/>
			<path
				d="M540.165 273.21c-.195.13-8.2 4.621-9.789 3.466 0-.065-.129-.13-.129-.283a4.79 4.79 0 011.435-2.377l-.78.284s-.632.633-.939.349"
				fill="none"
				stroke="#0045ab"
				strokeWidth={0.232}
			/>
			<path
				d="M540.165 273.21c-.068.065-8.327 4.709-9.789 3.335 0-.065-.129-.13-.129-.282 0-.938 1.435-2.312 1.5-2.377l-.782.283s-.658.786-1 .5"
				fill="none"
				stroke="#0049af"
				strokeWidth={0.232}
			/>
			<path
				d="M540.165 273.146s-9.482 5.361-9.917 2.963c0-.937 1.59-2.31 1.59-2.31l-.853.283s-.653.85-1 .567"
				fill="none"
				stroke="#004bb3"
				strokeWidth={0.232}
			/>
			<path
				d="M539.139 237.808c-.063-.938-.565-2.026-1.218-2.026a4.942 4.942 0 00-.786.061c-.346.134-.413.285-.5.636-.128.781.938 1.066 1.658 1.156.128 0 .653-.068.786.128.129.285.062.195.129.285a.444.444 0 01-.285-.135c-.564-.127-1.065-.127-1.875-.278-.563-.068-.937-1.156-.63-1.591.35-.351 1.59-.72 1.964-.42a3.169 3.169 0 011.155 2.468c-.067-.194-.35-.067-.35-.284"
				fill="#fc0"
			/>
			<path
				d="M539.139 237.808c-.063-.938-.565-2.026-1.218-2.026a4.942 4.942 0 00-.786.061c-.346.134-.413.285-.5.636-.128.781.938 1.066 1.658 1.156.128 0 .653-.068.786.128.129.285.062.195.129.285a.444.444 0 01-.285-.135c-.564-.127-1.065-.127-1.875-.278-.563-.068-.937-1.156-.63-1.591.35-.351 1.59-.72 1.964-.42a3.169 3.169 0 011.155 2.468c-.067-.194-.35-.067-.35-.284z"
				fill="none"
				stroke="#000"
				strokeWidth={0.173}
			/>
			<path
				d="M539.579 238.092c.847-.284 2.092-.134 2.31.413 0 .067.2.563.128.787.068.346-.066.5-.346.715-.72.35-1.378-.5-1.657-1.156a1.518 1.518 0 00-.418-.714c-.346-.068-.2 0-.346-.068.067.13.2.2.284.285.346.5.5.938.938 1.653.2.5 1.35.5 1.657.067a2.575 2.575 0 00-.2-2.026 3.015 3.015 0 00-2.747-.195c.195-.068.195.284.436.195"
				fill="#fc0"
			/>
			<path
				d="M539.579 238.092c.847-.284 2.092-.134 2.31.413a2 2 0 01.128.787c.068.346-.066.5-.346.715-.72.35-1.378-.5-1.657-1.156a1.518 1.518 0 00-.418-.714c-.346-.068-.2 0-.346-.068.067.13.2.2.284.285.346.5.5.938.938 1.653.2.5 1.35.5 1.657.067a2.575 2.575 0 00-.2-2.026 3.015 3.015 0 00-2.747-.195c.195-.068.195.284.436.195z"
				fill="none"
				stroke="#000"
				strokeWidth={0.173}
			/>
			<path
				d="M539.64 237.673c.285 0 .351.42.285.637 0 .194-.346.345-.57.284-.345-.133-.63-.419-.5-.786.061-.352.5-.195.781-.135"
				fill="#fc0"
			/>
			<path
				d="M539.64 237.673c.285 0 .351.42.285.637 0 .194-.346.345-.57.284-.345-.133-.63-.419-.5-.786.061-.352.5-.195.781-.135"
				fill="none"
				stroke="#000"
				strokeWidth={0.173}
			/>
			<path
				d="M543.72 233.532a15.016 15.016 0 01-4.057 2.032 5.785 5.785 0 010 2.244 5.529 5.529 0 012.528-.5 9.226 9.226 0 011.507-3.773"
				fill="#fc0"
			/>
			<path
				d="M543.72 233.532a15.016 15.016 0 01-4.057 2.032 5.785 5.785 0 010 2.244 5.529 5.529 0 012.528-.5 9.226 9.226 0 011.507-3.773z"
				fill="none"
				stroke="#000"
				strokeWidth={0.173}
			/>
			<path
				d="M542.13 235.19a6.738 6.738 0 01-1.658.787 1.829 1.829 0 010 .848 2.8 2.8 0 011-.128 4 4 0 01.636-1.507z"
				fill="none"
				stroke="#000"
				strokeWidth={0.173}
			/>
			<path
				d="M539.947 239.549s-.569-.63-.787-.937c-.128-.129.285.937-.128 1.221a5.351 5.351 0 000 2.595 2.4 2.4 0 002.093-.345c.284-.285-.134-.855-.352-1.29-.128-.195-.346-.937-.781-1.222"
				fill="#fc0"
			/>
			<path
				d="M539.947 239.549s-.569-.63-.787-.937c-.128-.129.285.937-.128 1.221a5.351 5.351 0 000 2.595 2.4 2.4 0 002.093-.345c.284-.285-.134-.855-.352-1.29-.128-.195-.346-.937-.781-1.222z"
				fill="none"
				stroke="#000"
				strokeWidth={0.173}
			/>
			<path
				d="M539.356 239.113c0 .068.067.42.067.5-.068.195-.285.284-.285.569a8.175 8.175 0 00.068 2.154m.217-2.416a6.081 6.081 0 00.134 2.46h-.134m.156-.937a3.658 3.658 0 01.129.938c.066-.062.194.067.284.067"
				fill="none"
				stroke="#000"
				strokeWidth={0.173}
			/>
			<path
				d="M501.624 326.9c-.066 0-.2-.134-.285-.195-.414-.2-1.067-.2-1.286-.42-1-1.154-.283-3.33.066-4.7a58.156 58.156 0 001.5-7.238h.065c.567 2.378.633 4.705 1.439 7.238.5 1.373 1.155 3.55.13 4.705-.195.2-.85.2-1.22.419-.13.061-.283.195-.414.195"
				fill="#fff"
			/>
			<path
				d="M501.624 314.213c.565 2.377.719 4.839 1.5 7.394.414 1.218 1.069 3.249.283 4.42l-.012-.156a2.87 2.87 0 001.067-.2c.13-.067.21.03.3-.105a3.206 3.206 0 01.436-.5c.283-.133.566-.066.85-.2.066-.062.066-.13.13-.13a1.827 1.827 0 001.287-2.286 2.838 2.838 0 00-.284-.788 5.8 5.8 0 00-.5-1.065 8.08 8.08 0 00-.567-1.156 1.181 1.181 0 00-.283-.5 2.906 2.906 0 00-.284-.5c-.066-.195-.283-.285-.414-.5-.132-.128-.219-.128-.284-.284-.065 0-.283-.061-.2-.129a.7.7 0 01-.282-.128c-.284-.72-.655-1.072-.938-1.814a2.224 2.224 0 01-.2-1.155h-1.59"
				fill="#004bb3"
			/>
			<path
				d="M502.43 314.28a35.041 35.041 0 001.5 5c.567 1 2.813 2.808 1.286 5.709"
				fill="none"
				stroke="#003"
				strokeWidth={0.232}
			/>
			<path
				d="M502.276 314.28a28.091 28.091 0 001.592 5c.567 1.066 2.878 2.812 1.351 5.709"
				fill="none"
				stroke="#00004b"
				strokeWidth={0.232}
			/>
			<path
				d="M502.211 314.28a37.861 37.861 0 001.479 5.1c.567 1 2.812 2.963 1.22 5.865"
				fill="none"
				stroke="#006"
				strokeWidth={0.232}
			/>
			<path
				d="M502.06 314.28a36.435 36.435 0 001.59 5.146c.567 1 2.837 2.7 1.31 5.69"
				fill="none"
				stroke="#00187e"
				strokeWidth={0.232}
			/>
			<path
				d="M501.994 314.28s.936 4.209 1.59 5.212c.5 1 2.682 3.115 1.068 6.079"
				fill="none"
				stroke="#039"
				strokeWidth={0.232}
			/>
			<path
				d="M501.928 314.28a36.187 36.187 0 001.5 5.275c.567 1 2.682 3.185 1.068 6.15"
				fill="none"
				stroke="#004bb3"
				strokeWidth={0.232}
			/>
			<path
				d="M502.5 314.28a30.09 30.09 0 001.591 4.928c.566 1.066 2.813 2.9 1.286 5.71"
				fill="none"
				stroke="#00004b"
				strokeWidth={0.232}
			/>
			<path
				d="M502.647 314.37a31.333 31.333 0 001.5 4.838c.566 1 2.9 2.9 1.373 5.71"
				fill="none"
				stroke="#006"
				strokeWidth={0.232}
			/>
			<path
				d="M502.713 314.37a27.5 27.5 0 001.59 4.838c.568 1 2.813 2.813 1.374 5.71"
				fill="none"
				stroke="#00187e"
				strokeWidth={0.232}
			/>
			<path
				d="M502.8 314.37a29.831 29.831 0 001.591 4.772c.567 1.071 2.9 2.9 1.374 5.714"
				fill="none"
				stroke="#039"
				strokeWidth={0.232}
			/>
			<path
				d="M502.93 314.37a25.7 25.7 0 001.592 4.772c.567 1 2.9 2.9 1.373 5.714"
				fill="none"
				stroke="#004bb3"
				strokeWidth={0.232}
			/>
			<path
				d="M501.624 314.213c-.5 2.377-.633 4.839-1.5 7.394-.35 1.218-1 3.249-.2 4.42l-.066-.06h.066a3.169 3.169 0 01-1.069-.195c-.066-.069-.2-.069-.282-.2a1.8 1.8 0 00-.5-.5c-.2-.133-.5-.066-.719-.2-.065-.062-.13-.13-.2-.13a2.587 2.587 0 01-1.221-1.065 3.84 3.84 0 01-.066-1.221c.066-.286.2-.5.284-.788a5.751 5.751 0 01.5-1.065 7.874 7.874 0 01.567-1.156 190.615 190.615 0 01.566-1c.066-.195.283-.285.415-.5.13-.128.194-.128.348-.284 0 0 .2-.061.2-.129a.142.142 0 00.132-.128 11.373 11.373 0 001-1.814 2.224 2.224 0 00.2-1.155h1.5"
				fill="#004bb3"
			/>
			<path
				d="M500.9 314.28a34.94 34.94 0 01-1.5 5c-.566 1-2.813 2.808-1.374 5.709"
				fill="none"
				stroke="#003"
				strokeWidth={0.232}
			/>
			<path
				d="M501.056 314.28a34.94 34.94 0 01-1.5 5c-.633 1.066-2.835 2.963-1.286 5.86"
				fill="none"
				stroke="#00004b"
				strokeWidth={0.232}
			/>
			<path
				d="M501.121 314.28a39 39 0 01-1.5 5.146c-.567 1-2.812 2.963-1.22 5.864"
				fill="none"
				stroke="#006"
				strokeWidth={0.232}
			/>
			<path
				d="M501.273 314.28a34.292 34.292 0 01-1.525 5.146c-.633 1-2.812 3.03-1.221 6.016"
				fill="none"
				stroke="#00187e"
				strokeWidth={0.232}
			/>
			<path
				d="M501.34 314.28a35.98 35.98 0 01-1.5 5.212c-.567 1-2.747 3.115-1.155 6.079"
				fill="none"
				stroke="#039"
				strokeWidth={0.232}
			/>
			<path
				d="M501.405 314.28s-.85 4.275-1.5 5.275c-.566 1-2.68 3.185-1.067 6.15"
				fill="none"
				stroke="#004bb3"
				strokeWidth={0.232}
			/>
			<path
				d="M500.838 314.28a38.373 38.373 0 01-1.5 4.928c-.567 1.066-2.9 2.9-1.374 5.71"
				fill="none"
				stroke="#00004b"
				strokeWidth={0.232}
			/>
			<path
				d="M500.75 314.37a34.783 34.783 0 01-1.59 4.838c-.568 1-2.9 2.9-1.374 5.71"
				fill="none"
				stroke="#006"
				strokeWidth={0.232}
			/>
			<path
				d="M500.6 314.37a27.385 27.385 0 01-1.592 4.838c-.5 1-2.811 2.813-1.286 5.71"
				fill="none"
				stroke="#00187e"
				strokeWidth={0.232}
			/>
			<path
				d="M500.533 314.37a21.653 21.653 0 01-1.656 4.772c-.5 1.071-2.813 2.9-1.287 5.714"
				fill="none"
				stroke="#039"
				strokeWidth={0.232}
			/>
			<path
				d="M500.4 314.37a25.7 25.7 0 01-1.592 4.772c-.567 1-2.812 2.9-1.286 5.714"
				fill="none"
				stroke="#004bb3"
				strokeWidth={0.232}
			/>
			<path
				d="M498.157 317.768c-.132.2-.349.285-.415.5a1.378 1.378 0 00-.283.5 1.3 1.3 0 00-.283.5 10.655 10.655 0 00-.567 1.155 11.17 11.17 0 00-.5 1.066c-.065.285-.2.5-.282.787a3.809 3.809 0 00.064 1.217 2.478 2.478 0 001.221 1.071c.066 0 .131.062.195.13.2.133.5.065.721.194a1.855 1.855 0 01.5.5c.066.133.2.133.283.194a3.006 3.006 0 001.07.2h-.066l.065.061v-.06a.421.421 0 00.132.279c.195.194.849.194 1.285.419.066.06.2.194.283.194.132 0 .284-.133.416-.194.349-.2 1-.2 1.22-.42a.337.337 0 00.13-.279v0a2.756 2.756 0 001.07-.2c.13-.061.195-.061.282-.194a3.579 3.579 0 01.437-.5c.282-.129.566-.061.85-.195.064-.068.13-.129.13-.129a1.836 1.836 0 001.287-2.288 2.831 2.831 0 00-.284-.787 5.661 5.661 0 00-.5-1.066 7.792 7.792 0 00-.569-1.155 1.131 1.131 0 00-.282-.5 2.78 2.78 0 00-.284-.5c-.066-.195-.283-.285-.415-.5"
				fill="none"
				stroke="#000"
				strokeWidth={0.232}
			/>
			<path
				d="M543.942 272.661l-8.03 5.32a18.435 18.435 0 01-.2 4.821 23.061 23.061 0 01-1.222 4.274h-.04l6.678 11.145a32.89 32.89 0 003-10.667c.004-6.412.217-8.32-.186-14.893z"
				fill="#fff"
			/>
			<path
				d="M534.5 287.075a23.218 23.218 0 001.222-4.274 18.423 18.423 0 00.2-4.84l-4.927 3.184 3.47 5.93"
				fill="#004bb3"
			/>
			<path d="M530.51 280.4l23.277-15.216.419.567-23.2 15.434-.5-.785" fill="#fc0" />
			<path
				d="M530.51 280.4l23.277-15.216.419.567-23.2 15.434-.5-.785"
				fill="none"
				stroke="#000"
				strokeWidth={0.173}
			/>
			<path
				d="M548.49 310.508a4.938 4.938 0 001.81-2.154c.5-1.657.418-1.6.853-3.471.2-1.066.2-2.244.413-3.334.285-1.068 1.809-4.621 1.875-6.016.129-4.622 1.658-7.76 1.284-12.753-.28-3.9-1.155-9.2-.72-13.276a30.281 30.281 0 00-.061-3.467l-10.007 6.52c.413 6.67.195 8.545.195 15 0 1.592-1.372 7.891-3.03 10.726l7.322 12.25"
				fill="#004bb3"
			/>
			<path
				d="M541.231 298.236l7.328 12.25a4.884 4.884 0 001.74-2.155 17.1 17.1 0 00.854-3.465 29.155 29.155 0 00.5-3.338c.28-1.068 1.808-4.622 1.875-6.017m.039-.021c-.062 1.373-1.59 4.84-1.875 5.93a22.612 22.612 0 01-.5 3.334 18.637 18.637 0 01-.854 3.466 5 5 0 01-1.741 2.093l-7.327-12.1"
				fill="none"
				stroke="#00004b"
				strokeWidth={0.232}
			/>
			<path
				d="M553.57 295.49c-.062 1.373-1.59 4.773-1.875 5.864a22.54 22.54 0 01-.5 3.333 20.423 20.423 0 01-.854 3.466 5.576 5.576 0 01-1.741 2.092s-7.238-11.965-7.327-12.03m12.294-2.725c-.062 1.373-1.5 4.773-1.875 5.864a22.9 22.9 0 01-.5 3.25 19.832 19.832 0 01-.854 3.4 4.884 4.884 0 01-1.741 2.025c-.067.067-7.238-11.748-7.327-11.813"
				fill="none"
				stroke="#00004f"
				strokeWidth={0.232}
			/>
			<path
				d="M553.57 295.49c-.062 1.286-1.5 4.708-1.875 5.8a19.47 19.47 0 01-.5 3.182 18.442 18.442 0 01-.854 3.4 5.667 5.667 0 01-1.741 2.093c-.067 0-7.171-11.665-7.327-11.752m12.294-2.725c-.062 1.286-1.5 4.621-1.808 5.711-.195 1-.285 2.158-.564 3.185a16.616 16.616 0 01-.854 3.332 5.576 5.576 0 01-1.741 2.092c-.067 0-7.171-11.53-7.327-11.6"
				fill="none"
				stroke="#000051"
				strokeWidth={0.232}
			/>
			<path
				d="M553.57 295.49c-.062 1.286-1.5 4.556-1.808 5.646-.195 1-.285 2.158-.564 3.183a19.144 19.144 0 01-.854 3.337 5.437 5.437 0 01-1.741 2.026c-.134.067-7.171-11.38-7.327-11.446m12.294-2.747c-.062 1.286-1.5 4.557-1.808 5.582-.195 1.068-.285 2.158-.564 3.182a22.669 22.669 0 01-.854 3.247 4.9 4.9 0 01-1.741 2.027c-.195.066-7.11-11.225-7.327-11.312"
				fill="none"
				stroke="#000053"
				strokeWidth={0.232}
			/>
			<path
				d="M553.57 295.49c-.062 1.286-1.5 4.49-1.808 5.58-.195 1-.285 2.093-.564 3.118a17.988 17.988 0 01-.937 3.244 5.4 5.4 0 01-1.658 1.944c-.195.066-7.11-11.1-7.327-11.161m12.294-2.725c-.062 1.22-1.5 4.425-1.808 5.428-.195 1.068-.285 2.158-.564 3.182a22.842 22.842 0 01-.937 3.182 4.923 4.923 0 01-1.658 1.943c-.195.06-7.11-10.945-7.327-11.01m12.294-2.725c-.062 1.22-1.5 4.425-1.808 5.428-.195 1-.285 2.026-.564 3.03a18.787 18.787 0 01-.937 3.184 4.479 4.479 0 01-1.658 1.936c-.285.068-7.11-10.788-7.327-10.876"
				fill="none"
				stroke="#000056"
				strokeWidth={0.232}
			/>
			<path
				d="M553.57 295.49c-.062 1.22-1.434 4.338-1.808 5.363-.195 1-.285 2.092-.564 3.03a14.722 14.722 0 01-1 3.115 4.27 4.27 0 01-1.591 1.942c-.285.066-7.02-10.66-7.327-10.725m12.294-2.725c-.062 1.22-1.434 4.273-1.808 5.275-.195 1-.346 2.092-.564 2.964a14.3 14.3 0 01-1 3.186 4.148 4.148 0 01-1.658 1.874c-.194.129-6.887-10.443-7.238-10.574"
				fill="none"
				stroke="#000058"
				strokeWidth={0.232}
			/>
			<path
				d="M553.57 295.49c-.062 1.22-1.434 4.273-1.808 5.275-.195.938-.346 1.94-.564 2.9a14.685 14.685 0 01-1 3.115 5.447 5.447 0 01-1.658 1.942c-.284.067-6.887-10.355-7.238-10.507m12.21-2.725c0 1.155-1.373 4.207-1.724 5.21-.195.937-.346 1.962-.57 2.9a19.473 19.473 0 01-1 3.12 5.405 5.405 0 01-1.657 1.87c-.286.067-6.888-10.221-7.238-10.353"
				fill="none"
				stroke="#00005c"
				strokeWidth={0.232}
			/>
			<path
				d="M553.508 295.49c0 1.155-1.373 4.12-1.724 5.144-.195.938-.346 1.94-.57 2.9a16.115 16.115 0 01-1 3.03 4.71 4.71 0 01-1.657 1.873c-.352.068-6.8-10.07-7.238-10.222m12.187-2.725c0 1.068-1.373 4.054-1.724 5.057-.195 1-.346 1.94-.57 2.9a18.362 18.362 0 01-1 2.965 4.7 4.7 0 01-1.657 1.874c-.352.129-6.8-9.918-7.238-10.071"
				fill="none"
				stroke="#00005e"
				strokeWidth={0.232}
			/>
			<path
				d="M553.508 295.425c0 1.155-1.373 4.12-1.724 5.143-.195.852-.346 1.875-.631 2.813a22.023 22.023 0 01-.937 2.9 5.352 5.352 0 01-1.657 1.875c-.352.133-6.8-9.785-7.238-9.917m12.187-2.811c0 1.155-1.373 4.054-1.724 4.991a27.164 27.164 0 01-.631 2.813 26.858 26.858 0 01-.937 2.965 5.19 5.19 0 01-1.657 1.803c-.413.129-6.8-9.634-7.238-9.787m12.187-2.79c0 1.155-1.288 3.989-1.724 4.991a25.909 25.909 0 01-.631 2.747 17.93 17.93 0 01-1 2.964 4.545 4.545 0 01-1.591 1.724c-.413.129-6.737-9.483-7.238-9.636"
				fill="none"
				stroke="#000060"
				strokeWidth={0.232}
			/>
			<path
				d="M553.508 295.425c0 1.155-1.288 3.9-1.657 4.926-.285.937-.413 1.874-.72 2.747a15.445 15.445 0 01-1 2.9 4.542 4.542 0 01-1.59 1.719c-.5.134-6.737-9.35-7.239-9.482m12.21-2.811c0 1.067-1.288 3.9-1.657 4.838-.285.938-.413 1.876-.72 2.747a15.726 15.726 0 01-1 2.81 5.58 5.58 0 01-1.59 1.814c-.5.061-6.737-9.266-7.239-9.42"
				fill="none"
				stroke="#000062"
				strokeWidth={0.232}
			/>
			<path
				d="M553.508 295.425c0 1.067-1.288 3.836-1.657 4.838-.285.85-.413 1.81-.72 2.682a13.433 13.433 0 01-1 2.747 3.983 3.983 0 01-1.59 1.725c-.5.194-6.67-8.984-7.239-9.2m12.21-2.79c0 1.067-1.288 3.836-1.657 4.773-.285.85-.413 1.809-.72 2.682a17.027 17.027 0 01-1 2.745 4.184 4.184 0 01-1.59 1.657c-.57.195-6.586-8.85-7.239-9.067"
				fill="none"
				stroke="#006"
				strokeWidth={0.232}
			/>
			<path
				d="M553.508 295.425c0 1.067-1.288 3.77-1.657 4.708-.285.85-.413 1.809-.72 2.594a22.19 22.19 0 01-1 2.747 4.508 4.508 0 01-1.59 1.72c-.57.133-6.586-8.761-7.239-8.98m12.21-2.79c0 1.068-1.288 3.684-1.657 4.622-.285.872-.413 1.809-.72 2.616a28.971 28.971 0 01-1 2.745 5.481 5.481 0 01-1.59 1.658c-.632.128-6.586-8.632-7.239-8.85"
				fill="none"
				stroke="#000268"
				strokeWidth={0.232}
			/>
			<path
				d="M553.508 295.425c0 1-1.222 3.618-1.657 4.621-.285.784-.413 1.656-.72 2.528a16.408 16.408 0 01-1.072 2.683 4.859 4.859 0 01-1.5 1.657c-.631.195-6.586-8.481-7.238-8.7m12.187-2.79c0 1-1.222 3.619-1.657 4.491-.285.85-.413 1.722-.72 2.594a15.352 15.352 0 01-1.072 2.591 4.232 4.232 0 01-1.59 1.658c-.564.2-6.452-8.325-7.172-8.543m12.211-2.79c0 1-1.222 3.552-1.657 4.49-.285.85-.413 1.657-.72 2.463a12.91 12.91 0 01-1.072 2.594 4.838 4.838 0 01-1.59 1.657c-.63.129-6.452-8.11-7.172-8.414"
				fill="none"
				stroke="#00056b"
				strokeWidth={0.232}
			/>
			<path
				d="M553.508 295.425c0 .937-1.222 3.465-1.657 4.424-.285.785-.413 1.723-.72 2.464a15.352 15.352 0 01-1.072 2.591 5.408 5.408 0 01-1.59 1.592c-.63.2-6.452-7.976-7.172-8.26m12.211-2.811a15.414 15.414 0 01-1.657 4.338c-.285.784-.413 1.656-.72 2.462a12.921 12.921 0 01-1.072 2.53 4.1 4.1 0 01-1.59 1.59c-.63.195-6.384-7.825-7.172-8.109"
				fill="none"
				stroke="#00066d"
				strokeWidth={0.232}
			/>
			<path
				d="M553.508 295.425a15.414 15.414 0 01-1.657 4.338c-.285.784-.413 1.591-.72 2.376-.413 1.22-.57 1.285-1.072 2.526a4.29 4.29 0 01-1.59 1.507c-.72.194-6.384-7.674-7.172-7.979m12.211-2.768a15.039 15.039 0 01-1.657 4.272c-.285.72-.413 1.591-.72 2.376a24.486 24.486 0 01-1.072 2.464 7.8 7.8 0 01-1.59 1.59c-.781.134-6.3-7.608-7.172-7.891"
				fill="none"
				stroke="#00096f"
				strokeWidth={0.232}
			/>
			<path
				d="M553.508 295.425a13.979 13.979 0 01-1.657 4.207c-.285.784-.413 1.59-.72 2.31-.5 1.221-.57 1.286-1.072 2.46a4.863 4.863 0 01-1.59 1.508c-.781.284-6.3-7.39-7.172-7.674m12.211-2.811a14.447 14.447 0 01-1.657 4.12 18.829 18.829 0 01-.787 2.31A15.639 15.639 0 01550 304.32a4.164 4.164 0 01-1.507 1.439c-.782.28-6.3-7.24-7.172-7.544"
				fill="none"
				stroke="#000b73"
				strokeWidth={0.232}
			/>
			<path
				d="M553.508 295.425a14.077 14.077 0 01-1.657 4.054 18.829 18.829 0 01-.787 2.31 12.735 12.735 0 01-1.065 2.4 5.075 5.075 0 01-1.591 1.5c-.787.195-6.15-7.172-7.11-7.456m12.21-2.811a13.731 13.731 0 01-1.657 3.989 18.829 18.829 0 01-.787 2.31A16.482 16.482 0 01550 304.1a5.648 5.648 0 01-1.591 1.441c-.787.195-6.15-7.021-7.11-7.325m12.21-2.791a13.731 13.731 0 01-1.657 3.989c-.285.719-.413 1.5-.787 2.244a9.145 9.145 0 01-1.155 2.312 4.813 4.813 0 01-1.5 1.437c-.787.285-6.15-6.887-7.11-7.17"
				fill="none"
				stroke="#000f75"
				strokeWidth={0.232}
			/>
			<path
				d="M553.508 295.425a11.351 11.351 0 01-1.657 3.9c-.285.72-.413 1.5-.787 2.246a14.394 14.394 0 01-1.155 2.245 4.158 4.158 0 01-1.5 1.44c-.855.195-6.083-6.671-7.11-7.021m12.21-2.811a11.628 11.628 0 01-1.657 3.836 16.643 16.643 0 01-.787 2.159 11.872 11.872 0 01-1.155 2.31 3.962 3.962 0 01-1.5 1.37c-.855.284-6.083-6.514-7.11-6.885"
				fill="none"
				stroke="#001178"
				strokeWidth={0.232}
			/>
			<path
				d="M553.508 295.425a12.23 12.23 0 01-1.657 3.836c-.285.632-.413 1.373-.787 2.093a11.971 11.971 0 01-1.155 2.245 3.978 3.978 0 01-1.5 1.373c-.855.285-6.083-6.365-7.11-6.736m12.21-2.811a10.254 10.254 0 01-1.657 3.683 16.643 16.643 0 01-.787 2.159 10.706 10.706 0 01-1.155 2.158 3.972 3.972 0 01-1.5 1.374c-.938.284-6.021-6.235-7.11-6.584"
				fill="none"
				stroke="#001379"
				strokeWidth={0.232}
			/>
			<path
				d="M553.508 295.425a10.966 10.966 0 01-1.657 3.683 21.962 21.962 0 01-.787 2.093 20.141 20.141 0 01-1.155 2.158 4.2 4.2 0 01-1.5 1.284c-.938.285-6.021-6.079-7.11-6.45m12.21-2.768a10.693 10.693 0 01-1.657 3.618c-.285.72-.5 1.373-.787 2.093a21.792 21.792 0 01-1.155 2.093 5.7 5.7 0 01-1.5 1.374c-1 .28-5.933-6.017-7.11-6.367"
				fill="none"
				stroke="#00167c"
				strokeWidth={0.232}
			/>
			<path
				d="M553.508 295.425a10.413 10.413 0 01-1.657 3.552c-.285.634-.5 1.374-.787 2.094a21.78 21.78 0 01-1.155 2.092 6.54 6.54 0 01-1.5 1.284c-1 .285-5.933-5.861-7.11-6.232m12.21-2.79a9.889 9.889 0 01-1.657 3.465c-.285.72-.5 1.373-.787 2.028a10.478 10.478 0 01-1.222 2.092 3.988 3.988 0 01-1.434 1.221c-1 .35-5.933-5.645-7.11-6.016m12.21-2.79a10.141 10.141 0 01-1.657 3.465c-.285.633-.5 1.286-.787 1.94a10.577 10.577 0 01-1.222 2.027 4.681 4.681 0 01-1.434 1.287c-1.072.28-5.866-5.58-7.11-5.93"
				fill="none"
				stroke="#00187e"
				strokeWidth={0.232}
			/>
			<path
				d="M553.508 295.425a9.384 9.384 0 01-1.657 3.4c-.285.566-.5 1.285-.787 1.94a9.4 9.4 0 01-1.222 1.94 4.678 4.678 0 01-1.434 1.286c-1.072.351-5.866-5.428-7.11-5.8m12.21-2.767a9.146 9.146 0 01-1.657 3.334c-.285.633-.5 1.286-.787 1.875a10.577 10.577 0 01-1.222 2.027 5.729 5.729 0 01-1.434 1.221c-1.072.284-5.866-5.21-7.11-5.646"
				fill="none"
				stroke="#001c82"
				strokeWidth={0.232}
			/>
			<path
				d="M553.508 295.425a9.675 9.675 0 01-1.657 3.334c-.285.567-.5 1.222-.787 1.81-.5 1-.72 1.068-1.222 2.026a5.446 5.446 0 01-1.434 1.157c-1.156.348-5.782-5.058-7.11-5.5m12.21-2.832a8.32 8.32 0 01-1.6 3.182c-.347.632-.564 1.286-.849 1.874-.5.939-.72 1.07-1.222 1.941a5.458 5.458 0 01-1.434 1.155c-1.223.35-5.782-4.926-7.11-5.362"
				fill="none"
				stroke="#001e85"
				strokeWidth={0.232}
			/>
			<path
				d="M553.508 295.337a8.45 8.45 0 01-1.6 3.27c-.28.566-.564 1.22-.849 1.81-.5.937-.72 1-1.222 1.873a4.819 4.819 0 01-1.5 1.157c-1.157.349-5.649-4.775-7.022-5.211m12.188-2.9a8.022 8.022 0 01-1.6 3.184 19.133 19.133 0 01-.938 1.81 9.438 9.438 0 01-1.217 1.809 3.655 3.655 0 01-1.44 1.155c-1.155.349-5.647-4.622-7.02-5.058"
				fill="none"
				stroke="#002086"
				strokeWidth={0.232}
			/>
			<path
				d="M553.508 295.337a7.416 7.416 0 01-1.6 3.117 19.012 19.012 0 01-.938 1.81 9.445 9.445 0 01-1.217 1.81 4.371 4.371 0 01-1.44 1.068c-1.221.414-5.647-4.426-7.02-4.927m12.21-2.878a7.533 7.533 0 01-1.6 3.03 11.252 11.252 0 01-.938 1.722 9.445 9.445 0 01-1.217 1.81 4.615 4.615 0 01-1.44 1.155c-1.221.349-5.58-4.338-7.02-4.84m12.21-2.877a7.533 7.533 0 01-1.6 3.03 14.873 14.873 0 01-.938 1.657 8.809 8.809 0 01-1.217 1.81 5.488 5.488 0 01-1.44 1.067c-1.221.349-5.58-4.207-7.02-4.709"
				fill="none"
				stroke="#002289"
				strokeWidth={0.232}
			/>
			<path
				d="M553.508 295.337a8.092 8.092 0 01-1.6 2.965c-.28.5-.564 1.068-.938 1.656a12.247 12.247 0 01-1.283 1.723 2.808 2.808 0 01-1.374 1c-1.289.414-5.58-3.99-7.02-4.49m12.21-2.857a6.468 6.468 0 01-1.6 2.9 16.767 16.767 0 01-.938 1.656 8.974 8.974 0 01-1.283 1.658 3.4 3.4 0 01-1.374 1.068c-1.289.414-5.514-3.9-7.02-4.426"
				fill="none"
				stroke="#00258b"
				strokeWidth={0.232}
			/>
			<path
				d="M553.508 295.337a7.207 7.207 0 01-1.6 2.9c-.28.5-.564 1-.938 1.592a6.923 6.923 0 01-1.283 1.592 4.121 4.121 0 01-1.374 1.067c-1.289.414-5.514-3.77-7.02-4.272m12.21-2.878a6.312 6.312 0 01-1.6 2.747 14.684 14.684 0 01-.938 1.656 12.941 12.941 0 01-1.283 1.592 6.127 6.127 0 01-1.374 1c-1.372.348-5.514-3.619-7.02-4.12"
				fill="none"
				stroke="#00288f"
				strokeWidth={0.232}
			/>
			<path
				d="M553.508 295.337a6.825 6.825 0 01-1.6 2.747 8.343 8.343 0 01-1 1.5c-.35.785-.72.938-1.221 1.657a4.389 4.389 0 01-1.374.938c-1.372.414-5.514-3.466-7.02-3.99m12.21-2.855a6.261 6.261 0 01-1.6 2.68 8.32 8.32 0 01-1 1.5c-.35.72-.72.85-1.221 1.592a5.885 5.885 0 01-1.374.938c-1.44.414-5.43-3.336-7.02-3.837"
				fill="none"
				stroke="#002b91"
				strokeWidth={0.232}
			/>
			<path
				d="M553.508 295.337a5.944 5.944 0 01-1.6 2.594 8.314 8.314 0 01-1 1.5c-.35.72-.72.85-1.221 1.5a5.791 5.791 0 01-1.374.937c-1.44.414-5.363-3.182-7.02-3.77m12.21-2.77a5.925 5.925 0 01-1.6 2.53 6.226 6.226 0 01-1 1.439 5.912 5.912 0 01-1.221 1.5 4.632 4.632 0 01-1.374 1c-1.44.348-5.363-3.117-7.02-3.685m12.21-2.79a6.344 6.344 0 01-1.6 2.463 6.231 6.231 0 01-1 1.44c-.35.718-.72.849-1.288 1.5a3.679 3.679 0 01-1.284.849c-1.507.5-5.363-2.811-7.021-3.466"
				fill="none"
				stroke="#002d93"
				strokeWidth={0.232}
			/>
			<path
				d="M553.508 295.337a5.644 5.644 0 01-1.6 2.463 8.414 8.414 0 01-1 1.373 8.6 8.6 0 01-1.288 1.439 8.021 8.021 0 01-1.284.938c-1.507.414-5.363-2.747-7.021-3.4m12.188-2.813a5.523 5.523 0 01-1.6 2.4 7.491 7.491 0 01-1 1.352 12.328 12.328 0 01-1.288 1.44 8.61 8.61 0 01-1.374.85c-1.44.414-5.206-2.594-6.954-3.25"
				fill="none"
				stroke="#002f96"
				strokeWidth={0.232}
			/>
			<path
				d="M553.508 295.337a4.922 4.922 0 01-1.6 2.31 7.573 7.573 0 01-1 1.374c-.413.566-.787.784-1.288 1.374a5.529 5.529 0 01-1.374.85c-1.5.413-5.206-2.463-6.954-3.118m12.211-2.79a5.137 5.137 0 01-1.6 2.245 5.434 5.434 0 01-1 1.286 8.547 8.547 0 01-1.288 1.374 5.529 5.529 0 01-1.374.85c-1.59.5-5.206-2.31-6.954-2.965"
				fill="none"
				stroke="#039"
				strokeWidth={0.232}
			/>
			<path
				d="M553.508 295.337a5.676 5.676 0 01-1.6 2.245 7.758 7.758 0 01-1 1.221 10.228 10.228 0 01-1.288 1.286 4.439 4.439 0 01-1.374.85c-1.59.415-5.145-2.157-6.954-2.812m12.211-2.79a5.409 5.409 0 01-1.6 2.158 12.478 12.478 0 01-1 1.221 10.162 10.162 0 01-1.278 1.284 6.743 6.743 0 01-1.374.785c-1.59.5-5.078-2.028-6.954-2.681"
				fill="none"
				stroke="#00359c"
				strokeWidth={0.232}
			/>
			<path
				d="M553.508 295.337a4.909 4.909 0 01-1.6 2.092 10.786 10.786 0 01-2.373 2.442 3.632 3.632 0 01-1.288.785c-1.658.5-5.08-1.874-6.955-2.53m12.211-2.79a4.819 4.819 0 01-1.6 2.028 5.663 5.663 0 01-1 1.222 9.844 9.844 0 01-1.373 1.22 4.729 4.729 0 01-1.288.72c-1.658.5-5.08-1.723-6.955-2.378m12.211-2.811a4.119 4.119 0 01-1.6 1.94 6.856 6.856 0 01-1 1.221c-.5.5-.787.632-1.373 1.155a4.728 4.728 0 01-1.288.72c-1.658.5-5.08-1.591-6.955-2.246"
				fill="none"
				stroke="#00389e"
				strokeWidth={0.232}
			/>
			<path
				d="M553.508 295.337a5 5 0 01-1.6 1.94 10.857 10.857 0 01-1 1.068 17.129 17.129 0 01-1.373 1.156 6 6 0 01-1.372.785c-1.658.5-4.928-1.44-6.892-2.16m12.232-2.79a5.111 5.111 0 01-1.6 1.876 10.857 10.857 0 01-1 1.068 7.639 7.639 0 01-1.373 1.069 2.636 2.636 0 01-1.372.718c-1.658.567-4.928-1.22-6.892-1.94"
				fill="none"
				stroke="#0039a0"
				strokeWidth={0.232}
			/>
			<path
				d="M553.508 295.337a4.325 4.325 0 01-1.6 1.81 10.857 10.857 0 01-1 1.068 16.026 16.026 0 01-1.373 1.068 7.731 7.731 0 01-1.372.72c-1.658.5-4.928-1.156-6.892-1.876m12.232-2.79a3.814 3.814 0 01-1.6 1.722 6.864 6.864 0 01-1.067 1.068c-.413.436-.786.633-1.283 1.069a11.459 11.459 0 01-1.378.632c-1.72.5-4.839-1-6.888-1.722"
				fill="none"
				stroke="#003ca2"
				strokeWidth={0.232}
			/>
			<path
				d="M553.508 295.337a4.3 4.3 0 01-1.6 1.722 12.242 12.242 0 01-1.067 1c-.413.413-.786.566-1.283 1a11.459 11.459 0 01-1.378.632c-1.72.566-4.839-.85-6.888-1.591m12.211-2.77a4.3 4.3 0 01-1.6 1.657c-.28.284-.631.633-1.067 1a11.54 11.54 0 01-1.372.939 3.925 3.925 0 01-1.29.63c-1.807.5-4.838-.718-6.887-1.438"
				fill="none"
				stroke="#003ea6"
				strokeWidth={0.232}
			/>
			<path
				d="M553.508 295.337a5.3 5.3 0 01-1.508 1.592c-.345.282-.72.632-1.155.937a4.934 4.934 0 01-1.372.937 3.91 3.91 0 01-1.29.632c-1.807.567-4.77-.567-6.887-1.286m12.211-2.812a4.485 4.485 0 01-1.507 1.5 8.127 8.127 0 01-1.155.937c-.413.349-.847.567-1.372.938a8.714 8.714 0 01-1.29.567c-1.807.566-4.77-.415-6.887-1.156m12.211-2.79a4.809 4.809 0 01-1.507 1.443c-.345.282-.72.567-1.155.937a6.293 6.293 0 01-1.44.85c-.346.2-.781.414-1.221.633-1.87.5-4.7-.35-6.888-1.07"
				fill="none"
				stroke="#0042a8"
				strokeWidth={0.232}
			/>
			<path
				d="M553.508 295.337a5.728 5.728 0 01-1.508 1.439c-.345.2-.72.5-1.155.785a7.333 7.333 0 01-1.44.937 7.7 7.7 0 01-1.221.5c-1.87.566-4.7-.132-6.954-.85m12.277-2.813a4.886 4.886 0 01-1.507 1.376 6.293 6.293 0 01-1.155.784 9.026 9.026 0 01-1.44.85 4.277 4.277 0 01-1.221.5c-1.87.632-4.7 0-6.954-.72"
				fill="none"
				stroke="#0045ab"
				strokeWidth={0.232}
			/>
			<path
				d="M553.508 295.337a6.155 6.155 0 01-1.508 1.286c-.345.2-.72.567-1.155.785a5.666 5.666 0 01-1.44.784c-.346.2-.781.35-1.221.567-1.937.567-4.622.13-6.954-.632m12.277-2.79a5.257 5.257 0 01-1.507 1.22 12.838 12.838 0 01-1.155.786c-.413.282-.937.5-1.44.784-.346.131-.781.349-1.221.5a12.454 12.454 0 01-6.954-.5"
				fill="none"
				stroke="#0046ad"
				strokeWidth={0.232}
			/>
			<path
				d="M553.508 295.337a5.257 5.257 0 01-1.507 1.22c-.345.2-.72.415-1.155.72a8.875 8.875 0 01-1.44.72 7.791 7.791 0 01-1.221.5 12.543 12.543 0 01-6.954-.349m12.277-2.812a18.1 18.1 0 01-1.508 1.156 13.435 13.435 0 00-1.155.72c-.413.195-.937.414-1.44.632a7.791 7.791 0 01-1.221.5 11.889 11.889 0 01-6.954-.2"
				fill="none"
				stroke="#0049af"
				strokeWidth={0.232}
			/>
			<path
				d="M553.508 295.337A11.274 11.274 0 01552 296.4c-.345.2-.72.415-1.155.633a8.955 8.955 0 01-1.44.719c-.434.13-.781.282-1.221.414a12.2 12.2 0 01-6.954-.065m12.277-2.77s-6.239 4.927-12.316 2.813"
				fill="none"
				stroke="#004bb3"
				strokeWidth={0.232}
			/>
			<path
				d="M553.787 275.892s-1.216 7.913-1.718 9.07c-.351 1-2.9 5.491-6.737 6.516"
				fill="none"
				stroke="#006"
				strokeWidth={0.232}
			/>
			<path
				d="M553.787 275.892s-1.283 7.825-1.808 8.915c-.413 1-2.745 5.364-6.669 6.671"
				fill="none"
				stroke="#00066d"
				strokeWidth={0.232}
			/>
			<path
				d="M553.726 275.825s-1.29 7.762-1.813 8.982c-.5 1-2.59 5.08-6.58 6.671"
				fill="none"
				stroke="#000b73"
				strokeWidth={0.232}
			/>
			<path
				d="M553.726 275.825s-1.373 7.762-1.875 8.917a14.188 14.188 0 01-6.519 6.671"
				fill="none"
				stroke="#001379"
				strokeWidth={0.232}
			/>
			<path
				d="M553.726 275.825s-1.506 7.674-2.031 8.765a14.624 14.624 0 01-6.385 6.8"
				fill="none"
				stroke="#00187e"
				strokeWidth={0.232}
			/>
			<path
				d="M553.726 275.825s-1.59 7.609-2.093 8.765a16.056 16.056 0 01-6.3 6.8"
				fill="none"
				stroke="#002086"
				strokeWidth={0.232}
			/>
			<path
				d="M553.66 275.825s-1.591 7.543-2.094 8.7a16.477 16.477 0 01-6.234 6.8"
				fill="none"
				stroke="#00258b"
				strokeWidth={0.232}
			/>
			<path
				d="M553.66 275.825s-1.747 7.457-2.244 8.634c-.5 1.068-1.814 3.9-6.15 6.889"
				fill="none"
				stroke="#002b91"
				strokeWidth={0.232}
			/>
			<path
				d="M553.66 275.825s-1.809 7.391-2.311 8.547c-.5 1.067-1.724 3.683-6.083 6.954"
				fill="none"
				stroke="#039"
				strokeWidth={0.232}
			/>
			<path
				d="M553.66 275.76s-1.876 7.456-2.462 8.547c-.5 1.067-1.506 3.4-5.933 7.02"
				fill="none"
				stroke="#00389e"
				strokeWidth={0.232}
			/>
			<path
				d="M553.66 275.76s-1.943 7.326-2.528 8.48c-.5 1.069-1.374 3.184-5.866 7.02"
				fill="none"
				stroke="#003ea6"
				strokeWidth={0.232}
			/>
			<path
				d="M553.57 275.76s-1.958 7.326-2.528 8.415c-.564 1.069-1.223 2.965-5.8 7.02"
				fill="none"
				stroke="#0046ad"
				strokeWidth={0.232}
			/>
			<path
				d="M553.57 275.674s-2.026 7.324-2.68 8.393c-.568 1.068-1.07 2.747-5.646 7.106"
				fill="none"
				stroke="#004bb3"
				strokeWidth={0.232}
			/>
			<path
				d="M553.291 271.03s-1.005 11.162-8.985 14.214"
				fill="none"
				stroke="#006"
				strokeWidth={0.232}
			/>
			<path
				d="M553.224 271.03a23.494 23.494 0 01-2.026 7.02 13.486 13.486 0 01-6.892 7.171"
				fill="none"
				stroke="#00066d"
				strokeWidth={0.232}
			/>
			<path
				d="M553.224 271.03a27.881 27.881 0 01-2.092 7.02c-1.156 2.376-3.25 5.581-6.8 7.171"
				fill="none"
				stroke="#000b73"
				strokeWidth={0.232}
			/>
			<path
				d="M553.224 271.03a28.01 28.01 0 01-2.16 6.888c-1.155 2.312-3.248 5.582-6.736 7.238"
				fill="none"
				stroke="#001379"
				strokeWidth={0.232}
			/>
			<path
				d="M553.224 271.03a31.509 31.509 0 01-2.31 6.888c-1 2.093-3.12 5.494-6.586 7.173"
				fill="none"
				stroke="#00187e"
				strokeWidth={0.232}
			/>
			<path
				d="M553.224 271.03a31.937 31.937 0 01-2.377 6.8c-.938 1.876-3.03 5.43-6.519 7.238"
				fill="none"
				stroke="#002086"
				strokeWidth={0.232}
			/>
			<path
				d="M553.134 271.03a30.443 30.443 0 01-2.377 6.736 17.281 17.281 0 01-6.451 7.326"
				fill="none"
				stroke="#00258b"
				strokeWidth={0.232}
			/>
			<path
				d="M553.134 270.964a31.082 31.082 0 01-2.46 6.737c-.787 1.5-2.9 5.276-6.368 7.325"
				fill="none"
				stroke="#002b91"
				strokeWidth={0.232}
			/>
			<path
				d="M553.134 270.964a38.848 38.848 0 01-2.528 6.671c-.787 1.44-2.812 5.277-6.3 7.39"
				fill="none"
				stroke="#039"
				strokeWidth={0.232}
			/>
			<path
				d="M553.134 270.964a32.032 32.032 0 01-2.679 6.671c-.636 1.156-2.66 5.145-6.15 7.39"
				fill="none"
				stroke="#00389e"
				strokeWidth={0.232}
			/>
			<path
				d="M553.134 270.964a42.188 42.188 0 01-2.745 6.605c-.57 1-2.6 5.06-6.083 7.391"
				fill="none"
				stroke="#003ea6"
				strokeWidth={0.232}
			/>
			<path
				d="M553.073 270.964a35.012 35.012 0 01-2.751 6.519c-.5.785-2.528 4.992-6.016 7.455"
				fill="none"
				stroke="#0046ad"
				strokeWidth={0.232}
			/>
			<path
				d="M553.073 270.964a33.861 33.861 0 01-2.9 6.453c-.413.633-2.377 4.993-5.864 7.543"
				fill="none"
				stroke="#004bb3"
				strokeWidth={0.232}
			/>
			<path
				d="M553.224 267.913s-2.31 8.981-8.762 11.161"
				fill="none"
				stroke="#006"
				strokeWidth={0.232}
			/>
			<path
				d="M553.224 267.913a21.757 21.757 0 01-3.03 6.235 12.256 12.256 0 01-5.715 4.926"
				fill="none"
				stroke="#00056b"
				strokeWidth={0.232}
			/>
			<path
				d="M553.224 267.913a23.269 23.269 0 01-3.12 6.147c-1.44 2.093-3.465 4.273-5.642 4.993"
				fill="none"
				stroke="#00096f"
				strokeWidth={0.232}
			/>
			<path
				d="M553.134 267.848A24.628 24.628 0 01550.1 274c-1.5 2.158-3.684 4.338-5.731 5.058"
				fill="none"
				stroke="#000f75"
				strokeWidth={0.232}
			/>
			<path
				d="M553.134 267.782a26.179 26.179 0 01-3.113 6.234c-1.6 2.093-3.773 4.426-5.648 5.058"
				fill="none"
				stroke="#00167c"
				strokeWidth={0.232}
			/>
			<path
				d="M553.134 267.782a25.588 25.588 0 01-3.247 6.083c-1.591 2.223-3.835 4.556-5.514 5.144"
				fill="none"
				stroke="#001c82"
				strokeWidth={0.232}
			/>
			<path
				d="M553.134 267.782a23.348 23.348 0 01-3.334 6.018c-1.657 2.31-3.99 4.708-5.43 5.21"
				fill="none"
				stroke="#002086"
				strokeWidth={0.232}
			/>
			<path
				d="M553.134 267.7a26.119 26.119 0 01-3.331 6.017c-1.724 2.31-4.124 4.84-5.43 5.275"
				fill="none"
				stroke="#00258b"
				strokeWidth={0.232}
			/>
			<path
				d="M553.134 267.7a25.9 25.9 0 01-3.465 5.929c-1.72 2.377-4.208 4.927-5.3 5.276"
				fill="none"
				stroke="#002b91"
				strokeWidth={0.232}
			/>
			<path
				d="M553.134 267.7a29.511 29.511 0 01-3.554 5.865c-1.808 2.376-4.336 5.055-5.207 5.361"
				fill="none"
				stroke="#002f96"
				strokeWidth={0.232}
			/>
			<path
				d="M553.134 267.63a32.289 32.289 0 01-3.616 5.864c-1.875 2.375-4.425 5.21-5.145 5.427"
				fill="none"
				stroke="#00359c"
				strokeWidth={0.232}
			/>
			<path
				d="M553.073 267.63a32.112 32.112 0 01-3.556 5.864c-1.941 2.375-4.559 5.21-5.211 5.427"
				fill="none"
				stroke="#003ca2"
				strokeWidth={0.232}
			/>
			<path
				d="M553.073 267.63a32.831 32.831 0 01-3.69 5.71c-1.873 2.53-4.62 5.43-5.077 5.582"
				fill="none"
				stroke="#0042a8"
				strokeWidth={0.232}
			/>
			<path
				d="M553.073 267.564a30.862 30.862 0 01-3.772 5.711 50.451 50.451 0 01-5 5.646"
				fill="none"
				stroke="#0046ad"
				strokeWidth={0.232}
			/>
			<path
				d="M553.073 267.476a31.911 31.911 0 01-3.84 5.712c-2.025 2.6-4.927 5.647-4.927 5.647m-8.439 1.35l-4.425.786m3.99 2.55l-3.99-1.656"
				fill="none"
				stroke="#004bb3"
				strokeWidth={0.232}
			/>
			<path
				d="M535.935 280.251l-4.426.72"
				fill="none"
				stroke="#0045ab"
				strokeWidth={0.232}
			/>
			<path
				d="M535.867 280.47l-4.425.5"
				fill="none"
				stroke="#003ca2"
				strokeWidth={0.232}
			/>
			<path
				d="M535.867 280.622l-4.425.349"
				fill="none"
				stroke="#00359c"
				strokeWidth={0.232}
			/>
			<path
				d="M535.867 280.753l-4.487.282"
				fill="none"
				stroke="#002d93"
				strokeWidth={0.232}
			/>
			<path
				d="M535.867 280.971l-4.487.065"
				fill="none"
				stroke="#00258b"
				strokeWidth={0.232}
			/>
			<path
				d="M535.867 281.124l-4.553-.066"
				fill="none"
				stroke="#001e85"
				strokeWidth={0.232}
			/>
			<path
				d="M535.867 281.276l-4.62-.2"
				fill="none"
				stroke="#00167c"
				strokeWidth={0.232}
			/>
			<path
				d="M535.807 281.406l-4.56-.282"
				fill="none"
				stroke="#000f75"
				strokeWidth={0.232}
			/>
			<path
				d="M535.807 281.56l-4.621-.415"
				fill="none"
				stroke="#00066d"
				strokeWidth={0.232}
			/>
			<path
				d="M535.522 283.3l-4.058-1.5"
				fill="none"
				stroke="#0045ab"
				strokeWidth={0.232}
			/>
			<path
				d="M535.522 283.15l-4.12-1.438"
				fill="none"
				stroke="#003ca2"
				strokeWidth={0.232}
			/>
			<path
				d="M535.522 283.02l-4.12-1.374"
				fill="none"
				stroke="#00359c"
				strokeWidth={0.232}
			/>
			<path
				d="M535.589 282.8l-4.275-1.22"
				fill="none"
				stroke="#002d93"
				strokeWidth={0.232}
			/>
			<path
				d="M535.589 282.65l-4.342-1.156"
				fill="none"
				stroke="#00258b"
				strokeWidth={0.232}
			/>
			<path
				d="M535.589 282.5l-4.342-1.07"
				fill="none"
				stroke="#001e85"
				strokeWidth={0.232}
			/>
			<path
				d="M535.65 282.28l-4.487-.851"
				fill="none"
				stroke="#00167c"
				strokeWidth={0.232}
			/>
			<path
				d="M535.717 282.061l-4.554-.785"
				fill="none"
				stroke="#000f75"
				strokeWidth={0.232}
			/>
			<path
				d="M535.717 281.93l-4.621-.654"
				fill="none"
				stroke="#00066d"
				strokeWidth={0.232}
			/>
			<path
				d="M535.717 281.777l-4.71-.565"
				fill="none"
				stroke="#006"
				strokeWidth={0.232}
			/>
			<path
				d="M548.49 310.508a4.938 4.938 0 001.81-2.154c.5-1.657.418-1.6.853-3.471.2-1.066.2-2.244.413-3.334.285-1.068 1.809-4.621 1.875-6.016.129-4.622 1.658-7.76 1.284-12.753-.28-3.9-1.155-9.2-.72-13.276a30.281 30.281 0 00-.061-3.467l-22.977 15.217"
				fill="none"
				stroke="#000"
				strokeWidth={0.232}
			/>
			<path
				d="M554.161 264.883c.2-.85-.066-2.03-.72-2.157a2.156 2.156 0 00-.786-.068c-.347 0-.413.13-.565.436-.35.785.565 1.287 1.285 1.5.133.066.569.13.63.349.134.349.068.2.134.349-.134-.065-.134-.2-.285-.284-.5-.282-1-.348-1.74-.72-.5-.194-.57-1.372-.2-1.657a2.3 2.3 0 012.03 0 3.561 3.561 0 01.5 2.682c0-.195-.285-.13-.285-.414"
				fill="#fc0"
			/>
			<path
				d="M554.161 264.883c.2-.85-.066-2.03-.72-2.157a2.156 2.156 0 00-.786-.068c-.347 0-.413.13-.565.436-.35.785.565 1.287 1.285 1.5.133.066.569.13.63.349.134.349.068.2.134.349-.134-.065-.134-.2-.285-.284-.5-.282-1-.348-1.74-.72-.5-.194-.57-1.372-.2-1.657a2.3 2.3 0 012.03 0 3.561 3.561 0 01.5 2.682c0-.195-.285-.13-.285-.414z"
				fill="none"
				stroke="#000"
				strokeWidth={0.173}
			/>
			<path
				d="M554.53 265.318c.938 0 2.026.349 2.093.938a3.64 3.64 0 010 .85c-.068.349-.129.5-.5.567-.847.2-1.217-.784-1.373-1.5a1.511 1.511 0 00-.195-.72c-.346-.13-.285-.066-.346-.13a.835.835 0 01.195.283c.2.5.285 1.068.5 1.81.13.567 1.218.784 1.591.436a2.194 2.194 0 00.285-1.94 3.319 3.319 0 00-2.6-.939c.194.066.128.414.345.35"
				fill="#fc0"
			/>
			<path
				d="M554.53 265.318c.938 0 2.026.349 2.093.938a3.64 3.64 0 010 .85c-.068.349-.129.5-.5.567-.847.2-1.217-.784-1.373-1.5a1.511 1.511 0 00-.195-.72c-.346-.13-.285-.066-.346-.13a.835.835 0 01.195.283c.2.5.285 1.068.5 1.81.13.567 1.218.784 1.591.436a2.194 2.194 0 00.285-1.94 3.319 3.319 0 00-2.6-.939c.194.066.128.414.345.35"
				fill="none"
				stroke="#000"
				strokeWidth={0.173}
			/>
			<path
				d="M554.725 264.948a.551.551 0 01.134.632c-.134.2-.5.283-.63.13a.59.59 0 01-.351-.85c.195-.282.568-.065.847.067"
				fill="#fc0"
			/>
			<path
				d="M554.725 264.948a.551.551 0 01.134.632c-.134.2-.5.283-.63.13a.59.59 0 01-.351-.85c.195-.282.568-.065.847.067z"
				fill="none"
				stroke="#000"
				strokeWidth={0.173}
			/>
			<path
				d="M559.586 261.833a13.626 13.626 0 01-4.425 1 6.749 6.749 0 01-.5 2.226 6.57 6.57 0 012.6.065 9.614 9.614 0 012.31-3.334"
				fill="#fc0"
			/>
			<path
				d="M559.586 261.833a13.626 13.626 0 01-4.425 1 6.749 6.749 0 01-.5 2.226 6.57 6.57 0 012.6.065 9.614 9.614 0 012.31-3.334z"
				fill="none"
				stroke="#000"
				strokeWidth={0.173}
			/>
			<path
				d="M557.65 263.05a5.141 5.141 0 01-1.747.418 2.969 2.969 0 01-.2.848 2.909 2.909 0 011 .065 2.961 2.961 0 01.938-1.354z"
				fill="none"
				stroke="#000"
				strokeWidth={0.173}
			/>
			<path
				d="M554.53 266.823s-.414-.785-.565-1.068c-.066-.13.063.937-.35 1.068a4.964 4.964 0 00-.63 2.593 2.16 2.16 0 002.092.066c.346-.2.128-.784-.067-1.286a2.287 2.287 0 00-.413-1.374"
				fill="#fc0"
			/>
			<path
				d="M554.53 266.823s-.414-.785-.565-1.068c-.066-.13.063.937-.35 1.068a4.964 4.964 0 00-.63 2.593 2.16 2.16 0 002.092.066c.346-.2.128-.784-.067-1.286a2.287 2.287 0 00-.413-1.374z"
				fill="none"
				stroke="#000"
				strokeWidth={0.173}
			/>
			<path
				d="M554.1 266.19a4.308 4.308 0 01-.068.567c0-.2-.2.2-.279.284a5.548 5.548 0 00-.569 2.31m.7-2.092a6.863 6.863 0 00-.346 2.245l-.067-.065m.48-1.308a4.035 4.035 0 00-.195 1.373l.279.13"
				fill="none"
				stroke="#000"
				strokeWidth={0.173}
			/>
			<path
				d="M531.944 314.213c-1.875 1.658-5.274 2.528-5.86 2.97a10.84 10.84 0 01-6.084 2.31c-2.31.195-3.335-.419-5.646-.72-2.66-.285.283.128-2.223-.42a29.641 29.641 0 00-3.03-.93c-1.286-.352-2.6-.637-3.4-1.725a2.054 2.054 0 01-.634-1.44h-1.72c-.131.5.348 1.44.5 1.808a4.222 4.222 0 01.415.659c.282.5.2.345.719.78a5.714 5.714 0 00.785.632 2.418 2.418 0 001 .636 22.489 22.489 0 014.12 1.155c1.57.413.719.346 1.94.63a21.431 21.431 0 002.31.631c1.069.195 1.222.352 2.312.57a27.571 27.571 0 008.328.285 14.057 14.057 0 004.927-1.29c1.72-1.222 5.581-1.719 7.238-2.9a9.7 9.7 0 001.5-.854c1.59-1.373 2.963-1.72 4.71-2.813h-12.25"
				fill="#004bb3"
			/>
			<path
				d="M518.54 314.213c-1.222.636-1.81 1.658-5.21 2.746-1.287 0-2.748.57-3.99.5 1.526.352 1.526.57 2.747.854 2.528.563-.415.129 2.223.413 2.31.285 3.335.938 5.646.72a10.655 10.655 0 006.084-2.31c.563-.413 3.99-1.29 5.865-2.97H518.5"
				fill="#fff"
			/>
			<path
				d="M518.54 314.213h-13.56a2.13 2.13 0 00.633 1.44c.784 1.072 2.091 1.374 3.4 1.724 1.373.28 2.812-.419 4.272-.419 3.554-1.064 3.99-2.242 5.211-2.745"
				fill="#004bb3"
			/>
			<path
				d="M531.666 314.213s2.371.135 2.528.135c.127 0 9.7-.135 9.7-.135"
				fill="none"
				stroke="#00066d"
				strokeWidth={0.232}
			/>
			<path
				d="M531.666 314.28s2.31.129 2.59.2c.2.068 9.637-.127 9.637-.127"
				fill="none"
				stroke="#000b73"
				strokeWidth={0.232}
			/>
			<path
				d="M531.666 314.37s2.31.195 2.59.279c.418 0 9.509-.279 9.509-.279"
				fill="none"
				stroke="#001379"
				strokeWidth={0.232}
			/>
			<path
				d="M531.666 314.37s2.176.279 2.679.346c.5.133 9.352-.285 9.352-.285"
				fill="none"
				stroke="#00187e"
				strokeWidth={0.232}
			/>
			<path
				d="M531.6 314.43s2.16.286 2.745.42c.631.128 9.264-.42 9.264-.42"
				fill="none"
				stroke="#002086"
				strokeWidth={0.232}
			/>
			<path
				d="M531.6 314.43s2.092.42 2.812.57c.781.129 9.2-.5 9.2-.5"
				fill="none"
				stroke="#00258b"
				strokeWidth={0.232}
			/>
			<path
				d="M531.531 314.43s2.093.5 2.964.721c.854.195 8.985-.564 8.985-.564"
				fill="none"
				stroke="#002b91"
				strokeWidth={0.232}
			/>
			<path
				d="M531.531 314.5s2.027.569 2.964.786c1 .128 8.918-.72 8.918-.72"
				fill="none"
				stroke="#039"
				strokeWidth={0.232}
			/>
			<path
				d="M531.531 314.587s1.943.63 3.03.848c1.156.2 8.852-.786 8.852-.786"
				fill="none"
				stroke="#00389e"
				strokeWidth={0.232}
			/>
			<path
				d="M531.531 314.587a28.846 28.846 0 003.12 1c1.155.2 8.634-.848 8.634-.848"
				fill="none"
				stroke="#003ea6"
				strokeWidth={0.232}
			/>
			<path
				d="M531.531 314.649a16.306 16.306 0 003.181 1c1.29.285 8.483-.937 8.483-.937"
				fill="none"
				stroke="#0046ad"
				strokeWidth={0.232}
			/>
			<path d="M544 314.213h-12.334" fill="none" stroke="#006" strokeWidth={0.232} />
			<path
				d="M543.128 314.805s-6.954 1.284-8.416 1a16.527 16.527 0 01-3.248-1.155"
				fill="none"
				stroke="#004bb3"
				strokeWidth={0.232}
			/>
			<path
				d="M529.94 319.643s-4.491.631-4.642.631c-.067 0-2.528-.194-2.66-.194l-2.18-.5"
				fill="none"
				stroke="#00066d"
				strokeWidth={0.232}
			/>
			<path
				d="M530.136 319.577s-4.554.72-4.838.636c-.2-.068-2.445-.2-2.594-.2-.13 0-2.029-.413-2.029-.413"
				fill="none"
				stroke="#001178"
				strokeWidth={0.232}
			/>
			<path
				d="M530.443 319.447a44.022 44.022 0 01-5.145.632c-.285 0-2.377-.129-2.528-.129-.2 0-1.876-.434-1.876-.434"
				fill="none"
				stroke="#00187e"
				strokeWidth={0.232}
			/>
			<path
				d="M530.66 319.292a45.409 45.409 0 01-5.43.72c-.345 0-2.16-.128-2.46-.128-.2-.068-1.658-.352-1.658-.352"
				fill="none"
				stroke="#002086"
				strokeWidth={0.232}
			/>
			<path
				d="M530.946 319.23a48.6 48.6 0 01-5.715.721c-.413-.068-2.093-.134-2.377-.2-.28 0-1.5-.194-1.5-.194"
				fill="none"
				stroke="#002b91"
				strokeWidth={0.232}
			/>
			<path
				d="M531.163 319.074s-4.994 1-6.016.787c-.5-.067-1.875-.128-2.31-.194a10.29 10.29 0 01-1.289-.2"
				fill="none"
				stroke="#039"
				strokeWidth={0.232}
			/>
			<path
				d="M531.443 319.013s-5.14 1-6.3.781c-.57-.061-1.814-.195-2.249-.195q-.607-.084-1.22-.128"
				fill="none"
				stroke="#0039a0"
				strokeWidth={0.232}
			/>
			<path
				d="M531.666 318.923s-5.213 1.066-6.52.787a14 14 0 00-2.248-.194 7.5 7.5 0 00-1-.069"
				fill="none"
				stroke="#0045ab"
				strokeWidth={0.232}
			/>
			<path
				d="M529.634 319.794l-4.336.57-2.66-.134-2.311-.564"
				fill="none"
				stroke="#006"
				strokeWidth={0.232}
			/>
			<path
				d="M531.944 318.8s-5.362 1.155-6.887.848a17.608 17.608 0 00-2.964-.284m-11.4.09s-2.748-1-4.21-1.508a4.693 4.693 0 01-2.9-3.616m7.417 4.247s-1.656-.636-3.03-1.155c-3.77-1.44-3.335-3.185-3.335-3.185"
				fill="none"
				stroke="#004bb3"
				strokeWidth={0.232}
			/>
			<path
				d="M511.28 318.706s-2.245-.787-3.335-1.223a7.127 7.127 0 01-1.722-.78 4.09 4.09 0 01-1.286-1.222 2.932 2.932 0 01-.415-1.223"
				fill="none"
				stroke="#003ca2"
				strokeWidth={0.232}
			/>
			<path
				d="M511.5 318.923s-2.747-1-3.553-1.372a11.133 11.133 0 01-1.722-.72 14 14 0 01-1.374-1.156 9.457 9.457 0 01-.414-1.44"
				fill="none"
				stroke="#002d93"
				strokeWidth={0.232}
			/>
			<path
				d="M511.781 319.074s-3.335-1.155-3.836-1.373q-.858-.368-1.722-.72c-.2-.128-1.286-1.066-1.44-1.217a11.676 11.676 0 01-.435-1.506"
				fill="none"
				stroke="#001e85"
				strokeWidth={0.232}
			/>
			<path
				d="M512 319.292s-3.837-1.373-4.054-1.5c-.2-.069-1.592-.57-1.657-.632a15.145 15.145 0 01-1.5-1.222c-.066-.134-.567-1.59-.567-1.59"
				fill="none"
				stroke="#000f75"
				strokeWidth={0.232}
			/>
			<path
				d="M511 319.447s-3.334-1.221-4.49-1.656a5.1 5.1 0 01-2.027-1.507 5.616 5.616 0 01-.785-1.936"
				fill="none"
				stroke="#003ca2"
				strokeWidth={0.232}
			/>
			<path
				d="M511.346 319.447s-4.056-1.438-4.927-1.807a5.436 5.436 0 01-1.875-1.44 7.108 7.108 0 01-.785-1.875"
				fill="none"
				stroke="#002d93"
				strokeWidth={0.232}
			/>
			<path
				d="M511.65 319.516s-4.708-1.814-5.21-1.943a7.673 7.673 0 01-1.809-1.373 7.313 7.313 0 01-.719-1.875"
				fill="none"
				stroke="#001e85"
				strokeWidth={0.232}
			/>
			<path
				d="M511.934 319.516s-5.276-2.033-5.582-2.094a12.1 12.1 0 01-1.721-1.289c-.13-.195-.633-1.808-.633-1.808"
				fill="none"
				stroke="#000f75"
				strokeWidth={0.232}
			/>
			<path
				d="M512.218 319.516l-5.93-2.25-1.592-1.222-.566-1.719"
				fill="none"
				stroke="#006"
				strokeWidth={0.232}
			/>
			<path
				d="M505.328 314.213s2.53.135 2.682.135c.13 0 10.071-.135 10.071-.135"
				fill="none"
				stroke="#00066d"
				strokeWidth={0.232}
			/>
			<path
				d="M505.328 314.28s2.464.129 2.682.2c.283.068 10-.127 10-.127"
				fill="none"
				stroke="#000b73"
				strokeWidth={0.232}
			/>
			<path
				d="M505.263 314.37s2.441.195 2.813.279c.348 0 9.853-.279 9.853-.279"
				fill="none"
				stroke="#001379"
				strokeWidth={0.232}
			/>
			<path
				d="M505.263 314.37s2.377.279 2.9.346c.5.133 9.7-.285 9.7-.285"
				fill="none"
				stroke="#00187e"
				strokeWidth={0.232}
			/>
			<path
				d="M505.263 314.43s2.223.286 2.9.42c.633.128 9.635-.42 9.635-.42"
				fill="none"
				stroke="#002086"
				strokeWidth={0.232}
			/>
			<path
				d="M505.263 314.43s2.158.42 2.965.57c.72.129 9.5-.5 9.5-.5"
				fill="none"
				stroke="#00258b"
				strokeWidth={0.232}
			/>
			<path
				d="M505.177 314.43s2.157.5 3.03.721c.936.195 9.416-.564 9.416-.564"
				fill="none"
				stroke="#002b91"
				strokeWidth={0.232}
			/>
			<path
				d="M505.177 314.5s2.092.569 3.117.786c1 .128 9.264-.72 9.264-.72"
				fill="none"
				stroke="#039"
				strokeWidth={0.232}
			/>
			<path
				d="M505.177 314.587s2 .63 3.117.848c1.155.2 9.2-.786 9.2-.786"
				fill="none"
				stroke="#00389e"
				strokeWidth={0.232}
			/>
			<path
				d="M505.177 314.587a32.2 32.2 0 003.182 1c1.286.2 9.07-.848 9.07-.848"
				fill="none"
				stroke="#003ea6"
				strokeWidth={0.232}
			/>
			<path
				d="M505.177 314.649a15.46 15.46 0 003.247 1c1.374.285 8.917-.937 8.917-.937"
				fill="none"
				stroke="#0046ad"
				strokeWidth={0.232}
			/>
			<path d="M518.169 314.213h-12.754" fill="none" stroke="#006" strokeWidth={0.232} />
			<path
				d="M517.23 314.805s-7.171 1.284-8.7 1a17.741 17.741 0 01-3.4-1.155"
				fill="none"
				stroke="#004bb3"
				strokeWidth={0.232}
			/>
			<path
				d="M503.214 314.213c-.131.5.348 1.44.5 1.814a4.215 4.215 0 01.415.653c.283.5.195.346.72.781a5.943 5.943 0 00.783.636 2.481 2.481 0 001 .631 22.871 22.871 0 014.12 1.156c1.569.413.72.346 1.94.63a20.545 20.545 0 002.31.63c1.07.2 1.221.352 2.311.57a27.56 27.56 0 008.326.285 13.908 13.908 0 004.927-1.29c1.724-1.216 5.582-1.718 7.238-2.9a9.013 9.013 0 001.508-.854c1.59-1.373 2.962-1.719 4.7-2.807"
				fill="none"
				stroke="#000"
				strokeWidth={0.232}
			/>
			<path
				d="M474.721 277.2c-1.438-3.554-2.964-10.944-2.9-12.623.349-6.89.2-8.984.85-16.087l7.172 8.2a23.291 23.291 0 000 5.274 26.769 26.769 0 00.939 4.993l-6.082 10.221"
				fill="#fff"
			/>
			<path
				d="M480.8 266.975a28.277 28.277 0 01-.938-4.991 23.413 23.413 0 010-5.274l4.339 4.838-3.4 5.427m-18.2 6.671c-.065-1.591-.2-3.335-.2-4.12 0-4.992-.567-7.76 0-13.056.414-4.125 1.439-9.638 1.22-14.064a36.124 36.124 0 01.2-3.773l8.85 9.857c-.63 7.1-.5 9.2-.849 16.087-.065 1.657 1.44 9.07 2.9 12.622l-1.875 3.183-10.224-6.736"
				fill="#004bb3"
			/>
			<path d="M484.858 260.9l-20.817-23.07-.415.5 20.6 23.194.632-.63" fill="#fc0" />
			<path
				d="M484.858 260.9l-20.817-23.07-.415.5 20.6 23.194.632-.63"
				fill="none"
				stroke="#000"
				strokeWidth={0.173}
			/>
			<path
				d="M464.258 244.259s1.656 14.565 7.325 14"
				fill="none"
				stroke="#006"
				strokeWidth={0.232}
			/>
			<path
				d="M471.583 258.188c-2.813.135-4.71-3.465-5.712-6.8a53.357 53.357 0 01-1.592-7.177"
				fill="none"
				stroke="#00056b"
				strokeWidth={0.232}
			/>
			<path
				d="M471.583 258.188c-2.813-.128-4.71-3.773-5.647-6.887a42.121 42.121 0 01-1.657-7.11"
				fill="none"
				stroke="#000b73"
				strokeWidth={0.232}
			/>
			<path
				d="M471.67 258.127c-2.9-.2-4.774-3.99-5.712-6.96a59.13 59.13 0 01-1.656-7.013"
				fill="none"
				stroke="#001178"
				strokeWidth={0.232}
			/>
			<path
				d="M471.67 258.06c-2.9-.413-4.774-4.209-5.647-6.954a67.931 67.931 0 01-1.744-7.02"
				fill="none"
				stroke="#00167c"
				strokeWidth={0.232}
			/>
			<path
				d="M471.67 257.971c-2.9-.564-4.774-4.487-5.582-6.953a70.184 70.184 0 01-1.809-7.018"
				fill="none"
				stroke="#001e85"
				strokeWidth={0.232}
			/>
			<path
				d="M471.67 257.971c-2.812-.781-4.774-4.771-5.515-7.02a46.1 46.1 0 01-1.788-6.951"
				fill="none"
				stroke="#002289"
				strokeWidth={0.232}
			/>
			<path
				d="M471.736 257.91c-2.9-.938-4.84-5-5.582-7.11a50.891 50.891 0 01-1.787-6.888"
				fill="none"
				stroke="#00288f"
				strokeWidth={0.232}
			/>
			<path
				d="M471.736 257.91c-2.9-1.223-4.84-5.28-5.43-7.178a36.75 36.75 0 01-1.939-6.886"
				fill="none"
				stroke="#002d93"
				strokeWidth={0.232}
			/>
			<path
				d="M471.736 257.754c-2.813-1.284-4.84-5.426-5.43-7.105a41.4 41.4 0 01-1.939-6.892"
				fill="none"
				stroke="#00359c"
				strokeWidth={0.232}
			/>
			<path
				d="M471.736 257.754c-2.813-1.5-4.84-5.8-5.364-7.172a42.026 42.026 0 01-2-6.8"
				fill="none"
				stroke="#0039a0"
				strokeWidth={0.232}
			/>
			<path
				d="M471.736 257.686c-2.813-1.652-4.84-6.016-5.277-7.17a44.031 44.031 0 01-2.092-6.8"
				fill="none"
				stroke="#003ea6"
				strokeWidth={0.232}
			/>
			<path
				d="M471.8 257.686c-2.9-1.875-4.926-6.295-5.362-7.322a49.254 49.254 0 01-2.092-6.735"
				fill="none"
				stroke="#0046ad"
				strokeWidth={0.232}
			/>
			<path
				d="M464.346 243.606a39.674 39.674 0 002.157 6.67c.35.785 2.377 5.211 5.275 7.237"
				fill="none"
				stroke="#004bb3"
				strokeWidth={0.232}
			/>
			<path
				d="M464.476 240.927s4.708 11.6 7.76 10.285"
				fill="none"
				stroke="#006"
				strokeWidth={0.232}
			/>
			<path
				d="M472.236 251.235c-1.286.569-3.248-1.719-4.84-4.487q-1.571-2.839-2.9-5.8"
				fill="none"
				stroke="#00066d"
				strokeWidth={0.232}
			/>
			<path
				d="M472.236 251.169c-1.155.5-3.182-1.653-4.773-4.488q-1.6-2.835-2.965-5.8"
				fill="none"
				stroke="#001178"
				strokeWidth={0.232}
			/>
			<path
				d="M472.236 251.169c-1 .44-3.117-1.653-4.773-4.555-1.81-3.248-2.9-5.708-2.9-5.708"
				fill="none"
				stroke="#00187e"
				strokeWidth={0.232}
			/>
			<path
				d="M472.236 251.169c-.784.283-3.03-1.653-4.621-4.622-1.962-3.4-3.03-5.708-3.03-5.708"
				fill="none"
				stroke="#002086"
				strokeWidth={0.232}
			/>
			<path
				d="M472.236 251.084c-.632.285-2.964-1.59-4.621-4.62-1.962-3.556-3.03-5.715-3.03-5.715"
				fill="none"
				stroke="#002b91"
				strokeWidth={0.232}
			/>
			<path
				d="M472.236 251.084c-.5.195-2.9-1.59-4.556-4.777-2.027-3.617-3.117-5.642-3.117-5.642"
				fill="none"
				stroke="#039"
				strokeWidth={0.232}
			/>
			<path
				d="M472.236 251.084c-.282.128-2.812-1.59-4.556-4.838-2.027-3.84-3.03-5.582-3.03-5.582"
				fill="none"
				stroke="#0039a0"
				strokeWidth={0.232}
			/>
			<path
				d="M472.236 251.084a12.192 12.192 0 01-4.49-4.838c-2.093-4.057-3.118-5.648-3.118-5.648"
				fill="none"
				stroke="#0045ab"
				strokeWidth={0.232}
			/>
			<path
				d="M464.628 240.576a47.8 47.8 0 013.117 5.49 13.028 13.028 0 004.491 4.93m7.63 8l3.9 2.16m-3.684 1.612l3.684-.636"
				fill="none"
				stroke="#004bb3"
				strokeWidth={0.232}
			/>
			<path
				d="M479.715 259.215l4.053 1.943"
				fill="none"
				stroke="#0045ab"
				strokeWidth={0.232}
			/>
			<path
				d="M479.715 259.366l4.119 1.875"
				fill="none"
				stroke="#003ca2"
				strokeWidth={0.232}
			/>
			<path
				d="M479.715 259.583l4.119 1.658"
				fill="none"
				stroke="#00359c"
				strokeWidth={0.232}
			/>
			<path
				d="M479.78 259.718l4.12 1.59"
				fill="none"
				stroke="#002d93"
				strokeWidth={0.232}
			/>
			<path
				d="M479.78 259.868l4.12 1.44"
				fill="none"
				stroke="#00258b"
				strokeWidth={0.232}
			/>
			<path
				d="M479.78 260.086l4.207 1.223"
				fill="none"
				stroke="#001e85"
				strokeWidth={0.232}
			/>
			<path
				d="M479.78 260.237l4.207 1.154"
				fill="none"
				stroke="#00167c"
				strokeWidth={0.232}
			/>
			<path
				d="M479.78 260.46l4.272.931"
				fill="none"
				stroke="#000f75"
				strokeWidth={0.232}
			/>
			<path
				d="M479.78 260.589l4.272.847"
				fill="none"
				stroke="#00066d"
				strokeWidth={0.232}
			/>
			<path
				d="M480.085 262.615l3.683-.565"
				fill="none"
				stroke="#0045ab"
				strokeWidth={0.232}
			/>
			<path
				d="M480.085 262.4l3.771-.413"
				fill="none"
				stroke="#003ca2"
				strokeWidth={0.232}
			/>
			<path d="M480 262.178l3.9-.284" fill="none" stroke="#00359c" strokeWidth={0.232} />
			<path d="M480 262.05l3.9-.134" fill="none" stroke="#002d93" strokeWidth={0.232} />
			<path d="M479.931 261.833h4.056" fill="none" stroke="#00258b" strokeWidth={0.232} />
			<path
				d="M479.931 261.615l4.056.128"
				fill="none"
				stroke="#001e85"
				strokeWidth={0.232}
			/>
			<path
				d="M479.931 261.391l4.12.286"
				fill="none"
				stroke="#00167c"
				strokeWidth={0.232}
			/>
			<path
				d="M479.931 261.241l4.209.351"
				fill="none"
				stroke="#000f75"
				strokeWidth={0.232}
			/>
			<path
				d="M479.931 261.023l4.274.57"
				fill="none"
				stroke="#00066d"
				strokeWidth={0.232}
			/>
			<path d="M479.866 260.806l4.339.72" fill="none" stroke="#006" strokeWidth={0.232} />
			<path
				d="M462.6 273.646c-.064-1.155-.13-2.377-.13-3.117.066-4.993-.633-8.764-.065-14.06.414-4.124 1.439-9.637 1.22-14.063a36.124 36.124 0 01.2-3.773l20.384 22.915"
				fill="none"
				stroke="#000"
				strokeWidth={0.232}
			/>
			<path
				d="M462.6 261.894a13.9 13.9 0 00.938 4.34c.938 1.875 3.772 4.621 7.02 6.671"
				fill="none"
				stroke="#006"
				strokeWidth={0.232}
			/>
			<path
				d="M470.645 272.926a27.9 27.9 0 01-5.276-4.49 18.456 18.456 0 01-1.722-2.245 17.978 17.978 0 01-.937-4.336"
				fill="none"
				stroke="#00056b"
				strokeWidth={0.232}
			/>
			<path
				d="M470.733 272.926a28.179 28.179 0 01-5.276-4.621 10.667 10.667 0 01-1.592-2.158 15.28 15.28 0 01-1.134-4.337"
				fill="none"
				stroke="#000b73"
				strokeWidth={0.232}
			/>
			<path
				d="M470.8 272.926a27.907 27.907 0 01-5.21-4.621 22.114 22.114 0 01-1.656-2.31 16.553 16.553 0 01-1.221-4.34"
				fill="none"
				stroke="#001178"
				strokeWidth={0.232}
			/>
			<path
				d="M470.863 272.861a31.353 31.353 0 01-5.21-4.621 16.624 16.624 0 01-1.59-2.311 19.942 19.942 0 01-1.353-4.336"
				fill="none"
				stroke="#00167c"
				strokeWidth={0.232}
			/>
			<path
				d="M470.95 272.861a33.516 33.516 0 01-5.144-4.709 16.715 16.715 0 01-1.592-2.31 19.369 19.369 0 01-1.439-4.339"
				fill="none"
				stroke="#001e85"
				strokeWidth={0.232}
			/>
			<path
				d="M471.016 272.861a30.149 30.149 0 01-5.058-4.84 12.208 12.208 0 01-1.591-2.244 19.643 19.643 0 01-1.592-4.34"
				fill="none"
				stroke="#002289"
				strokeWidth={0.232}
			/>
			<path
				d="M471.08 272.861a35.725 35.725 0 01-4.99-4.926 16.618 16.618 0 01-1.658-2.246 22.971 22.971 0 01-1.656-4.337"
				fill="none"
				stroke="#00288f"
				strokeWidth={0.232}
			/>
			<path
				d="M471.169 272.861a35.784 35.784 0 01-4.993-4.991 20.963 20.963 0 01-1.592-2.246 25.281 25.281 0 01-1.809-4.338"
				fill="none"
				stroke="#002d93"
				strokeWidth={0.232}
			/>
			<path
				d="M471.234 272.861a45.024 45.024 0 01-4.927-5.058 13.574 13.574 0 01-1.591-2.31 24.962 24.962 0 01-1.94-4.335"
				fill="none"
				stroke="#00359c"
				strokeWidth={0.232}
			/>
			<path
				d="M471.3 272.861a41.287 41.287 0 01-4.84-5.144 16.953 16.953 0 01-1.592-2.311 39.447 39.447 0 01-2.093-4.338"
				fill="none"
				stroke="#0039a0"
				strokeWidth={0.232}
			/>
			<path
				d="M471.386 272.861c-1.962-1.5-3.77-4.12-4.774-5.21a14.617 14.617 0 01-1.657-2.31c-1.068-1.873-2.158-4.34-2.158-4.34"
				fill="none"
				stroke="#003ea6"
				strokeWidth={0.232}
			/>
			<path
				d="M471.452 272.774c-1.94-1.5-3.772-4.12-4.774-5.21a15.13 15.13 0 01-1.5-2.311c-1.221-1.942-2.377-4.335-2.377-4.335"
				fill="none"
				stroke="#0046ad"
				strokeWidth={0.232}
			/>
			<path
				d="M462.754 260.806a60.413 60.413 0 004.054 6.67c.937 1 2.813 3.772 4.71 5.277"
				fill="none"
				stroke="#004bb3"
				strokeWidth={0.232}
			/>
			<path
				d="M462.82 273.646c3.029 2.028 3.77 2.528 10 6.518l1.88-2.964s-.72-1.656-1-2.528"
				fill="none"
				stroke="#00004b"
				strokeWidth={0.232}
			/>
			<path
				d="M462.884 273.646c2.9 1.94 3.837 2.528 9.94 6.365l.066-.065 1.657-2.812a3.29 3.29 0 00-.283-.784q-.312-.819-.567-1.657"
				fill="none"
				stroke="#00004f"
				strokeWidth={0.232}
			/>
			<path
				d="M462.884 273.646c2.747 1.876 3.99 2.681 9.94 6.3l.066-.13c0-.066 1.592-2.813 1.592-2.813s-.066-.282-.2-.719c-.2-.5-.414-1.156-.567-1.591"
				fill="none"
				stroke="#000053"
				strokeWidth={0.232}
			/>
			<path
				d="M462.884 273.646c2.681 1.723 4.208 2.681 9.94 6.147l.066-.13c0-.066 1.439-2.747 1.439-2.747a1.962 1.962 0 00-.195-.72c-.132-.5-.35-1.068-.415-1.5"
				fill="none"
				stroke="#000056"
				strokeWidth={0.232}
			/>
			<path
				d="M462.884 273.581c2.616 1.722 4.338 2.811 9.94 6.082l.066-.066c0-.13 1.373-2.812 1.373-2.812a2.561 2.561 0 00-.13-.632 6.929 6.929 0 01-.414-1.439"
				fill="none"
				stroke="#000058"
				strokeWidth={0.232}
			/>
			<path
				d="M462.884 273.581c2.53 1.656 4.491 2.9 9.94 6.016l.066-.13c0-.2 1.287-2.812 1.287-2.812a1.9 1.9 0 00-.132-.567 5.377 5.377 0 01-.348-1.374"
				fill="none"
				stroke="#00005c"
				strokeWidth={0.232}
			/>
			<path
				d="M462.884 273.581c2.464 1.59 4.71 2.964 9.94 5.864l.132-.131c0-.2 1.068-2.747 1.068-2.747a.945.945 0 00-.065-.566 4.55 4.55 0 01-.284-1.286"
				fill="none"
				stroke="#000060"
				strokeWidth={0.232}
			/>
			<path
				d="M462.884 273.581c2.4 1.5 4.84 2.964 9.94 5.712l.132-.132c0-.2 1-2.747 1-2.747s.065-.13-.066-.5a11.292 11.292 0 01-.283-1.221"
				fill="none"
				stroke="#000062"
				strokeWidth={0.232}
			/>
			<path
				d="M462.884 273.581c2.246 1.439 4.993 3.03 9.94 5.646l.132-.131c0-.283.937-2.747.85-2.747 0 0 .131-.13 0-.5a6.88 6.88 0 01-.2-1.155"
				fill="none"
				stroke="#006"
				strokeWidth={0.232}
			/>
			<path
				d="M462.972 273.516a90.978 90.978 0 009.853 5.58l.131-.13c0-.283.785-2.748.785-2.748s.13-.065 0-.414a2.821 2.821 0 01-.131-1.068"
				fill="none"
				stroke="#00056b"
				strokeWidth={0.232}
			/>
			<path
				d="M462.972 273.516a72.127 72.127 0 009.853 5.427c.065 0 .131-.13.131-.13 0-.35.72-2.682.72-2.682a.446.446 0 00.065-.414 1.693 1.693 0 01-.131-1"
				fill="none"
				stroke="#00066d"
				strokeWidth={0.232}
			/>
			<path
				d="M462.972 273.516a76.1 76.1 0 009.853 5.362c.065-.066.131-.131.131-.195 0-.285.567-2.595.567-2.595a.407.407 0 00.13-.436 2.145 2.145 0 01-.13-.938"
				fill="none"
				stroke="#00096f"
				strokeWidth={0.232}
			/>
			<path
				d="M463.037 273.516a74.825 74.825 0 009.788 5.21l.131-.132c0-.414.5-2.68.5-2.68s.195-.066.13-.35a1.82 1.82 0 01-.065-.85"
				fill="none"
				stroke="#000b73"
				strokeWidth={0.232}
			/>
			<path
				d="M463.037 273.516a69.139 69.139 0 009.788 5.078l.131-.13c0-.436.414-2.595.349-2.681 0 0 .349-.066.2-.284-.13-.349 0-.349 0-.785"
				fill="none"
				stroke="#001178"
				strokeWidth={0.232}
			/>
			<path
				d="M463.037 273.516a64.264 64.264 0 009.853 4.991l.066-.195c0-.415.349-2.6.283-2.6 0 0 .284-.065.2-.283-.13-.284 0-.284.066-.72"
				fill="none"
				stroke="#001379"
				strokeWidth={0.232}
			/>
			<path
				d="M463.037 273.428a47.808 47.808 0 009.853 4.927c.066 0 .066-.2.066-.2 0-.414.2-2.53.2-2.595 0 0 .283 0 .2-.195-.13-.284.066-.284.131-.634"
				fill="none"
				stroke="#00167c"
				strokeWidth={0.232}
			/>
			<path
				d="M463.037 273.428a46.134 46.134 0 009.853 4.773c.066 0 .066-.13.066-.13 0-.5.13-2.594.065-2.681 0 0 .414.065.283-.13-.064-.284.131-.2.2-.567"
				fill="none"
				stroke="#001c82"
				strokeWidth={0.232}
			/>
			<path
				d="M463.037 273.363a45.7 45.7 0 009.853 4.773c.066-.064.066-.2.131-.2 0-.566-.065-2.529-.065-2.594 0 0 .349.065.283-.13-.065-.283.131-.13.284-.5"
				fill="none"
				stroke="#001e85"
				strokeWidth={0.232}
			/>
			<path
				d="M463.037 273.363c1.286.85 6.518 3.836 9.853 4.621.066-.065.066-.13.131-.2a21.567 21.567 0 00-.2-2.594s.415.13.415-.066c-.132-.195.065-.065.282-.414"
				fill="none"
				stroke="#002086"
				strokeWidth={0.232}
			/>
			<path
				d="M463.037 273.363c1.22.785 6.649 3.9 9.853 4.49.066 0 .131-.13.131-.195a15.021 15.021 0 00-.282-2.53s.5.066.413-.065c-.13-.195.13 0 .349-.349"
				fill="none"
				stroke="#00258b"
				strokeWidth={0.232}
			/>
			<path
				d="M463.1 273.363c1 .719 6.735 3.989 9.787 4.425.066-.065.131-.13.131-.2a24.235 24.235 0 00-.35-2.53s.5.066.351-.065c0-.195.283.066.413-.282"
				fill="none"
				stroke="#00288f"
				strokeWidth={0.232}
			/>
			<path
				d="M463.1 273.363c.937.632 6.888 4.054 9.787 4.272.066-.065.131-.13.131-.195a11.133 11.133 0 00-.5-2.53s.5.131.5 0c-.065-.2.283.131.414-.2"
				fill="none"
				stroke="#002b91"
				strokeWidth={0.232}
			/>
			<path
				d="M463.1 273.363c.85.5 7.106 4.054 9.853 4.207 0-.13.065-.2.065-.282a11.628 11.628 0 00-.567-2.53s.567.131.5.066c-.066-.2.283.195.5-.131"
				fill="none"
				stroke="#002d93"
				strokeWidth={0.232}
			/>
			<path
				d="M463.1 273.3c.784.5 7.238 4.207 9.853 4.12 0-.066.065-.2.065-.284a7.429 7.429 0 00-.72-2.463s.634.13.567 0c-.065-.065.35.349.567 0"
				fill="none"
				stroke="#039"
				strokeWidth={0.232}
			/>
			<path
				d="M463.1 273.3c.718.5 7.39 4.272 9.853 3.989 0-.066.065-.13.065-.2a8.225 8.225 0 00-.785-2.529s.567.195.567.13c-.065-.13.414.35.633 0"
				fill="none"
				stroke="#00359c"
				strokeWidth={0.232}
			/>
			<path
				d="M463.1 273.3c.632.348 7.608 4.337 9.853 3.836a.655.655 0 00.065-.195 7.635 7.635 0 00-.85-2.465v-.065s.633.283.567.2c0-.132.414.414.72.065"
				fill="none"
				stroke="#00389e"
				strokeWidth={0.232}
			/>
			<path
				d="M463.1 273.3c.5.282 7.76 4.337 9.853 3.77a.422.422 0 00.065-.282 7.132 7.132 0 00-1-2.465s.72.285.633.2c0-.13.5.5.784.13"
				fill="none"
				stroke="#003ca2"
				strokeWidth={0.232}
			/>
			<path
				d="M463.168 273.3c.349.195 7.826 4.425 9.788 3.619.065-.067.065-.2.13-.284a8.378 8.378 0 00-1.155-2.464s.72.35.72.2c-.066 0 .5.633.784.284"
				fill="none"
				stroke="#003ea6"
				strokeWidth={0.232}
			/>
			<path
				d="M463.168 273.3c.282.13 7.978 4.49 9.788 3.552a1.773 1.773 0 01.13-.282 6.175 6.175 0 00-1.286-2.47s.784.285.719.285c0-.067.567.567.938.282"
				fill="none"
				stroke="#0042a8"
				strokeWidth={0.232}
			/>
			<path
				d="M463.168 273.21c.2.13 8.109 4.621 9.788 3.466.065-.065.065-.13.13-.283 0-.85-1.285-2.311-1.373-2.377l.785.284c-.065-.065.567.633.85.349"
				fill="none"
				stroke="#0045ab"
				strokeWidth={0.232}
			/>
			<path
				d="M463.168 273.21c.13.065 8.327 4.709 9.788 3.335a.35.35 0 00.13-.282c0-.938-1.373-2.312-1.5-2.377l.85.283s.566.786.937.5"
				fill="none"
				stroke="#0049af"
				strokeWidth={0.232}
			/>
			<path
				d="M463.255 273.146s9.417 5.361 9.853 2.963c0-.937-1.59-2.31-1.59-2.31l.85.283s.631.85 1 .567"
				fill="none"
				stroke="#004bb3"
				strokeWidth={0.232}
			/>
			<path
				d="M464.258 237.808c0-.938.5-2.026 1.155-2.026a4.925 4.925 0 01.785.061c.35.134.414.285.5.636.132.781-.85 1.066-1.59 1.156-.2 0-.72-.068-.786.128-.2.285-.065.195-.2.285a.429.429 0 00.283-.135c.633-.127 1.155-.127 1.94-.278.5-.068.85-1.156.567-1.591-.283-.351-1.591-.72-1.962-.42a3.15 3.15 0 00-1.155 2.468c.065-.194.349-.067.414-.284"
				fill="#fc0"
			/>
			<path
				d="M464.258 237.808c0-.938.5-2.026 1.155-2.026a4.925 4.925 0 01.785.061c.35.134.414.285.5.636.132.781-.85 1.066-1.59 1.156-.2 0-.72-.068-.786.128-.2.285-.065.195-.2.285a.429.429 0 00.283-.135c.633-.127 1.155-.127 1.94-.278.5-.068.85-1.156.567-1.591-.283-.351-1.591-.72-1.962-.42a3.15 3.15 0 00-1.155 2.468c.065-.194.349-.067.414-.284z"
				fill="none"
				stroke="#000"
				strokeWidth={0.173}
			/>
			<path
				d="M463.756 238.092c-.85-.284-2.006-.134-2.223.413a5.648 5.648 0 00-.2.787.68.68 0 00.437.715c.632.35 1.286-.5 1.57-1.156a1.483 1.483 0 01.413-.714c.349-.068.284 0 .349-.068-.065.13-.2.2-.283.285-.284.5-.5.938-.938 1.653a1.154 1.154 0 01-1.656.067 2.252 2.252 0 01.283-2.026 2.822 2.822 0 012.66-.195c-.131-.068-.2.284-.415.195"
				fill="#fc0"
			/>
			<path
				d="M463.756 238.092c-.85-.284-2.006-.134-2.223.413a3.882 3.882 0 00-.2.787.68.68 0 00.437.715c.632.35 1.286-.5 1.57-1.156a1.483 1.483 0 01.413-.714c.349-.068.284 0 .349-.068-.065.13-.2.2-.283.285-.284.5-.5.938-.938 1.653a1.154 1.154 0 01-1.656.067 2.252 2.252 0 01.283-2.026 2.822 2.822 0 012.66-.195c-.131-.068-.2.284-.415.195z"
				fill="none"
				stroke="#000"
				strokeWidth={0.173}
			/>
			<path
				d="M463.69 237.673c-.282 0-.348.42-.282.637 0 .194.348.345.566.284a.748.748 0 00.567-.786c-.13-.352-.567-.195-.85-.135"
				fill="#fc0"
			/>
			<path
				d="M463.69 237.673c-.282 0-.348.42-.282.637 0 .194.348.345.566.284a.748.748 0 00.567-.786c-.13-.352-.567-.195-.85-.135"
				fill="none"
				stroke="#000"
				strokeWidth={0.173}
			/>
			<path
				d="M459.68 233.532a15.319 15.319 0 003.99 2.032 5.785 5.785 0 000 2.244 5.536 5.536 0 00-2.53-.5 9.844 9.844 0 00-1.438-3.773"
				fill="#fc0"
			/>
			<path
				d="M459.68 233.532a15.319 15.319 0 003.99 2.032 5.785 5.785 0 000 2.244 5.536 5.536 0 00-2.53-.5 9.844 9.844 0 00-1.438-3.773z"
				fill="none"
				stroke="#000"
				strokeWidth={0.173}
			/>
			<path
				d="M461.294 235.19a5.7 5.7 0 001.59.787 1.8 1.8 0 000 .848 2.815 2.815 0 00-1-.128 3.466 3.466 0 00-.566-1.507z"
				fill="none"
				stroke="#000"
				strokeWidth={0.173}
			/>
			<path
				d="M463.386 239.549a11.331 11.331 0 00.85-.937c.065-.129-.35.937.065 1.221a5.388 5.388 0 010 2.595 2.232 2.232 0 01-2.026-.345c-.284-.285.065-.855.282-1.29a5.224 5.224 0 01.785-1.222"
				fill="#fc0"
			/>
			<path
				d="M463.386 239.549a11.331 11.331 0 00.85-.937c.065-.129-.35.937.065 1.221a5.388 5.388 0 010 2.595 2.232 2.232 0 01-2.026-.345c-.284-.285.065-.855.282-1.29a5.224 5.224 0 01.785-1.222z"
				fill="none"
				stroke="#000"
				strokeWidth={0.173}
			/>
			<path
				d="M463.974 239.113c0 .068-.065.42-.065.5.065.195.283.284.349.569a13.243 13.243 0 01-.13 2.154m-.219-2.416a7.672 7.672 0 01-.065 2.46h.065m-.153-.937a2.006 2.006 0 00-.13.938c-.066-.062-.2.067-.283.067"
				fill="none"
				stroke="#000"
				strokeWidth={0.173}
			/>
			<path
				d="M501.624 326.9c.13 0 .282-.134.413-.195.349-.2 1-.2 1.22-.42 1-1.154.35-3.33-.13-4.7-.784-2.533-.85-4.844-1.439-7.238h-.065a55.114 55.114 0 01-1.5 7.238c-.35 1.373-1.069 3.55-.066 4.705.2.2.85.2 1.286.419.066.061.2.195.284.195"
				fill="#fff"
			/>
			<path
				d="M501.624 314.213c-.5 2.377-.633 4.839-1.5 7.394-.35 1.218-1 3.249-.2 4.42l-.066-.06h.066a3.169 3.169 0 01-1.069-.195c-.066-.069-.2-.069-.282-.2a1.8 1.8 0 00-.5-.5c-.2-.133-.5-.066-.719-.2-.065-.062-.13-.13-.2-.13a2.587 2.587 0 01-1.221-1.065 3.84 3.84 0 01-.066-1.221c.066-.286.2-.5.284-.788a5.751 5.751 0 01.5-1.065 7.874 7.874 0 01.567-1.156 190.615 190.615 0 01.566-1c.066-.195.283-.285.415-.5.13-.128-.16 0-.006-.16a2.781 2.781 0 00.358-.463c.065 0 .313-.1.313-.157.414-.72.73-.833 1.012-1.575a2.214 2.214 0 00.2-1.155h1.5"
				fill="#004bb3"
			/>
			<path
				d="M500.9 314.28a34.94 34.94 0 01-1.5 5c-.566 1-2.813 2.808-1.374 5.709"
				fill="none"
				stroke="#003"
				strokeWidth={0.232}
			/>
			<path
				d="M501.056 314.28a34.94 34.94 0 01-1.5 5c-.633 1.066-2.835 2.963-1.286 5.86"
				fill="none"
				stroke="#00004b"
				strokeWidth={0.232}
			/>
			<path
				d="M501.121 314.28a39 39 0 01-1.5 5.146c-.567 1-2.812 2.963-1.22 5.864"
				fill="none"
				stroke="#006"
				strokeWidth={0.232}
			/>
			<path
				d="M501.273 314.28a34.292 34.292 0 01-1.525 5.146c-.633 1-2.812 3.03-1.221 6.016"
				fill="none"
				stroke="#00187e"
				strokeWidth={0.232}
			/>
			<path
				d="M501.34 314.28a35.98 35.98 0 01-1.5 5.212c-.567 1-2.747 3.115-1.155 6.079"
				fill="none"
				stroke="#039"
				strokeWidth={0.232}
			/>
			<path
				d="M501.405 314.28s-.85 4.275-1.5 5.275c-.566 1-2.68 3.185-1.067 6.15"
				fill="none"
				stroke="#004bb3"
				strokeWidth={0.232}
			/>
			<path
				d="M500.838 314.28a38.373 38.373 0 01-1.5 4.928c-.567 1.066-2.9 2.9-1.374 5.71"
				fill="none"
				stroke="#00004b"
				strokeWidth={0.232}
			/>
			<path
				d="M500.75 314.37a34.783 34.783 0 01-1.59 4.838c-.568 1-2.9 2.9-1.374 5.71"
				fill="none"
				stroke="#006"
				strokeWidth={0.232}
			/>
			<path
				d="M500.6 314.37a27.385 27.385 0 01-1.592 4.838c-.5 1-2.811 2.813-1.286 5.71"
				fill="none"
				stroke="#00187e"
				strokeWidth={0.232}
			/>
			<path
				d="M500.533 314.37a21.653 21.653 0 01-1.656 4.772c-.5 1.071-2.813 2.9-1.287 5.714"
				fill="none"
				stroke="#039"
				strokeWidth={0.232}
			/>
			<path
				d="M500.4 314.37a25.7 25.7 0 01-1.592 4.772c-.567 1-2.812 2.9-1.286 5.714"
				fill="none"
				stroke="#004bb3"
				strokeWidth={0.232}
			/>
			<path
				d="M501.624 314.213c.565 2.377.719 4.839 1.5 7.394.414 1.218 1.069 3.249.283 4.42l.01-.148a2.841 2.841 0 001.059-.216c.13-.069.195-.046.283-.18a2.5 2.5 0 01.436-.409c.283-.134.567-.068.85-.2.066-.062.066-.13.13-.13a1.827 1.827 0 001.287-2.286 2.835 2.835 0 00-.283-.788 5.877 5.877 0 00-.5-1.065 8.08 8.08 0 00-.567-1.156 1.16 1.16 0 00-.283-.5 2.78 2.78 0 00-.284-.5c-.066-.195-.283-.285-.414-.5-.18-.32-.3-.281-.37-.438-.065 0-.092.063 0 0-.066 0-.168-.146-.256-.207a7.183 7.183 0 01-1.07-1.706 2.217 2.217 0 01-.2-1.156h-1.59"
				fill="#004bb3"
			/>
			<path
				d="M502.43 314.28a35.041 35.041 0 001.5 5c.567 1 2.813 2.808 1.286 5.709"
				fill="none"
				stroke="#003"
				strokeWidth={0.232}
			/>
			<path
				d="M502.276 314.28a28.091 28.091 0 001.592 5c.567 1.066 3.066 2.594 1.54 5.49"
				fill="none"
				stroke="#00004b"
				strokeWidth={0.232}
			/>
			<path
				d="M502.211 314.28a39 39 0 001.5 5.146c.567 1 2.885 2.8 1.293 5.7"
				fill="none"
				stroke="#006"
				strokeWidth={0.232}
			/>
			<path
				d="M502.06 314.28a36.435 36.435 0 001.59 5.146c.563 1 2.815 2.753 1.358 5.7-.007.013-.034.013-.04.027s.227-.251.04-.027"
				fill="none"
				stroke="#00187e"
				strokeWidth={0.232}
			/>
			<path
				d="M501.994 314.28s.936 4.209 1.59 5.212c.5 1 2.682 3.115 1.068 6.079"
				fill="none"
				stroke="#039"
				strokeWidth={0.232}
			/>
			<path
				d="M501.928 314.28a36.187 36.187 0 001.5 5.275c.567 1 2.682 3.185 1.068 6.15"
				fill="none"
				stroke="#004bb3"
				strokeWidth={0.232}
			/>
			<path
				d="M502.5 314.28a30.09 30.09 0 001.591 4.928c.566 1.066 2.813 2.9 1.286 5.71"
				fill="none"
				stroke="#00004b"
				strokeWidth={0.232}
			/>
			<path
				d="M502.647 314.37a31.333 31.333 0 001.5 4.838c.566 1 2.9 2.9 1.373 5.71"
				fill="none"
				stroke="#006"
				strokeWidth={0.232}
			/>
			<path
				d="M502.713 314.37a27.5 27.5 0 001.59 4.838c.568 1 2.813 2.813 1.374 5.71"
				fill="none"
				stroke="#00187e"
				strokeWidth={0.232}
			/>
			<path
				d="M502.8 314.37a29.831 29.831 0 001.591 4.772c.567 1.071 2.9 2.9 1.374 5.714"
				fill="none"
				stroke="#039"
				strokeWidth={0.232}
			/>
			<path
				d="M502.93 314.37a25.7 25.7 0 001.592 4.772c.567 1 2.9 2.9 1.373 5.714"
				fill="none"
				stroke="#004bb3"
				strokeWidth={0.232}
			/>
			<path
				d="M504.85 317.461a7.077 7.077 0 01.642 1 4.6 4.6 0 01.283.5 1.291 1.291 0 01.284.5 10.474 10.474 0 01.567 1.155 10.931 10.931 0 01.5 1.066 5.762 5.762 0 01.282.787 2.541 2.541 0 01-.064 1.217 2.48 2.48 0 01-1.22 1.071s-.067.062-.132.129c-.283.133-.566.066-.85.195a3.884 3.884 0 00-.436.5c-.065.134-.13.134-.283.195a2.678 2.678 0 01-1.068.2v0a.417.417 0 01-.132.28c-.2.194-.85.194-1.22.418-.13.062-.283.195-.414.195-.066 0-.2-.133-.283-.195-.415-.2-1.069-.2-1.287-.419a.338.338 0 01-.13-.28v0a3.013 3.013 0 01-1.069-.2c-.065-.062-.2-.062-.282-.2a1.888 1.888 0 00-.5-.5c-.2-.129-.5-.062-.721-.195-.064-.068-.13-.129-.195-.129a2.573 2.573 0 01-1.222-1.051 3.78 3.78 0 01-.066-1.218c.066-.283.2-.5.283-.786a5.737 5.737 0 01.5-1.066 7.873 7.873 0 01.567-1.155 1.142 1.142 0 01.283-.5 1.16 1.16 0 01.284-.5 10.327 10.327 0 01.645-.874"
				fill="none"
				stroke="#000"
				strokeWidth={0.232}
			/>
			<path
				d="M459.37 272.661c-.341 6.572-.192 8.481-.192 14.894a31.329 31.329 0 003.006 10.68l6.678-11.159h-.027a23.483 23.483 0 01-1.22-4.273 18.507 18.507 0 01-.2-4.812z"
				fill="#fff"
			/>
			<path
				d="M468.836 287.075a23.365 23.365 0 01-1.221-4.274 18.582 18.582 0 01-.2-4.84l4.927 3.184-3.466 5.93"
				fill="#004bb3"
			/>
			<path d="M472.825 280.4l-23.283-15.216-.414.567 23.217 15.434.5-.785" fill="#fc0" />
			<path
				d="M472.825 280.4l-23.283-15.216-.414.567 23.217 15.434.5-.785z"
				fill="none"
				stroke="#000"
				strokeWidth={0.173}
			/>
			<path
				d="M454.84 310.508a5.157 5.157 0 01-1.723-2.154 17.677 17.677 0 01-.936-3.471c-.2-1.066-.2-2.244-.5-3.334-.132-1.068-1.723-4.621-1.81-6.016-.131-4.622-1.657-7.76-1.286-12.753.282-3.9 1.155-9.2.72-13.276a30.771 30.771 0 01.065-3.467l10 6.52c-.347 6.67-.194 8.545-.194 15a31.226 31.226 0 003.03 10.726l-7.324 12.25"
				fill="#004bb3"
			/>
			<path
				d="M462.078 298.236l-7.326 12.25a5.488 5.488 0 01-1.808-2.155c-.5-1.657-.414-1.657-.85-3.465-.2-1.071-.2-2.248-.414-3.338-.283-1.068-1.81-4.622-1.876-6.017m-.043-.021c.066 1.373 1.591 4.84 1.875 5.93.2 1.067.2 2.244.414 3.334a23.237 23.237 0 00.937 3.466 4.974 4.974 0 001.744 2.093l7.325-12.1"
				fill="none"
				stroke="#00004b"
				strokeWidth={0.232}
			/>
			<path
				d="M449.761 295.49c.066 1.373 1.591 4.773 1.81 5.864.282 1.068.282 2.245.566 3.333a29.441 29.441 0 00.85 3.466 5.536 5.536 0 001.744 2.092s7.238-11.965 7.325-12.03m-12.295-2.725c.066 1.373 1.591 4.773 1.81 5.864.282 1 .282 2.158.566 3.25a28.667 28.667 0 00.85 3.4 4.855 4.855 0 001.744 2.025c.066.067 7.238-11.748 7.325-11.813"
				fill="none"
				stroke="#00004f"
				strokeWidth={0.232}
			/>
			<path
				d="M449.761 295.49c.066 1.286 1.591 4.708 1.81 5.8.282 1.068.282 2.159.566 3.182a25.82 25.82 0 00.85 3.4 5.626 5.626 0 001.744 2.093c.131 0 7.238-11.665 7.325-11.752m-12.295-2.725c.066 1.286 1.591 4.621 1.81 5.711.282 1 .282 2.158.566 3.185a15.4 15.4 0 00.938 3.332 5.116 5.116 0 001.722 2.092c.065 0 7.106-11.53 7.238-11.6"
				fill="none"
				stroke="#000051"
				strokeWidth={0.232}
			/>
			<path
				d="M449.761 295.49c.066 1.286 1.5 4.556 1.81 5.646.282 1 .282 2.158.566 3.183a17.733 17.733 0 00.938 3.337 4.986 4.986 0 001.722 2.026c.065.067 7.106-11.38 7.238-11.446m-12.275-2.747c.067 1.286 1.5 4.557 1.81 5.582.283 1.068.283 2.158.567 3.182a20.532 20.532 0 00.938 3.247 4.532 4.532 0 001.722 2.027c.13.066 7.019-11.225 7.238-11.312"
				fill="none"
				stroke="#000053"
				strokeWidth={0.232}
			/>
			<path
				d="M449.761 295.49c.066 1.286 1.5 4.49 1.81 5.58.282 1 .282 2.093.566 3.118a25.181 25.181 0 00.938 3.244 5.509 5.509 0 001.722 1.944c.13.066 7.019-11.1 7.238-11.161m-12.275-2.725c.067 1.22 1.5 4.425 1.81 5.428.283 1.068.283 2.158.567 3.182a21.934 21.934 0 00.938 3.182 5.023 5.023 0 001.722 1.943c.13.06 7.019-10.945 7.238-11.01m-12.275-2.725c.067 1.22 1.5 4.425 1.81 5.428.283 1 .283 2.026.567 3.03a18.168 18.168 0 00.938 3.184 4.568 4.568 0 001.722 1.936c.2.068 6.953-10.788 7.238-10.876"
				fill="none"
				stroke="#000056"
				strokeWidth={0.232}
			/>
			<path
				d="M449.761 295.49c.066 1.22 1.5 4.338 1.81 5.363.282 1 .282 2.092.566 3.03a28.323 28.323 0 00.938 3.115 4.58 4.58 0 001.722 1.942c.2.066 6.953-10.66 7.238-10.725m-12.275-2.725c.067 1.22 1.5 4.273 1.81 5.275.283 1 .283 2.092.567 2.964a18.2 18.2 0 001 3.186 4.682 4.682 0 001.656 1.874c.284.129 6.955-10.443 7.238-10.574"
				fill="none"
				stroke="#000058"
				strokeWidth={0.232}
			/>
			<path
				d="M449.761 295.49c.066 1.22 1.5 4.273 1.81 5.275.282.938.282 1.94.566 2.9a19.051 19.051 0 001 3.115 5.423 5.423 0 001.656 1.942c.284.067 6.89-10.355 7.238-10.507m-12.273-2.725c.066 1.155 1.438 4.207 1.81 5.21.282.937.282 1.962.566 2.9a19.39 19.39 0 001 3.12 5.373 5.373 0 001.656 1.87c.284.067 6.89-10.221 7.238-10.353"
				fill="none"
				stroke="#00005c"
				strokeWidth={0.232}
			/>
			<path
				d="M449.761 295.49c.066 1.155 1.438 4.12 1.81 5.144.282.938.348 1.94.566 2.9a16.05 16.05 0 001 3.03 4.686 4.686 0 001.656 1.873c.35.068 6.89-10.07 7.238-10.222m-12.273-2.725c.066 1.068 1.438 4.054 1.81 5.057.282 1 .348 1.94.566 2.9a18.287 18.287 0 001 2.965 4.676 4.676 0 001.656 1.874c.35.129 6.89-9.918 7.238-10.071"
				fill="none"
				stroke="#00005e"
				strokeWidth={0.232}
			/>
			<path
				d="M449.761 295.425c.066 1.155 1.438 4.12 1.81 5.143.282.852.348 1.875.566 2.813a15.671 15.671 0 001 2.9 5.32 5.32 0 001.656 1.875c.35.133 6.8-9.785 7.238-9.917m-12.273-2.811a21.3 21.3 0 001.81 4.991c.282.938.348 1.94.566 2.813.5 1.5.5 1.5 1 2.965A4.622 4.622 0 00454.8 308c.415.129 6.737-9.634 7.238-9.787m-12.273-2.79a22.413 22.413 0 001.81 4.991 26.158 26.158 0 00.632 2.747 23.54 23.54 0 001 2.964 4.535 4.535 0 001.59 1.724c.5.129 6.737-9.483 7.239-9.636"
				fill="none"
				stroke="#000060"
				strokeWidth={0.232}
			/>
			<path
				d="M449.761 295.425c.066 1.155 1.352 3.9 1.81 4.926a26.216 26.216 0 00.632 2.747 19.5 19.5 0 001 2.9 5.327 5.327 0 001.59 1.719c.5.134 6.737-9.35 7.239-9.482m-12.275-2.811a21.726 21.726 0 001.81 4.838 26.551 26.551 0 00.633 2.747 20.244 20.244 0 001 2.81 6.005 6.005 0 001.656 1.814c.414.061 6.671-9.266 7.172-9.42"
				fill="none"
				stroke="#000062"
				strokeWidth={0.232}
			/>
			<path
				d="M449.761 295.425a22.88 22.88 0 001.81 4.838c.195.85.348 1.81.632 2.682a16.74 16.74 0 001 2.747 4.681 4.681 0 001.656 1.725c.5.194 6.6-8.984 7.172-9.2m-12.273-2.79a21.127 21.127 0 001.81 4.773c.195.85.348 1.809.632 2.682a15.744 15.744 0 001.067 2.745 4.182 4.182 0 001.592 1.657c.5.195 6.6-8.85 7.172-9.067"
				fill="none"
				stroke="#006"
				strokeWidth={0.232}
			/>
			<path
				d="M449.761 295.425a20.652 20.652 0 001.81 4.708 23.344 23.344 0 00.632 2.594 12.569 12.569 0 001.067 2.747 4.505 4.505 0 001.592 1.72c.5.133 6.6-8.761 7.172-8.98m-12.273-2.79a19.992 19.992 0 001.81 4.622 23.738 23.738 0 00.632 2.616 20.884 20.884 0 001.067 2.745 4.831 4.831 0 001.592 1.658c.567.128 6.517-8.632 7.172-8.85"
				fill="none"
				stroke="#000268"
				strokeWidth={0.232}
			/>
			<path
				d="M449.761 295.425a19.336 19.336 0 001.81 4.621c.195.784.348 1.656.632 2.528a18.974 18.974 0 001.067 2.683 4.353 4.353 0 001.592 1.657c.567.195 6.453-8.481 7.172-8.7m-12.273-2.79a16.583 16.583 0 001.81 4.491 14.859 14.859 0 00.718 2.594 10.409 10.409 0 001 2.591 4.251 4.251 0 001.592 1.658c.566.2 6.451-8.325 7.171-8.543m-12.295-2.79a17.489 17.489 0 001.81 4.49 12.2 12.2 0 00.718 2.463 13.1 13.1 0 001 2.594 4.317 4.317 0 001.592 1.657c.63.129 6.451-8.11 7.171-8.414"
				fill="none"
				stroke="#00056b"
				strokeWidth={0.232}
			/>
			<path
				d="M449.761 295.425a18.388 18.388 0 001.81 4.424 12.21 12.21 0 00.718 2.464 15.508 15.508 0 001 2.591 5.438 5.438 0 001.592 1.592c.63.2 6.451-7.976 7.171-8.26m-12.295-2.811a17.505 17.505 0 001.81 4.338 13.571 13.571 0 00.718 2.462 13.082 13.082 0 001 2.53 4.117 4.117 0 001.592 1.59c.718.195 6.386-7.825 7.171-8.109"
				fill="none"
				stroke="#00066d"
				strokeWidth={0.232}
			/>
			<path
				d="M449.761 295.425a17.505 17.505 0 001.81 4.338 19.575 19.575 0 00.718 2.376 13.11 13.11 0 001.069 2.526 3.815 3.815 0 001.5 1.507c.72.194 6.388-7.674 7.172-7.979m-12.273-2.768a20.683 20.683 0 001.722 4.272c.283.72.5 1.591.785 2.376a11.084 11.084 0 001.068 2.464 5.516 5.516 0 001.5 1.59c.72.134 6.387-7.608 7.172-7.891"
				fill="none"
				stroke="#00096f"
				strokeWidth={0.232}
			/>
			<path
				d="M449.827 295.425a13.976 13.976 0 001.656 4.207c.283.784.5 1.59.785 2.31a10.957 10.957 0 001.068 2.46 4.293 4.293 0 001.5 1.508c.785.284 6.3-7.39 7.172-7.674m-12.186-2.811a14.447 14.447 0 001.657 4.12c.283.785.5 1.591.785 2.31a15.292 15.292 0 001.068 2.465 4.126 4.126 0 001.5 1.439c.785.28 6.3-7.24 7.172-7.544"
				fill="none"
				stroke="#000b73"
				strokeWidth={0.232}
			/>
			<path
				d="M449.827 295.425a14.074 14.074 0 001.656 4.054c.283.784.5 1.592.785 2.31a12.493 12.493 0 001.068 2.4 4.974 4.974 0 001.5 1.5c.785.195 6.3-7.172 7.172-7.456m-12.186-2.811a13.731 13.731 0 001.657 3.989c.283.784.5 1.592.785 2.31.414 1.156.567 1.221 1.068 2.376a6.638 6.638 0 001.5 1.441c.85.195 6.234-7.021 7.172-7.325m-12.186-2.791a13.731 13.731 0 001.657 3.989c.283.719.5 1.5.785 2.244a20.21 20.21 0 001.068 2.312 5.586 5.586 0 001.591 1.437c.85.285 6.147-6.887 7.107-7.17"
				fill="none"
				stroke="#000f75"
				strokeWidth={0.232}
			/>
			<path
				d="M449.827 295.425c0 .85 1.154 3.03 1.656 3.9.283.72.5 1.5.785 2.246a14.748 14.748 0 001.155 2.245 4.134 4.134 0 001.5 1.44c.85.195 6.082-6.671 7.107-7.021m-12.207-2.811a13.705 13.705 0 001.656 3.836c.283.72.5 1.5.785 2.159a12.1 12.1 0 001.155 2.31 4.482 4.482 0 001.5 1.37c.85.284 6.082-6.514 7.107-6.885"
				fill="none"
				stroke="#001178"
				strokeWidth={0.232}
			/>
			<path
				d="M449.827 295.425c0 .784 1.154 2.9 1.656 3.836.283.632.5 1.373.785 2.093a12.214 12.214 0 001.155 2.245 4.5 4.5 0 001.5 1.373c.938.285 6.082-6.365 7.107-6.736m-12.207-2.811a10.2 10.2 0 001.656 3.683c.283.72.5 1.5.785 2.159a10.91 10.91 0 001.155 2.158 4.5 4.5 0 001.5 1.374c.938.284 6.017-6.235 7.107-6.584"
				fill="none"
				stroke="#001379"
				strokeWidth={0.232}
			/>
			<path
				d="M449.827 295.425a10.9 10.9 0 001.656 3.683c.283.633.5 1.439.785 2.093a13 13 0 001.155 2.158 4.207 4.207 0 001.5 1.284c.938.285 6.017-6.079 7.107-6.45m-12.207-2.768a10.632 10.632 0 001.656 3.618c.283.72.5 1.373.785 2.093.5 1 .632 1.068 1.155 2.093a5.707 5.707 0 001.5 1.374c1 .28 6.017-6.017 7.107-6.367"
				fill="none"
				stroke="#00167c"
				strokeWidth={0.232}
			/>
			<path
				d="M449.827 295.425a10.353 10.353 0 001.656 3.552c.283.634.5 1.374.785 2.094.5 1 .632 1.068 1.155 2.092a6.556 6.556 0 001.5 1.284c1 .285 5.93-5.861 7.107-6.232m-12.207-2.79a8.821 8.821 0 001.656 3.465 18.756 18.756 0 00.85 2.028 17.2 17.2 0 001.068 2.092 4.23 4.23 0 001.5 1.221c1 .35 5.93-5.645 7.106-6.016m-12.186-2.79a10.122 10.122 0 001.657 3.465c.283.633.5 1.286.85 1.94a10.414 10.414 0 001.156 2.027 5.648 5.648 0 001.438 1.287c1.069.28 5.865-5.58 7.107-5.93"
				fill="none"
				stroke="#00187e"
				strokeWidth={0.232}
			/>
			<path
				d="M449.827 295.425a9.364 9.364 0 001.656 3.4c.283.566.5 1.285.85 1.94a9.241 9.241 0 001.156 1.94 5.643 5.643 0 001.438 1.286c1.069.351 5.865-5.428 7.107-5.8m-12.207-2.767a9.126 9.126 0 001.656 3.334 18.061 18.061 0 00.85 1.875 10.414 10.414 0 001.156 2.027 5.78 5.78 0 001.438 1.221c1.156.284 5.865-5.21 7.107-5.646"
				fill="none"
				stroke="#001c82"
				strokeWidth={0.232}
			/>
			<path
				d="M449.827 295.425a9.653 9.653 0 001.656 3.334c.283.567.5 1.222.85 1.81a8.215 8.215 0 001.22 2.026 4.362 4.362 0 001.374 1.157c1.156.348 5.8-5.058 7.107-5.5m-12.207-2.832a8.621 8.621 0 001.656 3.182 18.045 18.045 0 00.85 1.874 9.58 9.58 0 001.22 1.941 4.369 4.369 0 001.374 1.155c1.156.35 5.8-4.926 7.107-5.362"
				fill="none"
				stroke="#001e85"
				strokeWidth={0.232}
			/>
			<path
				d="M449.827 295.337a8.737 8.737 0 001.656 3.27c.283.566.5 1.22.85 1.81a9.165 9.165 0 001.22 1.873 4.362 4.362 0 001.374 1.157c1.221.349 5.8-4.775 7.107-5.211m-12.207-2.9a8.3 8.3 0 001.656 3.184c.283.566.5 1.22.85 1.81a9.457 9.457 0 001.22 1.809 3.662 3.662 0 001.44 1.155c1.155.349 5.646-4.622 7.02-5.058"
				fill="none"
				stroke="#002086"
				strokeWidth={0.232}
			/>
			<path
				d="M449.827 295.337a6.942 6.942 0 001.656 3.117c.283.567.5 1.22.85 1.81a16.674 16.674 0 001.22 1.81 5.192 5.192 0 001.44 1.068c1.155.414 5.646-4.426 7.02-4.927m-12.187-2.878a7.038 7.038 0 001.657 3.03 13.921 13.921 0 00.85 1.722 16.674 16.674 0 001.22 1.81 5.531 5.531 0 001.44 1.155c1.22.349 5.646-4.338 7.02-4.84m-12.187-2.877a7.038 7.038 0 001.657 3.03c.283.5.5 1.155.85 1.657a14.774 14.774 0 001.22 1.81 6.873 6.873 0 001.44 1.067c1.286.349 5.646-4.207 7.02-4.709"
				fill="none"
				stroke="#002289"
				strokeWidth={0.232}
			/>
			<path
				d="M449.827 295.337a7.511 7.511 0 001.656 2.965c.283.5.5 1.068.85 1.656a21 21 0 001.22 1.723 3.943 3.943 0 001.44 1c1.286.414 5.582-3.99 7.02-4.49m-12.187-2.857a6.923 6.923 0 001.657 2.9c.283.567.5 1.069.85 1.656a9.169 9.169 0 001.286 1.658 4.117 4.117 0 001.374 1.068c1.286.414 5.494-3.9 7.02-4.426"
				fill="none"
				stroke="#00258b"
				strokeWidth={0.232}
			/>
			<path
				d="M449.827 295.337a7.794 7.794 0 001.656 2.9c.283.5.5 1 .85 1.592a7.042 7.042 0 001.286 1.592 4.1 4.1 0 001.374 1.067c1.373.414 5.494-3.77 7.02-4.272m-12.187-2.878a6.8 6.8 0 001.657 2.747c.283.5.5 1.155.85 1.656.5.72.72.85 1.286 1.592a6.181 6.181 0 001.374 1c1.373.348 5.494-3.619 7.02-4.12"
				fill="none"
				stroke="#00288f"
				strokeWidth={0.232}
			/>
			<path
				d="M449.827 295.337a6.38 6.38 0 001.656 2.747 17.16 17.16 0 00.85 1.5c.5.785.784.938 1.286 1.657a4.025 4.025 0 001.439.938c1.286.414 5.363-3.466 6.954-3.99m-12.186-2.855a5.875 5.875 0 001.657 2.68 17.045 17.045 0 00.85 1.5c.5.72.784.85 1.286 1.592a5.158 5.158 0 001.439.938c1.373.414 5.363-3.336 6.954-3.837"
				fill="none"
				stroke="#002b91"
				strokeWidth={0.232}
			/>
			<path
				d="M449.827 295.337a5.945 5.945 0 001.59 2.594c.35.5.633 1 1 1.5a11.474 11.474 0 001.22 1.5 5.1 5.1 0 001.44.937c1.373.414 5.361-3.182 6.953-3.77m-12.207-2.77a5.925 5.925 0 001.59 2.53c.35.5.633 1 1 1.439a7.681 7.681 0 001.22 1.5 4.932 4.932 0 001.44 1c1.373.348 5.361-3.117 6.953-3.685m-12.207-2.79a5.642 5.642 0 001.59 2.463c.35.5.633 1 1 1.44a8.328 8.328 0 001.286 1.5 3.26 3.26 0 001.35.849c1.44.5 5.3-2.811 6.955-3.466"
				fill="none"
				stroke="#002d93"
				strokeWidth={0.232}
			/>
			<path
				d="M449.827 295.337a5.642 5.642 0 001.59 2.463c.35.415.633.938 1 1.373a8.678 8.678 0 001.286 1.439 4.683 4.683 0 001.35.938c1.44.414 5.212-2.747 6.955-3.4m-12.186-2.813a5.524 5.524 0 001.591 2.4c.35.415.633.938 1 1.352a12.484 12.484 0 001.286 1.44 9.628 9.628 0 001.35.85c1.5.414 5.212-2.594 6.955-3.25"
				fill="none"
				stroke="#002f96"
				strokeWidth={0.232}
			/>
			<path
				d="M449.827 295.337a4.919 4.919 0 001.59 2.31c.35.437.633.939 1 1.374.414.566.784.784 1.286 1.374a5.879 5.879 0 001.35.85c1.5.413 5.212-2.463 6.955-3.118m-12.186-2.79a5.137 5.137 0 001.591 2.245 15.526 15.526 0 001 1.286 6.3 6.3 0 001.373 1.374 4.124 4.124 0 001.286.85c1.591.5 5.145-2.31 6.954-2.965"
				fill="none"
				stroke="#039"
				strokeWidth={0.232}
			/>
			<path
				d="M449.827 295.337a5.671 5.671 0 001.59 2.245c.35.414.633.786 1 1.221a7.084 7.084 0 001.373 1.286 3.467 3.467 0 001.286.85c1.591.415 5.145-2.157 6.954-2.812m-12.207-2.79a5.4 5.4 0 001.59 2.158c.35.35.633.785 1 1.221a7.054 7.054 0 001.381 1.284 4.829 4.829 0 001.286.785c1.591.5 5.145-2.028 6.954-2.681"
				fill="none"
				stroke="#00359c"
				strokeWidth={0.232}
			/>
			<path
				d="M449.827 295.337a4.9 4.9 0 001.59 2.092c.35.35.633.873 1 1.222a9.315 9.315 0 001.373 1.22 3.589 3.589 0 001.286.785c1.656.5 5.145-1.874 6.954-2.53m-12.207-2.79a4.317 4.317 0 001.59 2.028c.35.414.633.85 1 1.222a15.69 15.69 0 001.373 1.22 4.684 4.684 0 001.286.72c1.656.5 5.058-1.723 6.954-2.378m-12.207-2.811a4.125 4.125 0 001.59 1.94 12.259 12.259 0 001 1.221c.414.5.85.632 1.373 1.155a4.651 4.651 0 001.286.72c1.744.5 5.058-1.591 6.954-2.246"
				fill="none"
				stroke="#00389e"
				strokeWidth={0.232}
			/>
			<path
				d="M449.827 295.337a5.006 5.006 0 001.59 1.94 10.939 10.939 0 001 1.068 8.917 8.917 0 001.373 1.156 7.546 7.546 0 001.286.785c1.744.5 5.058-1.44 6.954-2.16m-12.207-2.79a5.121 5.121 0 001.59 1.876 11.054 11.054 0 001 1.068 7.5 7.5 0 001.373 1.069 2.711 2.711 0 001.286.718c1.744.567 4.992-1.22 6.954-1.94"
				fill="none"
				stroke="#0039a0"
				strokeWidth={0.232}
			/>
			<path
				d="M449.827 295.337a5.131 5.131 0 001.59 1.81 11.292 11.292 0 001 1.068 10.19 10.19 0 001.439 1.068 5.534 5.534 0 001.286.72c1.722.5 4.926-1.156 6.888-1.876m-12.207-2.79a4.755 4.755 0 001.5 1.722l1.068 1.068c.5.436.85.633 1.44 1.069a5.476 5.476 0 001.285.632c1.723.5 4.84-1 6.89-1.722"
				fill="none"
				stroke="#003ca2"
				strokeWidth={0.232}
			/>
			<path
				d="M449.827 295.337a5.6 5.6 0 001.5 1.722 14.273 14.273 0 011.068 1c.5.413.938.566 1.44 1a5.476 5.476 0 001.285.632c1.723.566 4.84-.85 6.89-1.591m-12.187-2.77a5.64 5.64 0 001.5 1.657c.35.284.72.633 1.156 1 .414.35.85.567 1.374.939a3.934 3.934 0 001.286.63c1.809.5 4.84-.718 6.888-1.438"
				fill="none"
				stroke="#003ea6"
				strokeWidth={0.232}
			/>
			<path
				d="M449.827 295.337a5.583 5.583 0 001.5 1.592c.35.282.72.632 1.156.937a6.092 6.092 0 001.374.937 4.679 4.679 0 001.286.632c1.809.567 4.773-.567 6.888-1.286m-12.207-2.812a4.691 4.691 0 001.5 1.5 8.369 8.369 0 001.156.937c.414.349.85.567 1.374.938a13.663 13.663 0 001.286.567c1.809.566 4.773-.415 6.888-1.156m-12.207-2.79a5.057 5.057 0 001.5 1.439c.35.282.72.567 1.156.937a7.648 7.648 0 001.374.85c.414.2.85.414 1.286.633 1.875.5 4.773-.35 6.888-1.07"
				fill="none"
				stroke="#0042a8"
				strokeWidth={0.232}
			/>
			<path
				d="M449.827 295.337a6.091 6.091 0 001.5 1.439c.35.2.72.5 1.156.785a7.476 7.476 0 001.439.937 7.964 7.964 0 001.22.5c1.941.566 4.71-.132 6.889-.85m-12.207-2.813a11.879 11.879 0 002.659 2.158 6.357 6.357 0 001.439.85 4.355 4.355 0 001.22.5c1.941.632 4.71 0 6.889-.72"
				fill="none"
				stroke="#0045ab"
				strokeWidth={0.232}
			/>
			<path
				d="M449.827 295.337a9.156 9.156 0 001.5 1.286c.35.2.72.567 1.156.785a5.694 5.694 0 001.439.784c.349.2.85.35 1.22.567 1.941.567 4.622.13 6.889-.632m-12.207-2.79a7.334 7.334 0 001.5 1.22 13.46 13.46 0 001.156.786c.414.282.937.5 1.439.784.414.131.85.349 1.22.5a12.183 12.183 0 006.889-.5"
				fill="none"
				stroke="#0046ad"
				strokeWidth={0.232}
			/>
			<path
				d="M449.827 295.337a5.256 5.256 0 001.5 1.22 13.08 13.08 0 011.156.72 8.946 8.946 0 001.439.72c.414.195.85.348 1.22.5a12.284 12.284 0 006.889-.349m-12.207-2.812a18.167 18.167 0 001.5 1.155c.35.2.72.414 1.221.72.35.195.85.414 1.352.632.415.195.85.348 1.22.5a11.665 11.665 0 006.89-.2"
				fill="none"
				stroke="#0049af"
				strokeWidth={0.232}
			/>
			<path
				d="M449.827 295.337a11.288 11.288 0 001.5 1.068 12.55 12.55 0 001.221.633 6.163 6.163 0 001.352.719c.415.13.85.282 1.22.414a11.978 11.978 0 006.89-.065m-12.187-2.77s6.3 4.927 12.252 2.813"
				fill="none"
				stroke="#004bb3"
				strokeWidth={0.232}
			/>
			<path
				d="M449.543 275.892s1.22 7.913 1.722 9.07c.348 1 2.9 5.491 6.67 6.516"
				fill="none"
				stroke="#006"
				strokeWidth={0.232}
			/>
			<path
				d="M449.543 275.892s1.286 7.825 1.81 8.915c.413 1 2.746 5.364 6.67 6.671"
				fill="none"
				stroke="#00066d"
				strokeWidth={0.232}
			/>
			<path
				d="M449.608 275.825s1.374 7.762 1.875 8.982a13.21 13.21 0 006.517 6.671"
				fill="none"
				stroke="#000b73"
				strokeWidth={0.232}
			/>
			<path
				d="M449.608 275.825s1.438 7.762 1.94 8.917a13.506 13.506 0 006.452 6.671"
				fill="none"
				stroke="#001379"
				strokeWidth={0.232}
			/>
			<path
				d="M449.608 275.825s1.5 7.674 2.027 8.765a14.687 14.687 0 006.366 6.8"
				fill="none"
				stroke="#00187e"
				strokeWidth={0.232}
			/>
			<path
				d="M449.608 275.825s1.591 7.609 2.158 8.765a15.148 15.148 0 006.235 6.8"
				fill="none"
				stroke="#002086"
				strokeWidth={0.232}
			/>
			<path
				d="M449.608 275.825s1.657 7.543 2.246 8.7a16 16 0 006.147 6.8"
				fill="none"
				stroke="#00258b"
				strokeWidth={0.232}
			/>
			<path
				d="M449.674 275.825s1.656 7.457 2.245 8.634a17.11 17.11 0 006.081 6.889"
				fill="none"
				stroke="#002b91"
				strokeWidth={0.232}
			/>
			<path
				d="M449.674 275.825s1.809 7.391 2.31 8.547c.567 1.067 1.744 3.683 6.083 6.954"
				fill="none"
				stroke="#039"
				strokeWidth={0.232}
			/>
			<path
				d="M449.761 275.76s1.81 7.456 2.376 8.547c.5 1.067 1.5 3.4 5.93 7.02"
				fill="none"
				stroke="#00389e"
				strokeWidth={0.232}
			/>
			<path
				d="M449.761 275.76s1.875 7.326 2.442 8.48c.566 1.069 1.373 3.184 5.864 7.02"
				fill="none"
				stroke="#003ea6"
				strokeWidth={0.232}
			/>
			<path
				d="M449.761 275.76s2.027 7.326 2.528 8.415c.567 1.069 1.286 2.965 5.865 7.02"
				fill="none"
				stroke="#0046ad"
				strokeWidth={0.232}
			/>
			<path
				d="M449.761 275.674s2.093 7.324 2.594 8.393c.567 1.068 1.156 2.747 5.776 7.106"
				fill="none"
				stroke="#004bb3"
				strokeWidth={0.232}
			/>
			<path
				d="M450.045 271.03s1 11.162 8.98 14.214"
				fill="none"
				stroke="#006"
				strokeWidth={0.232}
			/>
			<path
				d="M450.045 271.03a32.315 32.315 0 002.092 7.02 13.478 13.478 0 006.888 7.171"
				fill="none"
				stroke="#00066d"
				strokeWidth={0.232}
			/>
			<path
				d="M450.11 271.03a27.714 27.714 0 002.093 7.02 14.707 14.707 0 006.8 7.171"
				fill="none"
				stroke="#000b73"
				strokeWidth={0.232}
			/>
			<path
				d="M450.11 271.03a28.157 28.157 0 002.158 6.888c1.155 2.312 3.183 5.582 6.736 7.238"
				fill="none"
				stroke="#001379"
				strokeWidth={0.232}
			/>
			<path
				d="M450.11 271.03a27.905 27.905 0 002.31 6.888c1 2.093 3.03 5.494 6.584 7.173"
				fill="none"
				stroke="#00187e"
				strokeWidth={0.232}
			/>
			<path
				d="M450.11 271.03a31.6 31.6 0 002.376 6.8c.937 1.876 3.03 5.43 6.517 7.238"
				fill="none"
				stroke="#002086"
				strokeWidth={0.232}
			/>
			<path
				d="M450.2 271.03a29.806 29.806 0 002.4 6.736 17.306 17.306 0 006.452 7.326"
				fill="none"
				stroke="#00258b"
				strokeWidth={0.232}
			/>
			<path
				d="M450.2 270.964a35.374 35.374 0 002.464 6.737c.784 1.5 2.9 5.276 6.365 7.325"
				fill="none"
				stroke="#002b91"
				strokeWidth={0.232}
			/>
			<path
				d="M450.2 270.964a30.745 30.745 0 002.616 6.671c.72 1.44 2.747 5.277 6.235 7.39"
				fill="none"
				stroke="#039"
				strokeWidth={0.232}
			/>
			<path
				d="M450.262 270.964a28.306 28.306 0 002.594 6.671c.634 1.156 2.66 5.145 6.147 7.39"
				fill="none"
				stroke="#00389e"
				strokeWidth={0.232}
			/>
			<path
				d="M450.262 270.964a35.8 35.8 0 002.66 6.605c.633 1 2.594 5.06 6.082 7.391"
				fill="none"
				stroke="#003ea6"
				strokeWidth={0.232}
			/>
			<path
				d="M450.262 270.964a32.025 32.025 0 002.813 6.519c.5.785 2.462 4.992 5.93 7.455"
				fill="none"
				stroke="#0046ad"
				strokeWidth={0.232}
			/>
			<path
				d="M450.262 270.964a30.066 30.066 0 002.9 6.453c.414.633 2.375 4.993 5.864 7.543"
				fill="none"
				stroke="#004bb3"
				strokeWidth={0.232}
			/>
			<path
				d="M450.11 267.913s2.31 8.981 8.85 11.161"
				fill="none"
				stroke="#006"
				strokeWidth={0.232}
			/>
			<path
				d="M450.11 267.913a24.726 24.726 0 003.03 6.235 12.044 12.044 0 005.8 4.926"
				fill="none"
				stroke="#00056b"
				strokeWidth={0.232}
			/>
			<path
				d="M450.11 267.913a24.568 24.568 0 003.03 6.147c1.5 2.093 3.554 4.273 5.8 4.993"
				fill="none"
				stroke="#00096f"
				strokeWidth={0.232}
			/>
			<path
				d="M450.11 267.848a24.906 24.906 0 003.183 6.152c1.5 2.158 3.618 4.338 5.646 5.058"
				fill="none"
				stroke="#000f75"
				strokeWidth={0.232}
			/>
			<path
				d="M450.2 267.782a25.035 25.035 0 003.182 6.234c1.506 2.093 3.772 4.426 5.581 5.058"
				fill="none"
				stroke="#00167c"
				strokeWidth={0.232}
			/>
			<path
				d="M450.2 267.782a25.8 25.8 0 003.248 6.083c1.591 2.223 3.837 4.556 5.494 5.144"
				fill="none"
				stroke="#001c82"
				strokeWidth={0.232}
			/>
			<path
				d="M450.2 267.782a27.84 27.84 0 003.248 6.017c1.722 2.31 4.055 4.708 5.494 5.21"
				fill="none"
				stroke="#002086"
				strokeWidth={0.232}
			/>
			<path
				d="M450.2 267.7a25.115 25.115 0 003.4 6.017c1.723 2.31 4.055 4.84 5.363 5.275"
				fill="none"
				stroke="#00258b"
				strokeWidth={0.232}
			/>
			<path
				d="M450.262 267.7a24.248 24.248 0 003.4 5.929c1.745 2.377 4.208 4.927 5.277 5.276"
				fill="none"
				stroke="#002b91"
				strokeWidth={0.232}
			/>
			<path
				d="M450.262 267.7a26.509 26.509 0 003.466 5.865c1.788 2.376 4.273 5.055 5.211 5.361"
				fill="none"
				stroke="#002f96"
				strokeWidth={0.232}
			/>
			<path
				d="M450.262 267.63a25.1 25.1 0 003.554 5.864c1.809 2.375 4.425 5.21 5.143 5.427"
				fill="none"
				stroke="#00359c"
				strokeWidth={0.232}
			/>
			<path
				d="M450.262 267.63a30.293 30.293 0 003.62 5.864 36.75 36.75 0 005.057 5.427"
				fill="none"
				stroke="#003ca2"
				strokeWidth={0.232}
			/>
			<path
				d="M450.262 267.63a32.839 32.839 0 003.684 5.71 49.01 49.01 0 004.993 5.582"
				fill="none"
				stroke="#0042a8"
				strokeWidth={0.232}
			/>
			<path
				d="M450.262 267.564a30.756 30.756 0 003.771 5.711 50.2 50.2 0 004.993 5.646"
				fill="none"
				stroke="#0046ad"
				strokeWidth={0.232}
			/>
			<path
				d="M450.262 267.476a37.055 37.055 0 003.837 5.712c2.027 2.6 4.927 5.647 4.927 5.647m8.436 1.35l4.426.786m-3.99 2.55l3.99-1.656"
				fill="none"
				stroke="#004bb3"
				strokeWidth={0.232}
			/>
			<path
				d="M467.4 280.251l4.425.72"
				fill="none"
				stroke="#0045ab"
				strokeWidth={0.232}
			/>
			<path d="M467.4 280.47l4.49.5" fill="none" stroke="#003ca2" strokeWidth={0.232} />
			<path
				d="M467.463 280.622l4.49.349"
				fill="none"
				stroke="#00359c"
				strokeWidth={0.232}
			/>
			<path
				d="M467.463 280.753l4.49.282"
				fill="none"
				stroke="#002d93"
				strokeWidth={0.232}
			/>
			<path
				d="M467.463 280.971l4.556.065"
				fill="none"
				stroke="#00258b"
				strokeWidth={0.232}
			/>
			<path
				d="M467.463 281.124l4.556-.066"
				fill="none"
				stroke="#001e85"
				strokeWidth={0.232}
			/>
			<path
				d="M467.463 281.276l4.621-.2"
				fill="none"
				stroke="#00167c"
				strokeWidth={0.232}
			/>
			<path
				d="M467.463 281.406l4.708-.282"
				fill="none"
				stroke="#000f75"
				strokeWidth={0.232}
			/>
			<path
				d="M467.528 281.56l4.622-.415"
				fill="none"
				stroke="#00066d"
				strokeWidth={0.232}
			/>
			<path d="M467.9 283.3l4.055-1.5" fill="none" stroke="#0045ab" strokeWidth={0.232} />
			<path
				d="M467.81 283.15l4.121-1.438"
				fill="none"
				stroke="#003ca2"
				strokeWidth={0.232}
			/>
			<path
				d="M467.81 283.02l4.209-1.374"
				fill="none"
				stroke="#00359c"
				strokeWidth={0.232}
			/>
			<path
				d="M467.745 282.8l4.274-1.22"
				fill="none"
				stroke="#002d93"
				strokeWidth={0.232}
			/>
			<path
				d="M467.745 282.65l4.34-1.156"
				fill="none"
				stroke="#00258b"
				strokeWidth={0.232}
			/>
			<path
				d="M467.745 282.5l4.426-1.07"
				fill="none"
				stroke="#001e85"
				strokeWidth={0.232}
			/>
			<path
				d="M467.68 282.28l4.491-.851"
				fill="none"
				stroke="#00167c"
				strokeWidth={0.232}
			/>
			<path
				d="M467.68 282.061l4.556-.785"
				fill="none"
				stroke="#000f75"
				strokeWidth={0.232}
			/>
			<path
				d="M467.68 281.93l4.556-.654"
				fill="none"
				stroke="#00066d"
				strokeWidth={0.232}
			/>
			<path
				d="M467.616 281.777l4.708-.565"
				fill="none"
				stroke="#006"
				strokeWidth={0.232}
			/>
			<path
				d="M454.84 310.508a5.157 5.157 0 01-1.723-2.154 17.677 17.677 0 01-.936-3.471c-.2-1.066-.2-2.244-.5-3.334-.132-1.068-1.744-4.621-1.81-6.016-.131-4.622-1.657-7.76-1.286-12.753.282-3.9 1.155-9.2.72-13.276a30.771 30.771 0 01.065-3.467l22.976 15.217"
				fill="none"
				stroke="#000"
				strokeWidth={0.232}
			/>
			<path
				d="M449.172 264.883c-.13-.85.065-2.03.72-2.157a2.362 2.362 0 01.784-.068c.349 0 .415.13.633.436.283.785-.633 1.287-1.286 1.5-.2.066-.633.13-.72.349-.13.349-.066.2-.13.349.13-.065.13-.2.283-.284.5-.282 1-.348 1.722-.72.567-.194.633-1.372.283-1.657a2.292 2.292 0 00-2.027 0 3.214 3.214 0 00-.567 2.682c0-.195.349-.13.283-.414"
				fill="#fc0"
			/>
			<path
				d="M449.172 264.883c-.13-.85.065-2.03.72-2.157a2.152 2.152 0 01.784-.068c.349 0 .415.13.633.436.283.785-.633 1.287-1.286 1.5-.2.066-.633.13-.72.349-.13.349-.066.2-.13.349.13-.065.13-.2.283-.284.5-.282 1-.348 1.722-.72.567-.194.633-1.372.283-1.657a2.292 2.292 0 00-2.027 0 3.214 3.214 0 00-.567 2.682c0-.195.349-.13.283-.414z"
				fill="none"
				stroke="#000"
				strokeWidth={0.173}
			/>
			<path
				d="M448.8 265.318c-.85 0-2.028.349-2.094.938a3.7 3.7 0 000 .85c.066.349.2.5.5.567.85.2 1.22-.784 1.374-1.5 0-.13 0-.567.195-.72.35-.13.284-.066.35-.13a.786.786 0 00-.2.283c-.195.5-.195 1.068-.5 1.81-.13.567-1.22.784-1.591.436a2 2 0 01-.283-1.94 3.394 3.394 0 012.594-.939c-.13.066-.13.414-.35.35"
				fill="#fc0"
			/>
			<path
				d="M448.8 265.318c-.85 0-2.028.349-2.094.938a3.7 3.7 0 000 .85c.066.349.2.5.5.567.85.2 1.22-.784 1.374-1.5 0-.13 0-.567.195-.72.35-.13.284-.066.35-.13a.786.786 0 00-.2.283c-.195.5-.195 1.068-.5 1.81-.13.567-1.22.784-1.591.436a2 2 0 01-.283-1.94 3.394 3.394 0 012.594-.939c-.13.066-.13.414-.35.35"
				fill="none"
				stroke="#000"
				strokeWidth={0.173}
			/>
			<path
				d="M448.584 264.948a.465.465 0 00-.066.632.384.384 0 00.567.13.592.592 0 00.35-.85c-.2-.282-.5-.065-.851.067"
				fill="#fc0"
			/>
			<path
				d="M448.584 264.948a.465.465 0 00-.066.632.384.384 0 00.567.13.592.592 0 00.35-.85c-.2-.282-.5-.065-.851.067z"
				fill="none"
				stroke="#000"
				strokeWidth={0.173}
			/>
			<path
				d="M443.723 261.833a14.4 14.4 0 004.424 1 5.372 5.372 0 00.5 2.226 6.527 6.527 0 00-2.594.065 9.683 9.683 0 00-2.311-3.334"
				fill="#fc0"
			/>
			<path
				d="M443.723 261.833a14.4 14.4 0 004.424 1 5.372 5.372 0 00.5 2.226 6.538 6.538 0 00-2.594.065 9.683 9.683 0 00-2.311-3.334z"
				fill="none"
				stroke="#000"
				strokeWidth={0.173}
			/>
			<path
				d="M445.685 263.05a5.737 5.737 0 001.809.418 1.722 1.722 0 00.2.848 2.9 2.9 0 00-1 .065 3.354 3.354 0 00-1-1.354z"
				fill="none"
				stroke="#000"
				strokeWidth={0.173}
			/>
			<path
				d="M448.8 266.823s.414-.785.567-1.068c.065-.13-.065.937.349 1.068a5.161 5.161 0 01.719 2.593 2.354 2.354 0 01-2.18.066c-.348-.2-.066-.784 0-1.286a5.307 5.307 0 01.5-1.374"
				fill="#fc0"
			/>
			<path
				d="M448.8 266.823s.414-.785.567-1.068c.065-.13-.065.937.349 1.068a5.161 5.161 0 01.719 2.593 2.354 2.354 0 01-2.18.066c-.348-.2-.066-.784 0-1.286a5.307 5.307 0 01.5-1.374z"
				fill="none"
				stroke="#000"
				strokeWidth={0.173}
			/>
			<path
				d="M449.237 266.19a4.369 4.369 0 00.067.567c0-.2.194.2.282.284a5.6 5.6 0 01.567 2.31m-.7-2.092a6.857 6.857 0 01.348 2.245l.13-.065m-.478-1.308c.13.632.065 1 .13 1.373l-.282.13"
				fill="none"
				stroke="#000"
				strokeWidth={0.173}
			/>
			<path
				d="M471.452 314.213c1.81 1.658 5.21 2.528 5.8 2.97a10.871 10.871 0 006.147 2.31c2.247.195 3.249-.419 5.582-.72 2.681-.285-.35.128 2.246-.42a25.884 25.884 0 013.117-.93c1.286-.352 2.594-.637 3.4-1.725a2.8 2.8 0 00.567-1.44h1.743c.2.5-.282 1.44-.5 1.808-.066.135-.283.436-.414.659a2.166 2.166 0 01-.633.78c-.131.068-.72.57-.871.632a2.267 2.267 0 01-1.07.636 25.757 25.757 0 00-4.054 1.155c-1.591.413-.72.346-1.875.63-.632.13-1.787.57-2.376.631-1.067.195-1.22.352-2.31.57a27.572 27.572 0 01-8.328.285 14.051 14.051 0 01-4.927-1.29c-1.744-1.222-5.515-1.719-7.238-2.9a16.251 16.251 0 01-1.5-.854c-1.57-1.373-2.965-1.72-4.622-2.813h12.252"
				fill="#004bb3"
			/>
			<path
				d="M484.793 314.213c1.22.636 1.81 1.658 5.21 2.746 1.286 0 2.747.57 3.99.5-1.5.352-1.5.57-2.747.854-2.594.563.414.129-2.245.413-2.311.285-3.336.938-5.581.72a10.547 10.547 0 01-6.147-2.31c-.567-.413-3.99-1.29-5.8-2.97h13.342"
				fill="#fff"
			/>
			<path
				d="M484.793 314.213h13.56a2.941 2.941 0 01-.567 1.44c-.785 1.072-2.093 1.374-3.4 1.724-1.44.28-2.9-.419-4.34-.419-3.553-1.064-3.988-2.242-5.209-2.745"
				fill="#004bb3"
			/>
			<path
				d="M471.67 314.213s-2.377.135-2.53.135c-.13 0-9.7-.135-9.7-.135"
				fill="none"
				stroke="#00066d"
				strokeWidth={0.232}
			/>
			<path
				d="M471.67 314.28s-2.377.129-2.53.2c-.282.068-9.634-.127-9.634-.127"
				fill="none"
				stroke="#000b73"
				strokeWidth={0.232}
			/>
			<path
				d="M471.736 314.37s-2.312.195-2.66.279c-.35 0-9.5-.279-9.5-.279"
				fill="none"
				stroke="#001379"
				strokeWidth={0.232}
			/>
			<path
				d="M471.736 314.37s-2.224.279-2.748.346c-.5.133-9.352-.285-9.352-.285"
				fill="none"
				stroke="#00187e"
				strokeWidth={0.232}
			/>
			<path
				d="M471.736 314.43s-2.16.286-2.748.42c-.633.128-9.265-.42-9.265-.42"
				fill="none"
				stroke="#002086"
				strokeWidth={0.232}
			/>
			<path
				d="M471.736 314.43s-2.094.42-2.813.57c-.72.129-9.134-.5-9.134-.5"
				fill="none"
				stroke="#00258b"
				strokeWidth={0.232}
			/>
			<path
				d="M471.736 314.43s-2.029.5-2.9.721c-.851.195-8.981-.564-8.981-.564"
				fill="none"
				stroke="#002b91"
				strokeWidth={0.232}
			/>
			<path
				d="M471.8 314.5s-2.027.569-3.03.786c-.937.128-8.85-.72-8.85-.72"
				fill="none"
				stroke="#039"
				strokeWidth={0.232}
			/>
			<path
				d="M471.8 314.587s-1.94.63-3.03.848c-1.068.2-8.763-.786-8.763-.786"
				fill="none"
				stroke="#00389e"
				strokeWidth={0.232}
			/>
			<path
				d="M471.8 314.587a28.816 28.816 0 01-3.116 1c-1.221.2-8.634-.848-8.634-.848"
				fill="none"
				stroke="#003ea6"
				strokeWidth={0.232}
			/>
			<path
				d="M471.8 314.649a16.8 16.8 0 01-3.116 1c-1.374.285-8.546-.937-8.546-.937"
				fill="none"
				stroke="#0046ad"
				strokeWidth={0.232}
			/>
			<path d="M459.33 314.213h12.34" fill="none" stroke="#006" strokeWidth={0.232} />
			<path
				d="M460.2 314.805s6.956 1.284 8.416 1a14.794 14.794 0 003.248-1.155"
				fill="none"
				stroke="#004bb3"
				strokeWidth={0.232}
			/>
			<path
				d="M473.48 319.643s4.425.631 4.555.631c.066 0 2.595-.194 2.682-.194l2.18-.5"
				fill="none"
				stroke="#00066d"
				strokeWidth={0.232}
			/>
			<path
				d="M473.2 319.577s4.556.72 4.926.636c.13-.068 2.464-.2 2.53-.2.13 0 2.026-.413 2.026-.413"
				fill="none"
				stroke="#001178"
				strokeWidth={0.232}
			/>
			<path
				d="M472.978 319.447a41.727 41.727 0 005.144.632c.2 0 2.312-.129 2.53-.129.13 0 1.809-.434 1.809-.434"
				fill="none"
				stroke="#00187e"
				strokeWidth={0.232}
			/>
			<path
				d="M472.672 319.292a45.361 45.361 0 005.429.72c.348 0 2.245-.128 2.463-.128.2-.068 1.656-.352 1.656-.352"
				fill="none"
				stroke="#002086"
				strokeWidth={0.232}
			/>
			<path
				d="M472.454 319.23a46.678 46.678 0 005.647.721c.414-.068 2.092-.134 2.463-.2.283 0 1.438-.194 1.438-.194"
				fill="none"
				stroke="#002b91"
				strokeWidth={0.232}
			/>
			<path
				d="M472.171 319.074s4.992 1 6.016.787c.5-.067 1.94-.128 2.312-.194a11.961 11.961 0 001.351-.2"
				fill="none"
				stroke="#039"
				strokeWidth={0.232}
			/>
			<path
				d="M471.953 319.013s5.08 1 6.234.781c.634-.061 1.876-.195 2.224-.195.414-.068 1.221-.128 1.221-.128"
				fill="none"
				stroke="#0039a0"
				strokeWidth={0.232}
			/>
			<path
				d="M471.67 318.923s5.21 1.066 6.517.787a14.413 14.413 0 012.224-.194 7.546 7.546 0 011-.069"
				fill="none"
				stroke="#0045ab"
				strokeWidth={0.232}
			/>
			<path
				d="M473.7 319.794l4.338.57 2.682-.134 2.31-.564"
				fill="none"
				stroke="#006"
				strokeWidth={0.232}
			/>
			<path
				d="M471.452 318.8s5.362 1.155 6.8.848a17.631 17.631 0 012.966-.284m11.4.09s2.812-1 4.207-1.508a4.7 4.7 0 002.9-3.616m-7.39 4.252s1.655-.636 3.116-1.155c3.685-1.44 3.248-3.185 3.248-3.185"
				fill="none"
				stroke="#004bb3"
				strokeWidth={0.232}
			/>
			<path
				d="M492.118 318.706s2.158-.787 3.335-1.223a16.064 16.064 0 001.723-.78 5.436 5.436 0 001.286-1.222 2.928 2.928 0 00.282-1.223"
				fill="none"
				stroke="#003ca2"
				strokeWidth={0.232}
			/>
			<path
				d="M491.833 318.923s2.748-1 3.62-1.372c.35-.129 1.374-.57 1.656-.72a13.886 13.886 0 001.374-1.156 4.488 4.488 0 00.415-1.44"
				fill="none"
				stroke="#002d93"
				strokeWidth={0.232}
			/>
			<path
				d="M491.616 319.074s3.27-1.155 3.837-1.373c.284-.128 1.44-.63 1.591-.72a8.026 8.026 0 001.5-1.217 11.121 11.121 0 00.414-1.506"
				fill="none"
				stroke="#001e85"
				strokeWidth={0.232}
			/>
			<path
				d="M491.333 319.292s3.837-1.373 4.12-1.5c.066-.069 1.505-.57 1.591-.632a15.048 15.048 0 001.5-1.222 12.191 12.191 0 00.566-1.59"
				fill="none"
				stroke="#000f75"
				strokeWidth={0.232}
			/>
			<path
				d="M492.336 319.447s3.4-1.221 4.491-1.656a4.684 4.684 0 002.027-1.507 5.616 5.616 0 00.785-1.936"
				fill="none"
				stroke="#003ca2"
				strokeWidth={0.232}
			/>
			<path
				d="M491.987 319.447s4.055-1.438 4.927-1.807a5.422 5.422 0 001.874-1.44 6.909 6.909 0 00.72-1.875"
				fill="none"
				stroke="#002d93"
				strokeWidth={0.232}
			/>
			<path
				d="M491.681 319.516s4.71-1.814 5.277-1.943a11.839 11.839 0 001.809-1.373 9.3 9.3 0 00.633-1.875"
				fill="none"
				stroke="#001e85"
				strokeWidth={0.232}
			/>
			<path
				d="M491.4 319.516s5.276-2.033 5.582-2.094a17.531 17.531 0 001.721-1.289c.132-.195.655-1.808.655-1.808"
				fill="none"
				stroke="#000f75"
				strokeWidth={0.232}
			/>
			<path
				d="M491.115 319.516l5.93-2.25 1.591-1.222.567-1.719"
				fill="none"
				stroke="#006"
				strokeWidth={0.232}
			/>
			<path
				d="M498 314.213s-2.53.135-2.594.135c-.131 0-10.137-.135-10.137-.135"
				fill="none"
				stroke="#00066d"
				strokeWidth={0.232}
			/>
			<path
				d="M498 314.28s-2.464.129-2.682.2c-.283.068-10-.127-10-.127"
				fill="none"
				stroke="#000b73"
				strokeWidth={0.232}
			/>
			<path
				d="M498.069 314.37s-2.377.195-2.812.279c-.35 0-9.853-.279-9.853-.279"
				fill="none"
				stroke="#001379"
				strokeWidth={0.232}
			/>
			<path
				d="M498.069 314.37s-2.31.279-2.812.346c-.5.133-9.788-.285-9.788-.285"
				fill="none"
				stroke="#00187e"
				strokeWidth={0.232}
			/>
			<path
				d="M498.069 314.43s-2.245.286-2.9.42c-.632.128-9.634-.42-9.634-.42"
				fill="none"
				stroke="#002086"
				strokeWidth={0.232}
			/>
			<path
				d="M498.069 314.43s-2.158.42-2.9.57c-.784.129-9.57-.5-9.57-.5"
				fill="none"
				stroke="#00258b"
				strokeWidth={0.232}
			/>
			<path
				d="M498.069 314.43s-2.092.5-2.964.721c-.85.195-9.418-.564-9.418-.564"
				fill="none"
				stroke="#002b91"
				strokeWidth={0.232}
			/>
			<path
				d="M498.157 314.5s-2.093.569-3.118.786c-1 .128-9.265-.72-9.265-.72"
				fill="none"
				stroke="#039"
				strokeWidth={0.232}
			/>
			<path
				d="M498.157 314.587a32.112 32.112 0 01-3.184.848c-1.068.2-9.134-.786-9.134-.786"
				fill="none"
				stroke="#00389e"
				strokeWidth={0.232}
			/>
			<path
				d="M498.222 314.587s-2.027.72-3.249 1c-1.286.2-8.98-.848-8.98-.848"
				fill="none"
				stroke="#003ea6"
				strokeWidth={0.232}
			/>
			<path
				d="M498.222 314.649a18.954 18.954 0 01-3.336 1c-1.373.285-8.85-.937-8.85-.937"
				fill="none"
				stroke="#0046ad"
				strokeWidth={0.232}
			/>
			<path d="M485.163 314.213H498" fill="none" stroke="#006" strokeWidth={0.232} />
			<path
				d="M486.036 314.805s7.325 1.284 8.85 1a18.246 18.246 0 003.336-1.155"
				fill="none"
				stroke="#004bb3"
				strokeWidth={0.232}
			/>
			<path
				d="M500.1 314.213c.2.5-.282 1.44-.5 1.814-.066.129-.284.436-.415.653a2.107 2.107 0 01-.632.781c-.131.068-.72.57-.873.636a2.292 2.292 0 01-1.067.631 26.258 26.258 0 00-4.055 1.156c-1.591.413-.72.346-1.875.63-.633.134-1.788.569-2.377.63-1.068.2-1.22.352-2.31.57a27.57 27.57 0 01-8.328.285 13.908 13.908 0 01-4.926-1.29c-1.744-1.216-5.516-1.718-7.238-2.9a14.677 14.677 0 01-1.5-.854c-1.57-1.373-2.966-1.719-4.623-2.807"
				fill="none"
				stroke="#000"
				strokeWidth={0.232}
			/>
			<path d="M550.673 314.213l-49.028-81.964-48.963 81.964H550.7" fill="#fc0" />
			<path
				d="M550.673 314.213l-49.028-81.964-48.963 81.964h97.991z"
				fill="none"
				stroke="#000"
				strokeWidth={0.58}
			/>
			<path d="M545.964 311.534l-44.319-73.99-44.166 73.99h88.507" fill="#fff" />
			<path
				d="M545.964 311.534l-44.319-73.99-44.166 73.99h88.485z"
				fill="none"
				stroke="#fff"
				strokeWidth={0.173}
			/>
			<path
				d="M493.95 250.516a10.875 10.875 0 017.608-2.68h.195c2.813 0 5.712.72 7.609 2.68"
				fill="none"
				stroke="#00a8ff"
				strokeWidth={0.232}
			/>
			<path
				d="M493.95 250.582c2.026-1.942 4.62-2.595 7.608-2.679h.195c2.9 0 5.865.714 7.674 2.68"
				fill="none"
				stroke="#009eff"
				strokeWidth={0.232}
			/>
			<path
				d="M493.862 250.65a10.694 10.694 0 017.7-2.685h.195c2.965 0 5.93.72 7.761 2.746"
				fill="none"
				stroke="#0096ff"
				strokeWidth={0.232}
			/>
			<path
				d="M493.8 250.8c2.028-2.027 4.775-2.746 7.762-2.746h.282c2.965 0 5.93.72 7.827 2.813"
				fill="none"
				stroke="#008bff"
				strokeWidth={0.232}
			/>
			<path
				d="M493.731 250.867c2.027-2.032 4.84-2.747 7.892-2.813h.2c3.03.066 6.016.781 7.914 2.964"
				fill="none"
				stroke="#0082ff"
				strokeWidth={0.232}
			/>
			<path
				d="M493.644 250.934c2.027-2.1 4.84-2.814 7.979-2.814h.2c3.117.062 6.082.849 7.978 3.031"
				fill="none"
				stroke="#0079ff"
				strokeWidth={0.232}
			/>
			<path
				d="M493.644 251.084c1.961-2.093 4.84-2.9 7.979-2.9h.2c3.247.068 6.148.854 8.11 3.12"
				fill="none"
				stroke="#006fff"
				strokeWidth={0.232}
			/>
			<path
				d="M493.077 251.955c2.311-2.461 5.21-3.181 8.633-3.181h.195c3.772.061 6.956 1.283 8.852 3.9"
				fill="none"
				stroke="#1609ff"
				strokeWidth={0.232}
			/>
			<path
				d="M493.143 251.826c2.245-2.31 5.144-3.03 8.545-3.12h.2c3.684.068 6.8 1.29 8.7 3.84"
				fill="none"
				stroke="#1316ff"
				strokeWidth={0.232}
			/>
			<path
				d="M493.207 251.737c2.246-2.377 5.059-3.12 8.393-3.12h.2c3.618.067 6.8 1.223 8.7 3.773"
				fill="none"
				stroke="#1120ff"
				strokeWidth={0.232}
			/>
			<path
				d="M493.207 251.67c2.246-2.31 5.059-3.03 8.393-3.114h.2c3.553.061 6.67 1.155 8.633 3.683"
				fill="none"
				stroke="#0f2dff"
				strokeWidth={0.232}
			/>
			<path
				d="M493.36 251.52c2.093-2.244 4.927-2.964 8.263-2.964h.13c3.554 0 6.671 1 8.633 3.55"
				fill="none"
				stroke="#0938ff"
				strokeWidth={0.232}
			/>
			<path
				d="M493.36 251.452c2.093-2.243 4.993-2.962 8.2-2.962h.195c3.466 0 6.584.937 8.48 3.4"
				fill="none"
				stroke="#0645ff"
				strokeWidth={0.232}
			/>
			<path
				d="M493.426 251.39c2.027-2.248 4.927-2.968 8.11-2.968h.2c3.4 0 6.43.854 8.415 3.338"
				fill="none"
				stroke="#054fff"
				strokeWidth={0.232}
			/>
			<path
				d="M493.513 251.235c1.94-2.16 4.84-2.9 8.045-2.9h.13c3.4 0 6.453.78 8.393 3.247"
				fill="none"
				stroke="#025cff"
				strokeWidth={0.232}
			/>
			<path
				d="M496.762 245.655a7.9 7.9 0 014.838-1.284 8.348 8.348 0 014.84 1.217"
				fill="none"
				stroke="#ff0500"
				strokeWidth={0.232}
			/>
			<path
				d="M496.762 245.721a7.92 7.92 0 014.838-1.289 8.366 8.366 0 014.84 1.222"
				fill="none"
				stroke="#ff0b00"
				strokeWidth={0.232}
			/>
			<path
				d="M496.7 245.788a8.278 8.278 0 014.928-1.29 9 9 0 014.992 1.223"
				fill="none"
				stroke="#f10"
				strokeWidth={0.232}
			/>
			<path
				d="M496.7 245.938a8.208 8.208 0 014.928-1.372 9.394 9.394 0 014.992 1.222"
				fill="none"
				stroke="#ff1800"
				strokeWidth={0.232}
			/>
			<path
				d="M496.63 246.005a8.448 8.448 0 014.993-1.373 9.117 9.117 0 015.058 1.285"
				fill="none"
				stroke="#ff1e00"
				strokeWidth={0.232}
			/>
			<path
				d="M496.544 246.067a8.821 8.821 0 015.056-1.374 9.122 9.122 0 015.058 1.29"
				fill="none"
				stroke="#ff2500"
				strokeWidth={0.232}
			/>
			<path
				d="M496.544 246.224a7.963 7.963 0 015.056-1.44 9.471 9.471 0 015.146 1.283"
				fill="none"
				stroke="#ff2d00"
				strokeWidth={0.232}
			/>
			<path
				d="M496.478 246.285a8.476 8.476 0 015.145-1.435 8.8 8.8 0 015.21 1.374"
				fill="none"
				stroke="#f30"
				strokeWidth={0.232}
			/>
			<path
				d="M496.478 246.374a8.363 8.363 0 015.145-1.44 9.184 9.184 0 015.276 1.373"
				fill="none"
				stroke="#ff3900"
				strokeWidth={0.232}
			/>
			<path
				d="M496.412 246.44a8.662 8.662 0 015.212-1.44 9.522 9.522 0 015.275 1.374"
				fill="none"
				stroke="#ff3e00"
				strokeWidth={0.232}
			/>
			<path
				d="M496.324 246.525a8.761 8.761 0 015.276-1.434 10.243 10.243 0 015.364 1.372"
				fill="none"
				stroke="#ff4500"
				strokeWidth={0.232}
			/>
			<path
				d="M495.235 248.467a11.8 11.8 0 0112.97 0"
				fill="none"
				stroke="#fff500"
				strokeWidth={0.232}
			/>
			<path
				d="M495.322 248.339a10.765 10.765 0 016.366-1.876 10.516 10.516 0 016.453 1.937"
				fill="none"
				stroke="#ffeb00"
				strokeWidth={0.232}
			/>
			<path
				d="M495.388 248.249a11.631 11.631 0 0112.665 0"
				fill="none"
				stroke="#ffe000"
				strokeWidth={0.232}
			/>
			<path
				d="M495.453 248.12a11.74 11.74 0 0112.535 0"
				fill="none"
				stroke="#ffd600"
				strokeWidth={0.232}
			/>
			<path
				d="M495.453 248.054a11.655 11.655 0 0112.47 0"
				fill="none"
				stroke="#ffcf00"
				strokeWidth={0.232}
			/>
			<path
				d="M495.54 247.9a10.689 10.689 0 016.17-1.814 9.995 9.995 0 016.147 1.876"
				fill="none"
				stroke="#ffc500"
				strokeWidth={0.232}
			/>
			<path
				d="M495.605 247.837a10.265 10.265 0 016.083-1.81 10.163 10.163 0 016.082 1.809"
				fill="none"
				stroke="#ffb900"
				strokeWidth={0.232}
			/>
			<path
				d="M495.672 247.68a11.381 11.381 0 0112.032 0"
				fill="none"
				stroke="#ffaf00"
				strokeWidth={0.232}
			/>
			<path
				d="M495.76 247.619a9.8 9.8 0 015.95-1.725 10.215 10.215 0 015.93 1.725"
				fill="none"
				stroke="#ffa600"
				strokeWidth={0.232}
			/>
			<path
				d="M495.824 247.462a9.78 9.78 0 015.864-1.651 10.34 10.34 0 015.864 1.65"
				fill="none"
				stroke="#ff9c00"
				strokeWidth={0.232}
			/>
			<path
				d="M495.824 247.4a10.157 10.157 0 015.864-1.657 10.339 10.339 0 015.777 1.591"
				fill="none"
				stroke="#ff9100"
				strokeWidth={0.232}
			/>
			<path
				d="M495.954 247.245a9.51 9.51 0 015.734-1.657 9.663 9.663 0 015.712 1.657"
				fill="none"
				stroke="#ff8600"
				strokeWidth={0.232}
			/>
			<path
				d="M495.954 247.183a9.7 9.7 0 015.734-1.657 10.325 10.325 0 015.712 1.59"
				fill="none"
				stroke="#ff7c00"
				strokeWidth={0.232}
			/>
			<path
				d="M496.042 247.027a10.7 10.7 0 0111.227 0"
				fill="none"
				stroke="#ff7500"
				strokeWidth={0.232}
			/>
			<path
				d="M496.107 246.966a9.189 9.189 0 015.582-1.6 9.517 9.517 0 015.492 1.53"
				fill="none"
				stroke="#ff6b00"
				strokeWidth={0.232}
			/>
			<path
				d="M496.172 246.81a9.365 9.365 0 015.516-1.5 9.5 9.5 0 015.493 1.5"
				fill="none"
				stroke="#ff6000"
				strokeWidth={0.232}
			/>
			<path
				d="M496.26 246.748a8.526 8.526 0 015.428-1.507 10.107 10.107 0 015.428 1.44"
				fill="none"
				stroke="#ff5600"
				strokeWidth={0.232}
			/>
			<path
				d="M495.018 248.617a11.774 11.774 0 016.67-1.936 10.51 10.51 0 016.583 2.026"
				fill="none"
				stroke="#ebff00"
				strokeWidth={0.232}
			/>
			<path
				d="M494.952 248.774a11.112 11.112 0 016.736-2.026 11.336 11.336 0 016.736 2.087"
				fill="none"
				stroke="#d6ff00"
				strokeWidth={0.232}
			/>
			<path
				d="M494.886 248.9a10.977 10.977 0 016.8-2.093 11.207 11.207 0 016.736 2.093"
				fill="none"
				stroke="#c2ff00"
				strokeWidth={0.232}
			/>
			<path
				d="M494.821 249.059a10.813 10.813 0 016.89-2.16 11.145 11.145 0 016.8 2.16"
				fill="none"
				stroke="#adff00"
				strokeWidth={0.232}
			/>
			<path
				d="M494.734 249.12a11.094 11.094 0 016.889-2.154 11.278 11.278 0 016.953 2.153"
				fill="none"
				stroke="#9f0"
				strokeWidth={0.232}
			/>
			<path
				d="M494.668 249.276a10.474 10.474 0 016.956-2.249 10.991 10.991 0 017.019 2.249"
				fill="none"
				stroke="#85ff00"
				strokeWidth={0.232}
			/>
			<path
				d="M494.668 249.427a10.111 10.111 0 016.956-2.311 11.384 11.384 0 017.1 2.221"
				fill="none"
				stroke="#6fff00"
				strokeWidth={0.232}
			/>
			<path
				d="M494.516 249.555a10.2 10.2 0 017.107-2.439 11.2 11.2 0 017.106 2.377"
				fill="none"
				stroke="#5cff00"
				strokeWidth={0.232}
			/>
			<path
				d="M494.451 249.644a10.3 10.3 0 017.172-2.377 11.374 11.374 0 017.172 2.31"
				fill="none"
				stroke="#46ff00"
				strokeWidth={0.232}
			/>
			<path
				d="M494.08 250.3a10.908 10.908 0 017.608-2.528c2.747 0 5.712.72 7.543 2.528"
				fill="none"
				stroke="#05b9e2"
				strokeWidth={0.232}
			/>
			<path
				d="M494.167 250.3a10.551 10.551 0 017.543-2.68 11.3 11.3 0 017.542 2.529"
				fill="none"
				stroke="#09c5c6"
				strokeWidth={0.232}
			/>
			<path
				d="M494.167 250.147a10.92 10.92 0 017.543-2.528c2.748 0 5.646.72 7.456 2.438"
				fill="none"
				stroke="#11ccab"
				strokeWidth={0.232}
			/>
			<path
				d="M494.233 250.058a10.482 10.482 0 017.455-2.529 11.166 11.166 0 017.39 2.467"
				fill="none"
				stroke="#16d38f"
				strokeWidth={0.232}
			/>
			<path
				d="M494.233 250.058a10.289 10.289 0 017.39-2.6c2.747 0 5.646.787 7.39 2.467"
				fill="none"
				stroke="#1cde6f"
				strokeWidth={0.232}
			/>
			<path
				d="M494.3 250a10.06 10.06 0 017.326-2.533 11.471 11.471 0 017.389 2.377"
				fill="none"
				stroke="#20e653"
				strokeWidth={0.232}
			/>
			<path
				d="M494.386 249.93a10 10 0 017.238-2.53 11.281 11.281 0 017.323 2.373"
				fill="none"
				stroke="#28ed38"
				strokeWidth={0.232}
			/>
			<path
				d="M494.386 249.862a10.094 10.094 0 017.238-2.528c2.593 0 5.58.786 7.323 2.4"
				fill="none"
				stroke="#2df81c"
				strokeWidth={0.232}
			/>
			<path
				d="M506.419 245.5a8.148 8.148 0 00-4.774-1.223 7.724 7.724 0 00-4.774 1.289"
				fill="none"
				stroke="red"
				strokeWidth={0.232}
			/>
			<path
				d="M510.844 252.893c-1.874-2.746-5.21-4.058-9.07-4.058-3.552 0-6.364.72-8.762 3.186"
				fill="none"
				stroke="#1800ff"
				strokeWidth={0.232}
			/>
			<path
				d="M509.319 250.3c-1.876-1.808-4.775-2.528-7.609-2.528a11.224 11.224 0 00-7.695 2.594"
				fill="none"
				stroke="#00b3ff"
				strokeWidth={0.232}
			/>
			<path
				d="M510.038 251.452c-2.028-2.377-5.058-3.18-8.415-3.18-3.118 0-6.083.72-8.11 2.9"
				fill="none"
				stroke="#06f"
				strokeWidth={0.232}
			/>
			<path
				d="M508.316 248.617a10.8 10.8 0 00-6.585-2.026 11.285 11.285 0 00-6.582 1.942"
				fill="none"
				stroke="#ff0"
				strokeWidth={0.232}
			/>
			<path
				d="M507.007 246.525a10.055 10.055 0 00-5.363-1.434 8.291 8.291 0 00-5.276 1.59"
				fill="none"
				stroke="#ff4b00"
				strokeWidth={0.232}
			/>
			<path
				d="M508.881 249.644a11.65 11.65 0 00-7.237-2.377 9.981 9.981 0 00-7.172 2.528"
				fill="none"
				stroke="#3f0"
				strokeWidth={0.232}
			/>
			<path
				d="M470.514 289.539l-13.058 21.974h88.507l-13.188-21.974h-62.239"
				fill="#0088e8"
			/>
			<path
				d="M470.514 289.539l-13.058 21.974h88.507l-13.188-21.974h-62.261z"
				fill="none"
				stroke="#00ccb3"
				strokeWidth={0.347}
			/>
			<path
				d="M504.02 302.378a7.146 7.146 0 003.9.065c1.875-.414 3.684-1.5 5.93-1.285 1.59.13 3.77 1.5 6.452 1.5 2.592 0 3.486-.937 5.8-1.374a8.622 8.622 0 014.124.2c1.96.349 2.963 1.5 6.3 1.22"
				fill="none"
				stroke="#000"
				strokeWidth={0.173}
			/>
			<path
				d="M469.926 305.58a7.949 7.949 0 016.082-1.155c2.594.569 3.684 1.222 6.517 1.222 2.029-.067 3.839-1.437 5.952-1.437 3.467 0 3.62.718 6.737 1.286a8.59 8.59 0 005.624-1.071c1-.5 3.466-.412 4.709-.28a10.208 10.208 0 013.553 1.155 7.147 7.147 0 003.9.127c1.875-.563 3.619-1.808 5.93-1.5 1.591.13 3.77 1.721 6.388 1.721 2.68 0 3.555-1.065 5.776-1.59a8.937 8.937 0 014.208.2c1.958.412 2.963 1.724 6.3 1.44"
				fill="none"
				stroke="#fff"
				strokeWidth={0.637}
			/>
			<path
				d="M464.912 303.12a8.622 8.622 0 016.082-1c2.594.5 3.77 1.068 6.517 1.068 2.094-.065 3.838-1.286 5.93-1.286 3.554 0 3.62.632 6.737 1.155a8.61 8.61 0 002.594 0 12.38 12.38 0 003.117-.937c.85-.414 3.4-.349 4.621-.283a10.192 10.192 0 013.554 1.067 10.576 10.576 0 003.9.066c1.874-.5 3.684-1.591 5.93-1.352 1.59.13 3.835 1.592 6.452 1.5 2.593 0 3.554-.938 5.775-1.374a8.618 8.618 0 014.123.2c1.937.414 3.031 1.5 6.363 1.221"
				fill="none"
				stroke="#fff"
				strokeWidth={0.463}
			/>
			<path
				d="M460.355 310.29a7.381 7.381 0 016.083-1.222c2.594.57 3.77 1.378 6.517 1.29 2.094 0 3.9-1.591 5.93-1.591 3.554 0 3.619.781 6.737 1.5a8.783 8.783 0 002.66 0 14.505 14.505 0 003.03-1.216c.937-.5 3.4-.419 4.62-.284a7.61 7.61 0 013.554 1.284 7.447 7.447 0 003.99.066c1.874-.63 3.619-1.942 5.864-1.657 1.59.128 3.836 1.875 6.453 1.875 2.594 0 3.553-1.155 5.8-1.724 1.592-.413 2.378-.129 4.12.2 2.026.5 3.03 1.937 6.367 1.653"
				fill="none"
				stroke="#fff"
				strokeWidth={0.837}
			/>
			<path
				d="M461.51 306.15a9.247 9.247 0 016.148-1c2.595.5 3.772 1.071 6.519 1.071a8.369 8.369 0 002.66-.569"
				fill="none"
				stroke="#fff"
				strokeWidth={0.463}
			/>
			<path
				d="M474.94 301.876a9.349 9.349 0 013.4-.718c3.554 0 1.286 0 4.426.567.785.13 3.03.13 3.684-.415m30.934 10.007a13.356 13.356 0 003.117-1c.937-.436 3.335-.346 4.623-.195a12.449 12.449 0 013.55 1 8.123 8.123 0 003.907.063c1.875-.5 3.682-1.591 5.926-1.374 1.591.195 3.84 1.59 6.451 1.59"
				fill="none"
				stroke="#000"
				strokeWidth={0.406}
			/>
			<path
				d="M522.814 301.506c2.59 0 3.55-.937 5.8-1.373a8.6 8.6 0 014.119.2c2.026.348 3.03 1.5 6.367 1.22"
				fill="none"
				stroke="#fff"
				strokeWidth={0.463}
			/>
			<path
				d="M460.487 310.575a8.745 8.745 0 016.082-1c2.594.5 3.77 1.072 6.583 1.072 2.027-.067 3.837-1.29 5.952-1.29 3.465 0 3.618.631 6.67 1.156a8.419 8.419 0 002.594 0 10.1 10.1 0 003.118-.938 12.478 12.478 0 014.621-.194 8.869 8.869 0 013.554 1"
				fill="none"
				stroke="#000"
				strokeWidth={0.173}
			/>
			<path
				d="M466.067 307.305a9.143 9.143 0 016.083-1c2.593.5 3.77 1.155 6.517 1.072 2.094-.067 3.838-1.29 5.93-1.223 3.553 0 3.684.57 6.736 1.156a8.81 8.81 0 002.594 0 12.409 12.409 0 003.117-1 14.1 14.1 0 014.623-.195 12.691 12.691 0 013.552 1 8.11 8.11 0 003.9.068c1.874-.419 3.684-1.507 5.93-1.38 1.722.2 3.989 1.6 6.451 1.6 2.595 0 3.554-.938 5.8-1.373a8.166 8.166 0 014.208.195c1.875.346 2.963 1.5 6.234 1.217"
				fill="none"
				stroke="#000"
				strokeWidth={0.837}
			/>
			<path
				d="M492.706 252.48a19.3 19.3 0 018.917-2.16 20.064 20.064 0 019.2 2.594l9.418 15.653a18.639 18.639 0 11-37.278.065l9.7-16.175z"
				fill="none"
				stroke="#fff3f3"
				strokeWidth={0.232}
			/>
			<path
				d="M501.624 250.516a20.028 20.028 0 019.133 2.594l9.2 15.436a18.345 18.345 0 11-36.69.064l9.57-15.957a19.825 19.825 0 018.763-2.16z"
				fill="none"
				stroke="#fff3ef"
				strokeWidth={0.232}
			/>
			<path
				d="M501.624 250.732a19.342 19.342 0 018.98 2.595s9.134 15.152 9.134 15.219a18.138 18.138 0 11-36.275.065c0-.065 9.352-15.652 9.418-15.74a19.529 19.529 0 018.7-2.16z"
				fill="none"
				stroke="#ffefef"
				strokeWidth={0.232}
			/>
			<path
				d="M501.624 250.934a19.714 19.714 0 018.849 2.528c.065.061 8.982 14.93 8.982 15.084a17.833 17.833 0 11-35.665.065c0-.132 9.135-15.456 9.2-15.523a19.455 19.455 0 018.611-2.154z"
				fill="none"
				stroke="#ffefed"
				strokeWidth={0.232}
			/>
			<path
				d="M501.624 251.235a19.494 19.494 0 018.7 2.466c.132.129 8.917 14.713 8.917 14.931a17.615 17.615 0 11-35.229 0c0-.131 8.982-15.215 9.135-15.3a18.785 18.785 0 018.48-2.093m0 .217a19.533 19.533 0 018.632 2.468c.131.06 8.763 14.494 8.763 14.712a17.4 17.4 0 11-34.792 0c0-.2 8.917-14.93 9.07-15.087a18.8 18.8 0 018.327-2.093"
				fill="none"
				stroke="#ffedeb"
				strokeWidth={0.232}
			/>
			<path
				d="M501.624 251.737a18.533 18.533 0 018.479 2.377c.2.129 8.633 14.213 8.633 14.5a17.113 17.113 0 11-34.226 0c0-.2 8.611-14.714 8.85-14.87a18.041 18.041 0 018.263-2.027z"
				fill="none"
				stroke="#ffebe8"
				strokeWidth={0.232}
			/>
			<path
				d="M501.624 251.955a18.484 18.484 0 018.414 2.377c.195.128 8.48 13.908 8.48 14.279a16.9 16.9 0 11-33.79 0c0-.284 8.48-14.5 8.763-14.652a17.757 17.757 0 018.11-2.027z"
				fill="none"
				stroke="#ffebe6"
				strokeWidth={0.232}
			/>
			<path
				d="M501.624 252.172a18.23 18.23 0 018.26 2.378c.284.128 8.329 13.69 8.329 14.06a16.612 16.612 0 11-33.224 0c0-.348 8.328-14.277 8.612-14.428a17.425 17.425 0 017.978-2.032z"
				fill="none"
				stroke="#ffe8e6"
				strokeWidth={0.232}
			/>
			<path
				d="M501.624 252.48a17.263 17.263 0 018.109 2.31c.282.128 8.26 13.406 8.26 13.842a16.393 16.393 0 11-32.786 0c0-.348 8.2-13.993 8.48-14.217a17.386 17.386 0 017.891-1.935z"
				fill="none"
				stroke="#ffe8e2"
				strokeWidth={0.232}
			/>
			<path
				d="M501.624 252.675a17.233 17.233 0 018.043 2.31c.283.195 8.044 13.19 8.044 13.626a16.1 16.1 0 11-32.2 0c0-.415 7.978-13.777 8.328-13.994a17.624 17.624 0 017.76-1.942z"
				fill="none"
				stroke="#ffe6e0"
				strokeWidth={0.232}
			/>
			<path
				d="M501.624 252.981a17.484 17.484 0 017.912 2.222c.349.194 7.978 12.906 7.978 13.408a15.881 15.881 0 11-31.761.087c0-.5 7.825-13.624 8.2-13.841a17.113 17.113 0 017.674-1.876"
				fill="none"
				stroke="#ffe6de"
				strokeWidth={0.232}
			/>
			<path
				d="M501.624 253.2a16.541 16.541 0 017.76 2.243 153.017 153.017 0 017.825 13.19 15.619 15.619 0 11-31.238.086c0-.567 7.673-13.343 8.109-13.623a16.808 16.808 0 017.543-1.874z"
				fill="none"
				stroke="#ffe2de"
				strokeWidth={0.232}
			/>
			<path
				d="M501.624 253.417a15.949 15.949 0 017.607 2.243c.5.195 7.761 12.405 7.761 12.972a15.37 15.37 0 01-30.739.156v-.088c0-.566 7.457-13.12 7.979-13.4a15.754 15.754 0 017.39-1.875"
				fill="none"
				stroke="#ffe2dc"
				strokeWidth={0.232}
			/>
			<path
				d="M501.624 253.7a16.217 16.217 0 017.542 2.155c.5.285 7.608 12.1 7.608 12.755a15.151 15.151 0 11-30.3.066c0-.634 7.39-12.905 7.913-13.19a16.11 16.11 0 017.238-1.808zm0 .219a16.06 16.06 0 017.389 2.092c.5.346 7.543 11.967 7.543 12.62a15 15 0 01-14.933 14.934 14.845 14.845 0 01-14.868-14.865c0-.72 7.172-12.686 7.7-12.97a16.339 16.339 0 017.172-1.808"
				fill="none"
				stroke="#ffe0d9"
				strokeWidth={0.232}
			/>
			<path
				d="M501.624 254.2a17 17 0 017.323 2.031c.5.347 7.326 11.749 7.326 12.4a14.65 14.65 0 11-29.3.065c0-.718 7.02-12.468 7.543-12.751a15.78 15.78 0 017.107-1.725z"
				fill="none"
				stroke="#ffded6"
				strokeWidth={0.232}
			/>
			<path
				d="M501.624 254.415a16.1 16.1 0 017.17 2.033c.5.345 7.239 11.443 7.239 12.184a14.577 14.577 0 01-14.433 14.5 14.4 14.4 0 01-14.343-14.432c0-.785 6.8-12.183 7.39-12.557a16.016 16.016 0 016.953-1.725z"
				fill="none"
				stroke="#ffded3"
				strokeWidth={0.232}
			/>
			<path
				d="M501.624 254.723a15.6 15.6 0 017.019 1.942c.566.346 7.106 11.226 7.106 11.967a14.137 14.137 0 11-28.274.066c0-.785 6.67-11.966 7.325-12.318a15.116 15.116 0 016.8-1.657z"
				fill="none"
				stroke="#ffdcd3"
				strokeWidth={0.232}
			/>
			<path
				d="M501.624 254.94a14.631 14.631 0 016.887 1.943c.633.346 7.02 10.943 7.02 11.75a13.919 13.919 0 11-27.838.086c0-.85 6.517-11.747 7.237-12.1a14.811 14.811 0 016.67-1.656z"
				fill="none"
				stroke="#ffdcd1"
				strokeWidth={0.232}
			/>
			<path
				d="M501.624 255.158a14.521 14.521 0 016.8 1.942c.633.413 6.8 10.66 6.8 11.532a13.625 13.625 0 11-27.249.087c0-.937 6.387-11.446 7.02-11.88a14.693 14.693 0 016.583-1.659zm0 .285a14.022 14.022 0 016.67 1.874c.719.413 6.735 10.443 6.735 11.315a13.407 13.407 0 11-26.814.087c0-.937 6.235-11.228 6.955-11.664a13.77 13.77 0 016.453-1.59z"
				fill="none"
				stroke="#ffd9cf"
				strokeWidth={0.232}
			/>
			<path
				d="M501.624 255.66a13.437 13.437 0 016.517 1.876c.784.413 6.583 10.16 6.583 11.1a13.156 13.156 0 11-26.312.087c0-1 6.082-11.01 6.8-11.446a13.811 13.811 0 016.365-1.59z"
				fill="none"
				stroke="#ffd6cc"
				strokeWidth={0.232}
			/>
			<path
				d="M501.624 255.945a13.614 13.614 0 016.386 1.808c.785.413 6.517 9.942 6.517 10.88a12.905 12.905 0 11-25.81.065c0-1 5.8-10.727 6.671-11.23a13.659 13.659 0 016.235-1.523"
				fill="none"
				stroke="#ffd6c9"
				strokeWidth={0.232}
			/>
			<path
				d="M501.624 256.163a13.19 13.19 0 016.3 1.808c.785.5 6.366 9.636 6.366 10.661a12.688 12.688 0 11-25.376.066c0-1.068 5.734-10.51 6.519-11.011a13.557 13.557 0 016.147-1.524z"
				fill="none"
				stroke="#ffd3c9"
				strokeWidth={0.232}
			/>
			<path
				d="M501.624 256.38a12.556 12.556 0 016.147 1.808c.85.5 6.234 9.42 6.234 10.444a12.4 12.4 0 11-24.809.065c0-1.067 5.495-10.29 6.367-10.787a13 13 0 016.016-1.507z"
				fill="none"
				stroke="#ffd3c6"
				strokeWidth={0.232}
			/>
			<path
				d="M501.624 256.687a13.483 13.483 0 016.08 1.658c.85.5 6.083 9.2 6.083 10.287a12.187 12.187 0 11-24.373.066c0-1.068 5.363-10.007 6.3-10.57a13.187 13.187 0 015.864-1.44z"
				fill="none"
				stroke="#ffd1c5"
				strokeWidth={0.232}
			/>
			<path
				d="M501.624 256.9a12.737 12.737 0 015.95 1.657c.937.564 5.93 8.914 5.93 10.136a11.925 11.925 0 11-23.85 0c0-1.156 5.211-9.857 6.17-10.353a13.033 13.033 0 015.776-1.44z"
				fill="none"
				stroke="#ffd1c2"
				strokeWidth={0.232}
			/>
			<path
				d="M501.624 257.189a13.112 13.112 0 015.8 1.59c1 .565 5.864 8.7 5.864 9.919a11.663 11.663 0 01-23.325.029v-.027c0-1.221 4.992-9.572 6.017-10.136a12.5 12.5 0 015.646-1.373"
				fill="none"
				stroke="#ffcfc2"
				strokeWidth={0.232}
			/>
			<path
				d="M501.624 257.407a11.2 11.2 0 015.645 1.59c1 .564 5.733 8.48 5.733 9.723a11.413 11.413 0 11-22.825 0c0-1.22 4.841-9.353 5.865-9.917a12.387 12.387 0 015.582-1.373z"
				fill="none"
				stroke="#ffcfbe"
				strokeWidth={0.232}
			/>
			<path
				d="M501.624 257.686a12.071 12.071 0 015.58 1.507c1 .57 5.58 8.2 5.58 9.483a11.161 11.161 0 01-22.322 0c0-1.287 4.708-9.138 5.71-9.724a12.342 12.342 0 015.428-1.284zm0 .224a11.455 11.455 0 015.427 1.5c1.067.654 5.428 7.98 5.428 9.266a10.911 10.911 0 11-21.821 0c0-1.286 4.556-8.852 5.645-9.483a11.011 11.011 0 015.276-1.283z"
				fill="none"
				stroke="#ffccbc"
				strokeWidth={0.232}
			/>
			<path
				d="M501.624 258.127a11.472 11.472 0 015.362 1.5c1 .631 5.275 7.7 5.275 9.07a10.66 10.66 0 11-21.32 0c0-1.374 4.338-8.634 5.494-9.265a11.068 11.068 0 015.144-1.29z"
				fill="none"
				stroke="#ffc9b9"
				strokeWidth={0.232}
			/>
			<path
				d="M501.624 258.345a10.89 10.89 0 015.209 1.5c1.068.632 5.144 7.392 5.144 8.853a10.409 10.409 0 01-20.817.081v-.079c0-1.44 4.207-8.417 5.361-9.07a10.785 10.785 0 015.058-1.283z"
				fill="none"
				stroke="#ffc9b8"
				strokeWidth={0.232}
			/>
			<path
				d="M501.624 258.624a9.984 9.984 0 015.056 1.44c1.155.636 5.08 7.173 5.08 8.634a10.181 10.181 0 11-20.362 0c0-1.44 4.055-8.11 5.276-8.852a10.492 10.492 0 014.926-1.222z"
				fill="none"
				stroke="#ffc6b8"
				strokeWidth={0.232}
			/>
			<path
				d="M501.624 258.841a10.655 10.655 0 014.991 1.44c1.155.72 4.927 6.891 4.927 8.417a9.931 9.931 0 01-19.861 0c0-1.5 3.838-7.892 5.08-8.634a10.891 10.891 0 014.84-1.223z"
				fill="none"
				stroke="#ffc6b5"
				strokeWidth={0.232}
			/>
			<path
				d="M501.624 259.065a9.85 9.85 0 014.838 1.434c1.221.72 4.774 6.673 4.774 8.2a9.668 9.668 0 11-19.336 0c0-1.5 3.77-7.675 4.992-8.417a10.125 10.125 0 014.708-1.216zm0 .3a8.933 8.933 0 014.708 1.374c1.307.719 4.708 6.366 4.708 7.979a9.49 9.49 0 01-9.417 9.418 9.351 9.351 0 01-9.418-9.418c0-1.59 3.553-7.389 4.84-8.2a9.218 9.218 0 014.555-1.155z"
				fill="none"
				stroke="#ffc5b3"
				strokeWidth={0.232}
			/>
			<path
				d="M501.624 259.583a9.85 9.85 0 014.555 1.29c1.286.781 4.556 6.233 4.556 7.825a9.167 9.167 0 11-18.334 0c0-1.591 3.4-7.171 4.71-7.98a9.408 9.408 0 014.49-1.156z"
				fill="none"
				stroke="#ffc2af"
				strokeWidth={0.232}
			/>
			<path
				d="M501.624 259.868a9.534 9.534 0 014.49 1.222c1.286.782 4.424 5.93 4.424 7.608a8.916 8.916 0 11-17.832 0c0-1.657 3.183-6.955 4.556-7.764a9.539 9.539 0 014.338-1.065z"
				fill="none"
				stroke="#ffc2ad"
				strokeWidth={0.232}
			/>
			<path
				d="M501.624 260.086a8.939 8.939 0 014.337 1.223c1.373.786 4.272 5.645 4.272 7.389a8.666 8.666 0 11-17.331.036v-.034c0-1.723 3.03-6.737 4.426-7.54a9.471 9.471 0 014.272-1.072z"
				fill="none"
				stroke="#ffbead"
				strokeWidth={0.232}
			/>
			<path
				d="M501.624 260.37a8.453 8.453 0 014.271 1.156c1.353.87 4.121 5.428 4.121 7.172a8.448 8.448 0 11-16.9 0c0-1.723 2.9-6.452 4.34-7.323a8.806 8.806 0 014.119-1z"
				fill="none"
				stroke="#ffbeab"
				strokeWidth={0.232}
			/>
			<path
				d="M501.624 260.589a9 9 0 014.118 1.154c1.44.849 3.99 5.21 3.99 6.955a8.142 8.142 0 11-16.284 0c0-1.81 2.66-6.235 4.12-7.1a9.386 9.386 0 014.055-1"
				fill="none"
				stroke="#ffbca8"
				strokeWidth={0.232}
			/>
			<path
				d="M501.624 260.806a8.352 8.352 0 013.988 1.155c1.439.848 3.9 4.928 3.9 6.737a7.946 7.946 0 11-15.892.046v-.044c0-1.81 2.529-6.017 4.054-6.888a8.825 8.825 0 013.9-1z"
				fill="none"
				stroke="#ffbca6"
				strokeWidth={0.232}
			/>
			<path
				d="M501.624 261.113a7.627 7.627 0 013.835 1.065c1.5.849 3.838 4.71 3.838 6.52a7.674 7.674 0 01-15.348.087v-.085c0-1.875 2.311-5.8 3.9-6.67a8.414 8.414 0 013.77-.938z"
				fill="none"
				stroke="#ffb9a6"
				strokeWidth={0.232}
			/>
			<path
				d="M501.624 261.33a7.887 7.887 0 013.77 1.067c1.5.937 3.619 4.426 3.619 6.3a7.423 7.423 0 11-14.846.008v-.005c0-1.941 2.158-5.493 3.837-6.452a7.347 7.347 0 013.619-.937z"
				fill="none"
				stroke="#ffb9a2"
				strokeWidth={0.232}
			/>
			<path
				d="M501.624 261.615a7.019 7.019 0 013.618 1c1.5.938 3.553 4.12 3.553 6.084a7.172 7.172 0 11-14.344 0c0-1.941 2.026-5.275 3.618-6.235a7.235 7.235 0 013.554-.848m0 .218a7.085 7.085 0 013.466 1 8.46 8.46 0 013.4 5.867 6.921 6.921 0 11-13.842 0 8.2 8.2 0 013.554-5.928 6.1 6.1 0 013.4-.937z"
				fill="none"
				stroke="#ffb8a0"
				strokeWidth={0.232}
			/>
			<path
				d="M501.624 262.05a6.215 6.215 0 013.4 1 7.717 7.717 0 013.247 5.648 6.7 6.7 0 11-13.406 0 7.949 7.949 0 013.4-5.8 7.347 7.347 0 013.335-.847z"
				fill="none"
				stroke="#ffb59e"
				strokeWidth={0.232}
			/>
			<path
				d="M501.624 262.33a5.668 5.668 0 013.247.937 7.08 7.08 0 013.117 5.43 6.42 6.42 0 11-12.839 0 7.185 7.185 0 013.247-5.582 6.488 6.488 0 013.183-.787z"
				fill="none"
				stroke="#ffb59c"
				strokeWidth={0.232}
			/>
			<path
				d="M501.624 262.553a6.589 6.589 0 013.116.847 6.441 6.441 0 013.03 5.276 6.191 6.191 0 11-12.382.087 6.56 6.56 0 013.183-5.43 5.9 5.9 0 013.03-.78z"
				fill="none"
				stroke="#ffb39c"
				strokeWidth={0.232}
			/>
			<path
				d="M501.624 274.671a5.838 5.838 0 005.862-5.814v-.05a5.9 5.9 0 10-5.863 5.864"
				fill="none"
				stroke="#ffb399"
				strokeWidth={0.232}
			/>
			<path
				d="M501.624 274.736a5.93 5.93 0 10-5.931-5.93 5.982 5.982 0 005.931 5.93"
				fill="none"
				stroke="#fff"
				strokeWidth={0.173}
			/>
			<path
				d="M501.624 274.736a5.93 5.93 0 10-5.931-5.93 5.982 5.982 0 005.931 5.93"
				fill="#fff"
			/>
			<path
				d="M502.93 262.92l.633-3.118m-1.287 3.03l.35-3.181m-1 3.18v-3.248m-.567 3.248l-.283-3.18m-.37 3.27l-.655-3.12m.065 3.338l-1-3.12m.438 3.337l-1.286-2.963m.762 3.18l-1.656-2.745m1.09 3.1l-1.876-2.593m1.44 3.03l-2.246-2.465m1.722 2.9l-2.377-2.159m2.028 2.682l-2.594-1.94m2.224 2.378l-2.812-1.593m2.506 2.159l-2.964-1.286m2.747 1.874l-3.03-1m2.833 1.57l-3.117-.632m3.03 1.286l-3.183-.35m3.183 1h-3.248m3.248.589l-3.183.348m3.27.305l-3.117.633m3.313-.044l-3.117 1m3.335-.436l-2.964 1.286m3.27-.7l-3.466 2.094m3.75-1.592l-6.955 4.991m7.39-4.49l-7.543 6.584m7.914-6.147l-6.155 6.89m6.649-6.517l-4.621 6.3m5.144-5.865l-4.84 8.482m5.407-8.263l-2.68 6.147m3.269-5.864L497 283m3.314-8.327l-1.155 5.71m1.81-5.645l-.85 8.763m2.092-8.763l.349 3.183m.305-3.248l1.875 8.262m-1.286-8.415l1.591 4.84m-1.025-5.06l3.772 8.11m-3.182-8.394l4.054 6.89m-3.553-7.26l5.8 7.608m-5.3-7.956l5.08 5.864m-4.645-6.3l7.544 6.8m-7.172-7.325l4.12 2.966m-3.75-3.467l2.812 1.592m-2.529-2.18l2.966 1.286m-2.748-1.852l3.03 1m-2.811-1.59l3.117.633m-3.052-1.287l3.183.349m-3.1-1h3.182m-3.27-.566l3.183-.283m-3.248-.305l3.117-.72m-3.336.065l3.118-1m-3.27.415l2.9-1.286m-3.184.719l2.813-1.592m-3.183 1.091l2.594-1.873m-2.943 1.35l2.377-2.16m-2.806 1.718l2.093-2.377m-2.615 1.94l1.874-2.532m-2.377 2.25l1.592-2.813m-2.18 2.528l1.286-2.963m-1.853 2.746l1-3.03m-2.9-4.884v-2.46m-2.747 2.744l-.5-2.377m-2.2 3.248l-1-2.243m-1.438 3.706l-1.5-2.032m-.61 3.907l-1.875-1.658m.218 3.99l-2.18-1.289m1 3.816l-2.377-.785m1.723 3.554l-2.442-.2m2.442 3.03l-2.442.284m3.095 2.528l-2.462.72m27.052 1.9l2.18 1.22m-1-3.836l2.31.785m-1.743-3.531l2.441.282m-2.441-3.117l2.441-.195m-3.008-2.552l2.376-.785m-3.553-1.83l2.18-1.22m-3.837-1.027l1.875-1.742m-3.9-.15l1.373-2.032m-3.837.592l1-2.31m-3.772 1.35l.5-2.378"
				fill="none"
				stroke="#000"
				strokeWidth={0.173}
			/>
			<path
				d="M505.111 271.553a4.261 4.261 0 00-1.373-.414 17.848 17.848 0 00-3.62.13 1.842 1.842 0 00-.85.567 3.134 3.134 0 001.744.72 7.3 7.3 0 002.594-.2 5.4 5.4 0 001.5-.784"
				fill="#e60000"
			/>
			<path
				d="M505.111 271.553a4.261 4.261 0 00-1.373-.414 17.848 17.848 0 00-3.62.13 1.842 1.842 0 00-.85.567 3.134 3.134 0 001.744.72 7.3 7.3 0 002.594-.2 5.4 5.4 0 001.5-.784z"
				fill="none"
				stroke="#000"
				strokeWidth={0.173}
			/>
			<path
				d="M499.377 270.681A8.94 8.94 0 01500.6 267a10.316 10.316 0 00-.567 1.068s-.632.35-1-.13c-.413-.349-.195-.5.066-1.157.282-.414.2-.849.567-1.154.282-.283.567-.349 1.373-.349a1.932 1.932 0 011.94 1c.567.784.938 1.5 1.222 1.94a5.1 5.1 0 01.632 2.311l.2 1a4.254 4.254 0 00-1.374-.415 17.76 17.76 0 00-3.618.13 1.847 1.847 0 00-.85.568s-.348-.784.131-1.155"
				fill="#e60000"
			/>
			<path
				d="M499.377 270.681A8.94 8.94 0 01500.6 267a10.316 10.316 0 00-.567 1.068s-.632.35-1-.13c-.413-.349-.195-.5.066-1.157.282-.414.2-.849.567-1.154.282-.283.567-.349 1.373-.349a1.932 1.932 0 011.94 1c.567.784.938 1.5 1.222 1.94a5.1 5.1 0 01.632 2.311l.2 1a4.254 4.254 0 00-1.374-.415 17.76 17.76 0 00-3.618.13 1.847 1.847 0 00-.85.568s-.348-.784.131-1.155z"
				fill="none"
				stroke="#000"
				strokeWidth={0.173}
			/>
			<path
				d="M499.377 270.681a6.612 6.612 0 012.747-.348c2.528.065 2.594.195 2.748.414"
				fill="none"
				stroke="#000"
				strokeWidth={0.173}
			/>
			<path
				d="M501.558 279.968v-8.7s.282-.282.937 0v8.632s.2 6.671-.5 6.585c-.851 0-.415-1.5-.415-6.52"
				fill="#fc0"
			/>
			<path
				d="M501.558 279.968v-8.7s.282-.282.937 0v8.632s.2 6.671-.5 6.585c-.851 0-.415-1.5-.415-6.52z"
				fill="none"
				stroke="#000"
				strokeWidth={0.173}
			/>
			<path
				d="M545.964 311.534l-44.319-73.99-44.166 73.99h88.485z"
				fill="none"
				stroke="#000"
				strokeWidth={0.406}
			/>
			<path
				d="M467.245 295.054c.414.065 1.439-.72 1.722-.938.414-.2.632-.85.937-1.221a18.328 18.328 0 011.81-1.155 12.071 12.071 0 004.337-3.837 21.353 21.353 0 016.955-6.3 3.863 3.863 0 013.182.066 3.6 3.6 0 011 .718 13.867 13.867 0 004.708 2.16c1.875.566 2.31 1.808 3.77 3.116a9.808 9.808 0 002.465 1.592c.066.066.283.349.348.414.785.633 1.722 1.156 2.465 1.723 1.373 1.22 2.593 2.462 3.9 3.77.217.2.284.634.5.786a12.547 12.547 0 003.032 2.462 35.814 35.814 0 013.335 2.028c-11.249.415-21.539-.283-32.853.066h-2.092c-.785-.066-1.286 0-2.159 0-3.4 0-6.67 0-10.659-.066l3.183-5.428"
				fill="#090"
			/>
			<path
				d="M467.245 295.054c.414.065 1.439-.72 1.722-.938.414-.2.632-.85.937-1.221a18.328 18.328 0 011.81-1.155 12.071 12.071 0 004.337-3.837 21.353 21.353 0 016.955-6.3 3.863 3.863 0 013.182.066 3.6 3.6 0 011 .718 13.867 13.867 0 004.708 2.16c1.875.566 2.31 1.808 3.77 3.116a9.808 9.808 0 002.465 1.592c.066.066.283.349.348.414.785.633 1.722 1.156 2.465 1.723 1.373 1.22 2.593 2.462 3.9 3.77.217.2.284.634.5.786a12.547 12.547 0 003.032 2.462 35.814 35.814 0 013.335 2.028c-11.249.415-21.539-.283-32.853.066h-2.092c-.785-.066-1.286 0-2.159 0-3.4 0-6.67 0-10.659-.066l3.183-5.428z"
				fill="none"
				stroke="#000"
				strokeWidth={0.347}
			/>
			<path
				d="M481.96 282.28c.566-.066.282-.2.784.13m-1.788.523c.567-.065.785-.414 1.222.065m-1.744.305a1.224 1.224 0 011.22.2m-1.788.524a2.18 2.18 0 011.287.065m-2.006.436c.567-.195.85.2 1.5.066m-2.245.675c.414 0 .5-.13.85 0 .436.066.349 0 .785.066m-2.42.654a4.451 4.451 0 01.938 0 1.877 1.877 0 00.85 0m-2.224.653a3.278 3.278 0 011.656.132m-2.833 1.4a2.056 2.056 0 011.656.065m-13.406 12.056c2.31-.35 5.08.065 7.39-.283m4.73-12.557c.567-.2.414-.131 1-.066.632.065.85.13 1 .065m-2.943 1.374a2.536 2.536 0 011.875 0m-.35.588a9.674 9.674 0 00-1.94 0m1.418.72a4.22 4.22 0 00-2.093-.131m-.872.633a7.887 7.887 0 012.464.064m-3.184.59a5.872 5.872 0 012.682.065m-3.553.435c.937-.065 1.809-.065 2.747-.065.13 0 .414-.13.567.065m-.262.524a26.7 26.7 0 01-4.208.13m3.4.59a13.183 13.183 0 01-1.788.13c-.065 0-.2-.13-.348-.13a7.386 7.386 0 00-2.093.195m-.349.524a1.176 1.176 0 01.938-.066 16.015 16.015 0 012.528.2 2.132 2.132 0 00.72.13m-4.687.11a9.04 9.04 0 011.875.065 14.934 14.934 0 002.376.348h-.065m-4.775.022a8.858 8.858 0 011.962.283c.85.13 1.81-.065 2.594.13m-5.34.023c.85.349 1.808.065 2.746.2.85.13 1.656.13 2.53.283m-5.865.24a28.553 28.553 0 014.054.2 3.343 3.343 0 001.5.13m-6.059.262a35.292 35.292 0 013.988.35 8.566 8.566 0 001.875.195h-.13m-6.257.458a.764.764 0 01.35-.13c1.067 0 2.092.13 3.182.065a6.85 6.85 0 012.593.13h-.065m-6.562.589c2.094-.2 4.273.065 6.366 0m-6.736.654c2.245.195 4.49 0 6.671.195m-7.02.459c1 .2 1.94-.065 2.9.13a7.525 7.525 0 002.092.13 8.539 8.539 0 011.81-.064m9.09-9.265h.2m-.414.283c.065 0 .2-.13.2 0m-.5.37h.5m-.633.285h.567m-1 .37c.35 0 .633.066 1 .066h-.065m-1.22.435c.348-.13.783 0 1.155-.13h-.066m-1.613.719h1.526m-1.81.371a6.884 6.884 0 011.657.065m-2.027.5a10.346 10.346 0 012 .065m-2.377.523c.415-.065.786.2 1.222.283a1.879 1.879 0 00.85-.065m-2.2.218a7.07 7.07 0 001.96.283m-2.331.218a5.567 5.567 0 011.591.283 2.619 2.619 0 00.72 0m-3.03.524a3.637 3.637 0 012.245.13 3.1 3.1 0 00.784 0h-.065m-3.03.37a3.708 3.708 0 012.376.132h.414m-3.313.523c1.068.2 2.18-.13 3.183.132m-3.466.3c.85.349 1.809 0 2.68.283a1.549 1.549 0 00.939-.065m-4.186.437a2.232 2.232 0 011.155-.131 21.7 21.7 0 002.813.282m-4.491.5c.195 0 .414.13.632.065a38.281 38.281 0 013.836-.065m-4.752.5c1 .349 2.027 0 3.183.282a1.968 1.968 0 001.373 0m-4.927.46c1.5.064 3.03-.066 4.84.13m4.023-9.142c.13 0 .283.13.414.13m-.632.37a.85.85 0 01.567-.065m-.7.5a1.625 1.625 0 01.786.065m-1 .524a5.214 5.214 0 011 .065m-1.309.5c.414-.131.85.065 1.286-.066m-1.35.5a8.508 8.508 0 001.307.065v-.065m-1.526.653a3.466 3.466 0 011.155.066.48.48 0 00.414-.065m-1.634.588c.567-.2 1.067.13 1.656 0m-1.875.72a16.791 16.791 0 001.81 0m-2.028.588c.2-.065.5-.282.785-.13a6.814 6.814 0 001.221.13m-2.159.654c.72-.283 1.44.131 2.159-.2m-2.224.85a2.565 2.565 0 011 0 2.849 2.849 0 001.286 0m-2.506.633a16.937 16.937 0 012.594-.066l-.065.065m-3.052.59c1.067-.066 2.245-.2 3.335-.2m-3.183.85a23.007 23.007 0 013.684-.13m-3.9.785a12.313 12.313 0 002.682-.066 9.007 9.007 0 001.44-.282h.718m-4.84.719c1.81-.132 3.772.13 5.647-.283m-13.777.064h1.5m5.69.219c.2.065.413-.067.5.065m6.606-.218c1.5-.13 3.03.283 4.557 0m-5.341-.5a5.571 5.571 0 012.811.13c.066 0 .066.131.131.2a10.148 10.148 0 002.442-.065m-10.77-.349h-1m-5.1-.218c-.631.065-1.286.065-2.026.13m14.8-14.343h.284m-.13.436a.835.835 0 00.348-.066m-.282.72a.228.228 0 01.064-.131h.414m-.326.567c.195-.13.414-.066.719-.066m.065.436a2.354 2.354 0 00-.632.131m.282.589a1.086 1.086 0 01.633-.13m.305.5h-.937m.283.5a1.515 1.515 0 00.938-.13m.24.7a2.507 2.507 0 00-1 .13m.2.61a1.845 1.845 0 001.156-.2m.088.414a9.5 9.5 0 01-1.069.284m.195.589c.415-.2 1 0 1.44-.13m.153.565a6.864 6.864 0 00-1.156 0 .684.684 0 01-.348.132m.26.959a1.537 1.537 0 01.938-.284c0-.2.2 0 .348-.13.066-.066.2 0 .35 0m.261.633a7.322 7.322 0 00-1.656.13m.13.72c.633-.2 1.286-.2 1.962-.35m-1.9 1.156a10.883 10.883 0 002.158-.415m.523.48a8.556 8.556 0 00-2.377.349m.131.74a.681.681 0 00.35.132 4.379 4.379 0 012.245-.5m.24.59a6.081 6.081 0 01-2.463.282c-.066 0-.132.066-.284.131m.283.545c.938-.13 1.81-.2 2.747-.349m.588.632c-.719.066-1.439-.065-2.158.066-.348.066-.654.2-1 .283m.11.589c.13 0 .283.065.349-.066a6.2 6.2 0 013.03-.348m.327.567a8.667 8.667 0 00-2.594.065 2.151 2.151 0 01-.939.282m.263.655c.5-.065.937-.283 1.373-.349a21.268 21.268 0 012.9-.065m0 .5a3.566 3.566 0 00-1.657 0 10.656 10.656 0 01-2.464.414m.5.457c.655-.065 1.286-.282 1.94-.414a6.983 6.983 0 011.657-.066m-3.6.85a20.4 20.4 0 003.03-.282c.35-.131.72.064 1.07 0m.042-.392c1.744.13 3.4-.2 5.08.13m-4.73.393c.195.065.348-.132.5-.132 1.374 0 2.748.065 4.208.132m-.5-3.554h.2m-.108.436c.13.066.349-.2.5 0m-.37.5h.851m-.633.72c.284-.349.72 0 1-.2m-.784.85c.349-.282.937.066 1.286-.282m-1.2.784c.566-.13 1.154.066 1.656-.282m-1.439.805c.85-.348 1.809.2 2.594-.414m-2.529.85c1.069-.349 2.18 0 3.248-.065m.676 0q2.79-.1 5.581 0m-6.387-.675c1.656.13 4.12 0 6.169.13"
				fill="none"
				stroke="#00b300"
				strokeWidth={0.173}
			/>
			<path
				d="M511.434 300.22c-.939-.567-1.877-1.22-2.9-1.722a11.523 11.523 0 01-3.03-2.465c-.2-.13-.285-.565-.5-.784-1.286-1.286-2.528-2.528-3.9-3.77-.72-.568-1.657-1.07-2.464-1.723-.065-.065-.283-.349-.349-.414a9.37 9.37 0 01-2.463-1.59c-.938-.851-1.44-1.658-2.224-2.313v-.065c.5-.282 1-.632 1.5-.937a3.309 3.309 0 012.68.13 2.509 2.509 0 01.851.5 11.631 11.631 0 003.9 1.875c1.592.414 1.941 1.438 3.183 2.53a6.893 6.893 0 001.94 1.285 4.486 4.486 0 01.283.414 14.793 14.793 0 012.094 1.438q1.656 1.525 3.247 3.118c.131.131.2.5.35.654a11.014 11.014 0 002.593 2.027c.937.5 1.81 1.156 2.747 1.657-2.528.131-4.992.131-7.542.131h-.066"
				fill="#fc0"
			/>
			<path
				d="M511.434 300.22c-.939-.567-1.877-1.22-2.9-1.722a11.523 11.523 0 01-3.03-2.465c-.2-.13-.285-.565-.5-.784-1.286-1.286-2.528-2.528-3.9-3.77-.72-.568-1.657-1.07-2.464-1.723-.065-.065-.283-.349-.349-.414a9.017 9.017 0 01-2.463-1.59c-.938-.851-1.44-1.658-2.224-2.313v-.065c.5-.282 1-.632 1.5-.937a3.309 3.309 0 012.68.13 2.509 2.509 0 01.851.5 11.631 11.631 0 003.9 1.875c1.592.414 1.941 1.438 3.183 2.53a6.893 6.893 0 001.94 1.285 4.486 4.486 0 01.283.414 14.793 14.793 0 012.094 1.438q1.656 1.525 3.247 3.118c.131.131.2.5.35.654a11.014 11.014 0 002.593 2.027c.937.5 1.81 1.156 2.747 1.657-2.528.131-4.992.131-7.542.131h-.066z"
				fill="none"
				stroke="#000"
				strokeWidth={0.347}
			/>
			<path
				d="M495.322 287.075c.131 0 1.222-.2 1.352-.2m-1 .48a3.524 3.524 0 001.44-.195m-.851.719l1-.2h.413m-.98.48c.131-.065 1.5 0 1.743-.065m.349.349a5.306 5.306 0 00-1.5.194m.937.612a3.238 3.238 0 011.22-.283m.654.5c-.348 0-1.067.066-1.439.066m.72.587a4.566 4.566 0 001.221-.282m.741.566c-.414 0-.937.065-1.439.065m.633.524a10.52 10.52 0 001.5-.065m.545.282a10.014 10.014 0 01-1.286.284m.632.59c.348-.2 1-.066 1.5-.2m.523.48a7.463 7.463 0 00-1.286.066 1.344 1.344 0 01-.349.065m3.161 1.025a7.9 7.9 0 00-1.81.13m.567.676a9.139 9.139 0 011.962-.35m-.5 2.094a4.592 4.592 0 00.938-.065 8.04 8.04 0 012.092-.283m.523.414c-1.22.195-1.656.195-2.594.348-.13 0-.414.066-.5.066m.545.457c.937-.195 2.245-.13 3.183-.283m1.024.5c-.72.13-1.657 0-2.377.13-.282.065-.936.13-1.285.2m.915.61c.066 0 .284 0 .35-.065.719-.5 1.94-.35 3.029-.35m.763.48c-1.067 0-1.5 0-2.31.066a5.134 5.134 0 01-1.069.195m.83.61c1-.194 2.811-.348 1.721-.282 1-.066 1.156-.066 2.311-.066m.3.349a5.694 5.694 0 00-1.874.065 3.977 3.977 0 01-1.723.284m.567.306a5.1 5.1 0 001.44-.2 7.915 7.915 0 011.787-.065m-2.856.566a8.635 8.635 0 012.245-.065 4.649 4.649 0 00.937-.065m-19.663-13.3a1.166 1.166 0 01.85-.13c-.065-.2.2 0 .349-.131 0-.067.2 0 .349 0m-2.049-.241a1.455 1.455 0 01.937-.065c-.131-.2.283 0 .283-.13.066-.066.283 0 .5 0m6.693 7.3a.841.841 0 01.72-.131c-.13-.2.414 0 .5-.13 0-.066.5 0 .653 0m-.064 1.918a9.645 9.645 0 002.092-.414m1.025.72a12.626 12.626 0 00-2.594.348m-9.648-10.14c-.784-.066-.85.194-1.439.194"
				fill="none"
				stroke="#00b300"
				strokeWidth={0.173}
			/>
			<path
				d="M501.405 286.487a5.1 5.1 0 011.068.348c1.591.414 1.94 1.438 3.183 2.528a6.791 6.791 0 001.94 1.286 4.815 4.815 0 01.283.415 14.56 14.56 0 012.092 1.44q1.658 1.524 3.25 3.116c.13.131.2.5.348.654a11.029 11.029 0 002.594 2.028 17.206 17.206 0 012.31 1.438c2.094 0 4.121-.065 6.3-.13-.87-.5-1.59-1.068-2.527-1.5a9.343 9.343 0 01-2.312-1.875c-.13-.065-.2-.415-.349-.567q-1.449-1.44-2.964-2.812c-.567-.5-1.22-.85-1.875-1.374-.066 0-.195-.283-.283-.283a10.627 10.627 0 01-1.81-1.22c-1.067-1-1.439-1.875-2.9-2.312a13.141 13.141 0 01-3.554-1.656 2.516 2.516 0 00-.719-.5 2.974 2.974 0 00-2.463-.13 12.408 12.408 0 00-1.656 1.155"
				fill="#fc0"
			/>
			<path
				d="M501.405 286.487a5.1 5.1 0 011.068.348c1.591.414 1.94 1.438 3.183 2.528a6.791 6.791 0 001.94 1.286 4.815 4.815 0 01.283.415 14.56 14.56 0 012.092 1.44q1.658 1.524 3.25 3.116c.13.131.2.5.348.654a11.029 11.029 0 002.594 2.028 17.206 17.206 0 012.31 1.438c2.094 0 4.121-.065 6.3-.13-.87-.5-1.59-1.068-2.527-1.5a9.343 9.343 0 01-2.312-1.875c-.13-.065-.2-.415-.349-.567q-1.449-1.44-2.964-2.812c-.567-.5-1.22-.85-1.875-1.374-.066 0-.195-.283-.283-.283a10.627 10.627 0 01-1.81-1.22c-1.067-1-1.439-1.875-2.9-2.312a13.141 13.141 0 01-3.554-1.656 2.516 2.516 0 00-.719-.5 2.974 2.974 0 00-2.463-.13 12.408 12.408 0 00-1.656 1.155z"
				fill="none"
				stroke="#000"
				strokeWidth={0.347}
			/>
			<path
				d="M503.89 287.51c.065 0 .938-.13 1.068-.13m-.785.5c.5-.13.938 0 1.22-.2m-.783.633l.849-.131a.915.915 0 01.415-.066m-.829.546a9.581 9.581 0 011.5-.132m.3.35a11.5 11.5 0 00-1.439.195m.567.545a3.3 3.3 0 011.5-.2m.611.392c-.349 0-1.286.066-1.59.066m.5.458a5.6 5.6 0 001.592-.2m.567.545a10.025 10.025 0 00-1.352.064m.414.458a5.981 5.981 0 001.591-.13m.523.262a10.636 10.636 0 01-1.35.349m.7.457c.349-.195 1-.065 1.439-.195m.435.479a5.547 5.547 0 00-1.068.065c-.13 0-.2.13-.348.065m2.876.96a6.587 6.587 0 00-1.656.13m.5.61a10 10 0 011.874-.282m-.37 1.94c.13.065.567-.131.632-.131 1-.065 1.068-.283 2.027-.283m.48.413a11.1 11.1 0 01-2.4.284 1.55 1.55 0 00-.5.13m.479.393c.85-.13 2.093-.13 2.965-.2m.959.414c-.654.065-1.439 0-2.158.13-.282.067-.937.067-1.22.132m.849.61a.706.706 0 00.349-.065 5.637 5.637 0 012.812-.349m.611.414a18.625 18.625 0 00-2.094.13c-.414.066-1 .2-1.067.2m.632.458c.937-.131 2.812-.283 1.81-.2.937-.065 1.154-.065 2.18-.065m.217.414a3.535 3.535 0 00-1.657 0 7.636 7.636 0 01-1.874.284m.48.283a12.094 12.094 0 001.591-.2 6.786 6.786 0 011.656-.065m-2.594.567a9.617 9.617 0 012.028-.131c.349 0 .5-.066.85-.066m-18.051-12.3c.2-.065.131-.131.5-.131.283-.065.5.066.567-.065a1.337 1.337 0 01.349-.066m-2.071-.021c.282-.13.349-.284.719-.2.349-.065.5 0 .567-.13h.415m6.365 6.714c.195-.131.065-.2.5-.131-.13-.13.35 0 .415-.065a1.747 1.747 0 01.654-.066m-.044 1.788a12.226 12.226 0 001.876-.349m.937.633a9.224 9.224 0 00-2.159.283m-9.068-9.287a2.679 2.679 0 00-1.723.567"
				fill="none"
				stroke="#00b300"
				strokeWidth={0.173}
			/>
			<path
				d="M511.716 288.884a6.422 6.422 0 001 1.069 10.2 10.2 0 001.808 1.22c.067 0 .2.283.284.283.633.5 1.286.851 1.875 1.373 1 .939 1.94 1.81 2.965 2.813.131.131.2.5.348.567a9.4 9.4 0 002.312 1.875c.565.283 1.067.632 1.658.937h-.066c2.46 0 4.927 0 7.389-.065a14.952 14.952 0 00-2.026-1.222 9.092 9.092 0 01-1.876-1.5c-.133-.065-.133-.283-.284-.5-.781-.786-1.591-1.5-2.377-2.246a10.852 10.852 0 00-1.5-1.069c-.067-.065-.195-.195-.195-.282a5.763 5.763 0 01-1.506-.938c-.85-.785-1.068-1.591-2.246-1.874a8.571 8.571 0 01-2.9-1.374 2.859 2.859 0 00-.633-.414 2.7 2.7 0 00-1.94-.065 11.447 11.447 0 00-2.026 1.439"
				fill="#fc0"
			/>
			<path
				d="M511.716 288.884a6.422 6.422 0 001 1.069 10.2 10.2 0 001.808 1.22c.067 0 .2.283.284.283.633.5 1.286.851 1.875 1.373 1 .939 1.94 1.81 2.965 2.813.131.131.2.5.348.567a9.4 9.4 0 002.312 1.875c.565.283 1.067.632 1.658.937h-.066c2.46 0 4.927 0 7.389-.065a14.952 14.952 0 00-2.026-1.222 9.092 9.092 0 01-1.876-1.5c-.133-.065-.133-.283-.284-.5-.781-.786-1.591-1.5-2.377-2.246a10.852 10.852 0 00-1.5-1.069c-.067-.065-.195-.195-.195-.282a5.763 5.763 0 01-1.506-.938c-.85-.785-1.068-1.591-2.246-1.874a8.571 8.571 0 01-2.9-1.374 2.859 2.859 0 00-.633-.414 2.7 2.7 0 00-1.94-.065 11.447 11.447 0 00-2.026 1.439z"
				fill="none"
				stroke="#000"
				strokeWidth={0.347}
			/>
			<path
				d="M512.588 289.756c.065 0 1.069-.13 1.069-.13m-.786.348a5.155 5.155 0 001.156-.13m-.72.5l.785-.13c.065-.065.2 0 .349 0m-.85.414a4.846 4.846 0 011.374-.13m.239.282a2.858 2.858 0 00-1.068.131m.545.37a4.5 4.5 0 011-.13m.458.283c-.2 0-1 .066-1.221.066m.414.37a3.664 3.664 0 001.22-.195m.459.48h-1.07m.263.37a8.38 8.38 0 001.307-.066m.37.2a2.991 2.991 0 01-1.067.195m.348.393c.284-.131 1 0 1.286-.066m.437.285a3.948 3.948 0 00-.937.065h-.283m2.245.806a10.615 10.615 0 00-1.44.131m.5.37a9.225 9.225 0 011.5-.2m-.5 1.44a2.669 2.669 0 00.72 0c.719-.066.85-.283 1.5-.2m.393.327c-.785.065-1.156.13-1.81.13-.065 0-.348.066-.5.066m.35.327c.632-.13 1.809-.065 2.46-.13m.681.348c-.5.065-1.158 0-1.66.065-.349.066-1 .132-1 .132m.48.458c.13 0 .72-.132.72-.132.85-.065 1.156-.13 1.96-.2m.5.327a11.483 11.483 0 00-1.657.13 7.422 7.422 0 00-1.067.2m.61.393c.568-.132 2.159-.284 1.506-.284a13.2 13.2 0 001.59-.065m.263.349a4.217 4.217 0 00-1.29 0 5.666 5.666 0 01-1.524.195m.413.24a7.035 7.035 0 001.223-.13 4.374 4.374 0 011.284-.066m-2.071.48a4.753 4.753 0 011.724-.13 2.621 2.621 0 00.631-.066m-14.037-9.374c.2-.066.282-.2.566-.131.195-.065.348 0 .348-.065.066-.066.2-.066.35-.066m-1.626-.038c.2-.066.282-.2.566-.2H513c0-.065.2-.065.283-.065m4.73 5.123a1.218 1.218 0 01.568-.067c-.13-.065.282 0 .349-.065h.414m.065 1.374a4.981 4.981 0 001.44-.284m.74.5a7.71 7.71 0 00-1.809.195m-6.91-7.084c-.5-.066-.633.13-1 .348"
				fill="none"
				stroke="#00b300"
				strokeWidth={0.173}
			/>
			<path
				d="M530.878 298.76a8.662 8.662 0 00-1.506-.938 9.286 9.286 0 01-1.876-1.5c-.128-.065-.128-.284-.278-.5-.787-.785-1.59-1.5-2.377-2.245a10.827 10.827 0 00-1.508-1.068c-.061-.065-.195-.2-.195-.283a5.787 5.787 0 01-1.5-.938c-.719-.72-1-1.285-1.81-1.722h.066a6.891 6.891 0 011.22-.785 2.177 2.177 0 011.725.065c.062.067.28.2.5.35a6.193 6.193 0 002.467 1.154c.938.284 1.155.938 1.937 1.592a4.744 4.744 0 001.222.85c.067 0 .134.2.2.2a7.73 7.73 0 011.29.938c.72.633 1.373 1.285 2.026 1.94.133.13.133.349.284.414a8.586 8.586 0 001.59 1.22c.631.35 1.155.722 1.724 1.07-1.724.065-3.465.065-5.212.065v.065"
				fill="#fc0"
			/>
			<path
				d="M530.878 298.76a8.662 8.662 0 00-1.506-.938 9.286 9.286 0 01-1.876-1.5c-.128-.065-.128-.284-.278-.5-.787-.785-1.59-1.5-2.377-2.245a10.827 10.827 0 00-1.508-1.068c-.061-.065-.195-.2-.195-.283a5.787 5.787 0 01-1.5-.938c-.719-.72-1-1.285-1.81-1.722h.066a6.891 6.891 0 011.22-.785 2.177 2.177 0 011.725.065c.062.067.28.2.5.35a6.193 6.193 0 002.467 1.154c.938.284 1.155.938 1.937 1.592a4.744 4.744 0 001.222.85c.067 0 .134.2.2.2a7.73 7.73 0 011.29.938c.72.633 1.373 1.285 2.026 1.94.133.13.133.349.284.414a8.586 8.586 0 001.59 1.22c.631.35 1.155.722 1.724 1.07-1.724.065-3.465.065-5.212.065v.065z"
				fill="none"
				stroke="#000"
				strokeWidth={0.347}
			/>
			<path
				d="M520.5 290.126c.066 0 .937-.13 1-.13m-.72.414c.284-.066.85-.066 1-.2m-.719.413l.85-.13h.283m-.7.566a5.853 5.853 0 011.157-.2m.305.195a3.818 3.818 0 00-1.22.2m.478.306a2.608 2.608 0 011.072-.132m.48.284a4.2 4.2 0 00-1.224.13m.414.241a3.353 3.353 0 001.155-.2m.435.415a11.175 11.175 0 00-1.222.13m.5.306a3.654 3.654 0 001.221-.132m.308.2a6.984 6.984 0 01-1.155.2m.563.391c.134-.13.854-.065 1.155-.13m.374.262a3.242 3.242 0 00-.854.065c-.062.065-.279.065-.346.065m2.137.676a7.729 7.729 0 00-1.289.131m.352.37a9.1 9.1 0 011.5-.2m-.48 1.374c.068 0 .57-.065.636-.065a5.826 5.826 0 011.435-.132m.307.262c-.72.13-1.066.13-1.658.2h-.413m.263.393c.563-.066 1.657-.13 2.243-.2m.743.326a12.293 12.293 0 00-1.591.066 5.8 5.8 0 00-.938.131m.48.392c.061 0 .63-.13.63-.13.721-.066 1.006-.131 1.81-.2m.479.327a9.994 9.994 0 00-1.5.065c-.353.066-.855.283-1.006.283m.547.284a7.545 7.545 0 011.435-.2 9.6 9.6 0 011.44-.065m.239.26a2.581 2.581 0 00-1.222 0 4.875 4.875 0 01-1.373.2m.352.174a3.4 3.4 0 001.155-.13 7.42 7.42 0 011.222 0m-2.032.435a11.794 11.794 0 011.658-.13h.57m-12.951-8.743a1 1 0 01.5-.13h.436a.7.7 0 01.282-.066m-1.525 0c.2-.13.2-.2.5-.13.195-.066.348 0 .414-.066a.7.7 0 01.283-.066m4.316 4.753a1.135 1.135 0 01.5-.065c-.067-.131.285 0 .346-.066h.441m-.134 1.221a9.861 9.861 0 001.44-.2m.742.415a8.36 8.36 0 00-1.875.13m-6.17-6.518c-.5-.065-.633.13-.938.349"
				fill="none"
				stroke="#00b300"
				strokeWidth={0.173}
			/>
			<path
				d="M514.5 299.651a2.1 2.1 0 00-1.161-.287l-.906-.031.893-.062c.974-.069 1.025-.11.628-.507-.235-.234-.5-.244-2.2-.071a10.429 10.429 0 01-2.244.07c-.375-.15.737-.356 2.026-.376.487-.008.808-.09.808-.207 0-.2-2.291-.1-3.234.134-.34.086-.386.063-.222-.111a3.638 3.638 0 011.49-.3c1.375-.088 1.76-.362.562-.4-.4-.013-.552-.057-.341-.1.737-.142.386-.4-.425-.316-2.319.245-3.015.272-2.767.1a2.482 2.482 0 011.022-.178c.9 0 1.531-.152 1.531-.356 0-.08-.21-.113-.467-.073s-1 .112-1.66.16c-1.374.1-1.03-.132.468-.316 1.342-.166 1.269-.477-.085-.366l-1.064.086.809-.182c.445-.1.808-.25.808-.334 0-.189.03-.19-1.66.084-1.183.192-1.4.192-1.4 0 0-.165.244-.232.838-.232.887 0 1.42-.131 1.3-.321a3.526 3.526 0 00-1.233-.008c-1.264.116-1.858-.078-.792-.257.708-.12 1.208-.36 1.06-.509a1.283 1.283 0 00-.674.076c-.753.216-1.523.214-1.523 0 0-.093.25-.171.554-.172.536 0 1.137-.244.974-.393a3.611 3.611 0 00-1.017.057 2.32 2.32 0 01-1.1-.022c-.1-.088.166-.15.64-.15 1.188 0 .968-.315-.265-.38l-1.064-.056.723-.144c1.057-.212.905-.49-.192-.351-.6.074-.954.049-1.031-.074s.093-.187.49-.187c.964 0 .7-.337-.288-.37-.735-.023-.78-.04-.255-.095.35-.036.638-.149.638-.25 0-.12-.292-.15-.846-.083-.923.11-1.335-.119-.513-.283.52-.1.714-.451.253-.451-.14 0-.256-.085-.256-.19 0-.127-.245-.152-.75-.077-.462.07-.794.044-.862-.066s.092-.178.411-.178c.752 0 .643-.336-.118-.36-.35-.01-.5-.055-.338-.1.546-.143.142-.352-.6-.309-.4.024-.516.01-.258-.032.722-.114.553-.39-.255-.419-.509-.017-.585-.045-.256-.1.257-.04.468-.153.468-.253 0-.117-.263-.146-.727-.082a1.99 1.99 0 01-.979-.06c-.182-.116-.076-.16.387-.161.35 0 .638-.047.638-.1 0-.3-.58-.587-1.222-.608-.4-.012-.563-.056-.352-.1.471-.09.508-.39.047-.39-.243 0-.3-.078-.226-.285s.041-.258-.175-.175c-.158.06-.284.027-.284-.073s-.27-.157-.682-.118c-.374.036-.68 0-.68-.069s.172-.132.383-.133a1.4 1.4 0 00.623-.156c.2-.127.195-.2-.049-.44-.227-.227-.454-.265-1.049-.176-.494.074-.76.051-.76-.067 0-.1.268-.18.6-.18.8 0 .762-.3-.043-.38l-.638-.06.808-.384c1.163-.552 2.127-.337 3.75.84a15.515 15.515 0 002.57 1.214 6.969 6.969 0 013.225 2 23.333 23.333 0 002.083 1.789 29.261 29.261 0 014.944 4.03 23.445 23.445 0 011.617 1.765 12.975 12.975 0 003.191 2.528 11.732 11.732 0 011.387.89 9.012 9.012 0 01-1.605.072c-1.2 0-1.669-.065-1.86-.256z"
				fill="#090"
			/>
			<path
				d="M521.309 299.14a1.808 1.808 0 01-.373-.621c-.112-.354-.177-.36-2.265-.27-1.2.054-1.962.035-1.726-.042a6.563 6.563 0 011.4-.156c.614-.01.98-.09.98-.212 0-.14-.448-.17-1.575-.1-.887.053-1.39.034-1.15-.043a5.632 5.632 0 011.235-.154c.444-.01.808-.093.808-.187s-.115-.17-.255-.17-.255-.077-.255-.17-.517-.184-1.15-.2c-.7-.017-.9-.054-.51-.095.35-.036.638-.137.638-.224a3.73 3.73 0 00-1.574-.074c-1.776.1-1.825-.006-.085-.174 1.182-.115 1.578-.41.6-.444-.3-.011-.419-.055-.255-.1.493-.128.337-.428-.17-.328-1.29.253-2.052.3-2.16.12-.078-.125.161-.185.735-.185a1.725 1.725 0 00.965-.183c.077-.124-.246-.17-1.013-.142-1.29.047-1.626-.09-.618-.25.378-.06.687-.185.687-.279 0-.2-.227-.206-1.065-.011-.352.081-.677.087-.722.015s.261-.185.682-.248.764-.187.764-.277c0-.143-1.066-.076-1.654.1a.281.281 0 01-.308-.1c-.057-.092.162-.163.5-.163.97 0 .7-.338-.288-.357-.869-.017-.878-.023-.341-.195.825-.265.67-.467-.275-.355-.529.063-.87.03-.945-.093s.082-.191.487-.191c.7 0 .834-.334.138-.354-.257-.008-.372-.052-.255-.1.488-.2.156-.35-.58-.266-.569.064-.757.034-.67-.106a.581.581 0 01.45-.2c.183 0 .332-.077.332-.17s-.116-.171-.256-.171-.256-.073-.256-.162-.363-.137-.808-.107-.6.023-.341-.018c.723-.115.554-.391-.254-.417-.4-.013-.552-.056-.341-.1.426-.08.528-.39.127-.39-.14 0-.255-.076-.255-.17s-.248-.18-.553-.19-.42-.054-.255-.1c.629-.165.259-.383-.51-.3-.679.073-.741.057-.39-.1a2.828 2.828 0 00.488-.252c.124-.124-.45-.6-.725-.6-.147 0-.268-.078-.268-.17s-.114-.171-.255-.171-.236-.1-.213-.213-.088-.19-.253-.163c-.188.031-.263-.033-.207-.18.066-.17-.077-.218-.556-.188-.367.023-.46 0-.218-.048.667-.138.82-.4.246-.42-.286-.01-.374-.053-.2-.1.364-.1.4-.394.043-.394-.14 0-.255-.077-.255-.17s-.288-.173-.639-.176c-.6 0-.617-.021-.307-.255a2.323 2.323 0 012.323.17 32.609 32.609 0 004.058 1.974 5.889 5.889 0 012.213 1.5 16.621 16.621 0 001.8 1.532c1.993 1.307 3.452 2.593 6.939 6.113a11.279 11.279 0 002.125 1.586 8.681 8.681 0 011.235.76 4.192 4.192 0 01-1.094.073c-.748 0-1.176-.082-1.351-.257zm4.829-.608c0-.348-.49-.668-1.02-.668-.312 0-.49-.07-.428-.17s-.019-.171-.17-.171-.229-.076-.17-.17-.058-.17-.255-.17-.314-.077-.256-.17-.087-.17-.34-.17-.4-.074-.341-.17-.16-.18-.543-.194-.5-.052-.265-.1c.427-.082.527-.39.127-.39-.14 0-.255-.076-.255-.17s-.115-.17-.255-.17-.256-.076-.256-.17-.234-.17-.52-.17c-.307 0-.478-.071-.415-.172.119-.192-.3-.68-.585-.68a.177.177 0 01-.182-.17c0-.094-.158-.17-.35-.17s-.3-.077-.246-.17-.216-.181-.713-.2c-.62-.02-.685-.044-.265-.095.545-.069.792-.388.3-.388-.14 0-.255-.062-.255-.137s-.288-.112-.638-.082c-.556.045-.587.029-.243-.12s.368-.2.14-.427a.848.848 0 00-.438-.255.179.179 0 01-.183-.17.183.183 0 00-.192-.171.982.982 0 01-.494-.346 2.2 2.2 0 00-1.041-.493c-.408-.08-.607-.154-.443-.163.408-.026.376-.37-.042-.48-.188-.05-.341-.166-.341-.259s-.27-.137-.6-.1a1.272 1.272 0 01-1.15-.4l-.548-.471.457-.007c.579-.009.774-.3.388-.585-.268-.2-.238-.252.334-.6a2.608 2.608 0 012.957.288 10.343 10.343 0 002.038 1 4.835 4.835 0 012.167 1.342 24.389 24.389 0 002.553 2.077 29.988 29.988 0 013.522 3.09 17.6 17.6 0 002.469 2.223c1.283.678 1.265.691-.926.693-1.371 0-2.085-.059-2.085-.18zm6.819-.562c-.2-.367-.314-.4-1.263-.361-.576.023-.8.01-.493-.032s.553-.113.553-.161c0-.223-.541-.589-1.012-.682-.286-.058-.52-.172-.52-.253s-.11-.15-.243-.15-.293-.152-.353-.34a.5.5 0 00-.436-.34c-.182 0-.33-.076-.33-.17s-.25-.171-.553-.173c-.392 0-.483-.047-.313-.155.2-.129.2-.193-.03-.423a.9.9 0 00-.453-.27.178.178 0 01-.183-.171c0-.094-.115-.17-.255-.17s-.256-.077-.256-.17a.2.2 0 00-.217-.17.784.784 0 01-.463-.342.825.825 0 00-.559-.34c-.186 0-.266-.076-.195-.189.167-.272-.277-.493-.777-.385-.325.07-.367.05-.177-.083.211-.147.188-.228-.154-.524a1.534 1.534 0 00-.555-.351 1.612 1.612 0 01-.578-.425 1.558 1.558 0 00-.6-.425 2.567 2.567 0 01-1.007-.941 1.023 1.023 0 00-.274-.38c-.254-.254-.245-.286.1-.413a2.241 2.241 0 011.962.545 9.984 9.984 0 001.778.86 4.9 4.9 0 011.899 1.192 13.987 13.987 0 001.8 1.45 26.112 26.112 0 012.825 2.439 23.56 23.56 0 002.724 2.341l.9.559h-1.036c-.917 0-1.06-.041-1.251-.4z"
				fill="#090"
			/>
			<path
				d="M492.488 272.643l.132.349-1.657.633.2.631-.2.065c-.131-.348-.284-.5-.72-.414l-.13-.282 2.376-1m-1.81-.72a.464.464 0 01-.283-.413c-.066-.414.066-.938.567-1 .283-.13.937-.13 1.155.721a.8.8 0 01-.5.937l-.13-.349c.348-.065.414-.283.348-.567a.581.581 0 00-.72-.414.557.557 0 00-.414.72c0 .13.132.283.35.348l.065.284-1.438.13-.284-1.286.283-.065.284 1.068.72-.066m-.72-4.752a.563.563 0 00-.567.557v.01c0 .2 0 .633.414.633.2 0 .283-.13.349-.284l.2-.72a.594.594 0 01.72-.5c.632 0 .785.566.719 1.067a.964.964 0 01-.283.72.682.682 0 01-.72.195l.065-.283c.414 0 .567-.348.633-.718a.583.583 0 00-.35-.72c-.282 0-.348.065-.5.5l-.2.567a.624.624 0 01-.632.5.823.823 0 01-.719-1c.066-.85.566-.938.85-.938v.35m2.616-2.4l-.567 1.875-2.529-.85.567-1.81.35.131-.5 1.439.72.2.5-1.374.284.132-.5 1.373.85.283.5-1.5.283.065m.415-.545l-.2.284-2.246-1.354.632-1a.687.687 0 011-.284.7.7 0 01.282 1.066l-.413.72.938.567m-1.025-3.335l1.5-1.5.2.195-.632.63 1.656 1.59-.194.286-1.658-1.658-.633.631-.195-.2m3.88.023l-.283.195-1.5-2.16.2-.128 1.59 2.093M498 259.5l-1.722.938-1.22-2.4 1.744-.848.131.278-1.373.721.348.72 1.286-.631.13.284-1.285.63.414.788 1.373-.72.13.195m2.443-.524l-.283-1.5c0-.067-.066-.35-.13-.636l-.2 2.311-.348.133-1.221-2.03a5.6 5.6 0 01.13.568l.35 1.591h-.35l-.566-2.528.5-.067 1.22 2.031.284-2.377.5-.134.5 2.6-.348.067m.894-2.7h1.069c.5.061.784.346.719.72a.6.6 0 01-.349.564c.13.067.5.194.414.63a.7.7 0 01-.85.72l-1.156-.062.132-2.6m2.572 2.919l-.283-.066.631-2.59 1.221.413c.415.067.785.346.633.848-.131.413-.35.413-.5.5.065.067.194.194.065.568l-.065.413c0 .195 0 .195.065.285v.061l-.414-.127c-.065-.135.065-.5.13-.632a.473.473 0 00-.348-.568l-.85-.195-.283 1.087m3.77 1.658l-1.722-1 1.286-2.244 1.744.937-.2.285-1.286-.787-.415.72 1.222.72-.132.285-1.275-.722-.348.72 1.286.782-.066.284m2.877-.847l.633.78a1.078 1.078 0 01-.2 1.658c-.5.413-1.221.72-1.81.067l-.632-.848 2.027-1.658m.415 5.448l-.872-1.72 2.311-1.222.85 1.722-.283.13-.633-1.372-.784.346.719 1.288-.283.131-.633-1.286-.784.347.72 1.442-.285.13m.393 2.31v-.349l1.809-.2-.13-.567.282-.065c.132.414.132.567.568.567l.065.283-2.594.35m1.46 2.157a.627.627 0 01-.654.414c-.414 0-.784-.282-.784-.937a1.27 1.27 0 01.195-.567.814.814 0 01.655-.283.823.823 0 01.633.5c.064-.2.195-.282.5-.282.283 0 .633.13.633.784 0 .567-.349.784-.72.719-.349 0-.414-.195-.5-.349m.174.938a.822.822 0 01.719 1.068.838.838 0 01-.938.633c-.414-.131-.567-.415-.719-.938l-.065-.284c-.066-.348-.2-.5-.35-.5l-.347 1.352-.285-.066.415-1.723a.993.993 0 01.871.85l.132.35c.065.283.13.5.5.567.132.065.415 0 .5-.35.132-.5-.282-.566-.414-.653v-.351m-2.55 2.6l.13-.284 1.656.785.2-.567.284.066c-.2.414-.2.567.13.85l-.13.195-2.311-1.068"
				fill="#e60000"
			/>
			<path
				d="M491.681 263.268l.284-.5c.2-.286.2-.5-.065-.637-.2-.195-.414-.062-.567.134l-.349.563.72.42m9.92-5.844h.631c.283 0 .414-.067.5-.35 0-.286-.132-.347-.5-.347l-.567-.068-.065.787"
				fill="#ffd1c5"
			/>
			<path
				d="M501.624 258.562h.631c.349 0 .567-.134.567-.35 0-.347-.284-.414-.567-.414l-.632-.068v.855"
				fill="#ffe6d9"
			/>
			<path
				d="M504.39 257.754l.721.195c.195 0 .5.067.566-.28a.388.388 0 00-.282-.5l-.785-.194-.2.78m4.752 3.99l.348.413c.283.352.72.352 1.221-.061.414-.351.5-.786.2-1.072l-.414-.5-1.374 1.222m3.227 7.129c-.2 0-.5.065-.5.414 0 .2 0 .5.414.5.283 0 .435-.13.435-.414.067-.35-.13-.5-.348-.5m1.155.937a.317.317 0 00.283-.349c.067-.348-.13-.414-.283-.414a.383.383 0 100 .763"
				fill="#ffd1c5"
			/>
			<path
				d="M501.624 335.538c1.5 0 3.116 0 9.852-1.658 6.737-1.59 12.337-5.715 13.626-6.3a8.106 8.106 0 013.248-.413 8.4 8.4 0 00-5.713-2.685c-2.964 0-1.721 0-4.272 1.071-2.464 1-7.674 4.2-16.459 4.2h-.13c-8.851 0-14.28-3.182-16.83-4.2-2.442-1.071-1.373-1.071-4.274-1.071a8.15 8.15 0 00-5.711 2.685 8.732 8.732 0 013.27.413c1.286.563 6.89 4.71 13.626 6.3 6.735 1.658 8.415 1.658 9.787 1.658"
				fill="#fff"
			/>
			<path
				d="M501.624 335.538c1.5 0 3.116 0 9.852-1.658 6.737-1.59 12.337-5.715 13.626-6.3a8.106 8.106 0 013.248-.413 8.4 8.4 0 00-5.713-2.685c-2.964 0-1.721 0-4.272 1.071-2.464 1-7.674 4.2-16.459 4.2h-.13c-8.851 0-14.28-3.182-16.83-4.2-2.442-1.071-1.373-1.071-4.274-1.071a8.15 8.15 0 00-5.711 2.685 8.732 8.732 0 013.27.413c1.286.563 6.89 4.71 13.626 6.3 6.735 1.658 8.415 1.658 9.787 1.658z"
				fill="none"
				stroke="#000"
				strokeWidth={0.406}
			/>
			<path
				d="M475.66 329.74c.718-.352-.132-1.6-.132-1.6l2.682-.563a8.233 8.233 0 00-3.27-.413c-.5.413-.414.937-.5 1.283a1.719 1.719 0 00.195 1.29c.284.194 1 0 1 0"
				fill="#fff"
			/>
			<path
				d="M475.66 329.74c.718-.352-.132-1.6-.132-1.6l2.682-.563a8.233 8.233 0 00-3.27-.413c-.5.413-.414.937-.5 1.283a1.719 1.719 0 00.195 1.29c.284.194 1 0 1 0z"
				fill="none"
				stroke="#000"
				strokeWidth={0.406}
			/>
			<path
				d="M478.187 327.557l-2.68.563s.85 1.223.13 1.6l4.71-.854a25.078 25.078 0 00-2.16-1.283"
				fill="#fff"
			/>
			<path
				d="M478.187 327.557l-2.68.563s.85 1.223.13 1.6l4.71-.854a25.078 25.078 0 00-2.16-1.283z"
				fill="none"
				stroke="#000"
				strokeWidth={0.406}
			/>
			<path
				d="M527.675 329.74c-.72-.352.128-1.6.128-1.6l-2.679-.563a8.115 8.115 0 013.25-.413c.5.413.412.937.5 1.283a1.733 1.733 0 01-.2 1.29c-.28.194-1 0-1 0"
				fill="#fff"
			/>
			<path
				d="M527.675 329.74c-.72-.352.128-1.6.128-1.6l-2.679-.563a8.115 8.115 0 013.25-.413c.5.413.412.937.5 1.283a1.733 1.733 0 01-.2 1.29c-.28.194-1 0-1 0"
				fill="none"
				stroke="#000"
				strokeWidth={0.406}
			/>
			<path
				d="M525.147 327.557l2.679.563s-.848 1.223-.129 1.6l-4.71-.854s.721-.5 2.16-1.283"
				fill="#fff"
			/>
			<path
				d="M525.147 327.557l2.679.563s-.848 1.223-.129 1.6l-4.71-.854s.721-.5 2.16-1.283z"
				fill="none"
				stroke="#000"
				strokeWidth={0.406}
			/>
			<path d="M482.984 325.75l.567.194a1.6 1.6 0 11-1.243 2.941l-.567-.195 1.22-2.963m1.7 4.23l-.35-.134 1.287-2.9.349.061-1.286 2.97m3.989 0a1.552 1.552 0 01-2.094.847 1.573 1.573 0 01-.784-2.091 1.606 1.606 0 012.093-.938 1.648 1.648 0 01.785 2.16m2.092-.263c-.065-.2-.13-.351-.348-.413-.2-.067-.5 0-.567.195a.493.493 0 00.131.565l.2.195c.349.284.567.569.349 1.071a.952.952 0 01-1.22.63 1.06 1.06 0 01-.568-1.222l.349.067a.626.626 0 00.349.787.554.554 0 00.72-.351c.13-.346-.067-.564-.284-.782l-.131-.134a.833.833 0 01-.283-.937.794.794 0 011.068-.5.834.834 0 01.567.721l-.35.066m2.355.174l-.5 1.808c-.13.5-.13 1 .414 1.16.567.195.85-.2 1-.72l.5-1.813.35.066-.567 1.943a1.058 1.058 0 01-1.374.847 1 1 0 01-.719-1.438l.5-1.937.349.061m2.354.547l1.722 2.9.414-2.317.35.067-.568 3.248-1.809-2.9-.414 2.31-.349-.066.633-3.248m3.138 3.9l-.348-.06.348-3.12h.35l-.35 3.181m3.86-1.373a1.555 1.555 0 01-1.593 1.59 1.539 1.539 0 01-1.525-1.718 1.49 1.49 0 011.59-1.507 1.547 1.547 0 011.506 1.657m.37-1.763l2.464 2.243-.219-2.31h.414l.2 3.248-2.441-2.244.2 2.31h-.414l-.2-3.247m5.232 2.333l.85-.134.13.351-1.286.2-.653-3.12.414-.06.5 2.746m1.788.022l-.349.061-.72-3.03.35-.129.719 3.12m-.153-3.23l.349-.13c.567-.128 1.068-.128 1.286.57a.754.754 0 01-.131.63.7.7 0 01.785.565.966.966 0 01-.785 1.154l-.653.2-.851-3.029m2.115-.614l1.59-.563.066.345-1.155.413.283.854 1.156-.42.066.353-1.07.346.35 1.16 1.134-.418.13.352-1.5.5-1.069-2.97m5.015 1.575l-.436.129-1.286-.849-.131.061.414 1.223-.283.133-1.226-2.966.414-.127a1.768 1.768 0 01.786-.2.972.972 0 01.632.563.838.838 0 01-.349 1.071l1.439.938m1.264-.547l-.348.195-1.156-2.6-.633.284-.13-.284 1.591-.72.2.284-.72.286 1.22 2.528m1.07-1.374l.065.849-.349.2-.2-3.622 2.747 2.244-.284.2-.72-.57-1.22.63m.959-3.18l.5-.285a1.575 1.575 0 012.312.5 1.6 1.6 0 01-.72 2.244l-.5.284-1.592-2.746" />
			<path
				d="M482.33 328.427h.131a1.047 1.047 0 001.59-.5c.35-.782-.064-1.218-.783-1.5l-.066-.067-.872 2.093m5.864 1.29a1.152 1.152 0 00-.567-1.508 1.07 1.07 0 00-1.374.63 1.122 1.122 0 00.5 1.508 1.085 1.085 0 001.439-.653m13.647 3.136a1.083 1.083 0 00-1-1.222 1.193 1.193 0 00-1.156 1.156 1.234 1.234 0 001.091 1.221 1.12 1.12 0 001.068-1.155m8.5-1.44l.066-.061c.283-.067.567-.134.436-.57-.13-.412-.349-.412-.72-.284h-.065l.283.937m8.546-4.012l.065 1.29.85-.5-.937-.787m2.856.57h.065a1.18 1.18 0 00.633-1.658 1.154 1.154 0 00-1.722-.285l-.13.067 1.154 1.876m-11.03 4.794l.282-.062c.284-.134.568-.285.416-.637-.067-.412-.5-.346-.786-.279h-.131l.2 1m3.945-2.79h.065c.35-.129.72-.346.5-.781-.13-.351-.567-.285-.85-.2l-.066.061.35.937"
				fill="#fff"
			/>
		</svg>
	)
}

export default SvgSv
